import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  nl: {
    app_name: "CampAd Pro",
    admin_camping: "Camping",
    admin_camping_desc: "Gegevens van de camping",
    admin_map: "Plattegrond",
    admin_map_desc: "Kaart en plaatsen",
    admin_stock: "Voorraad",
    admin_stock_desc: "Artikelen en leveringen",
    articles: "Artikelen",
    new_article: "Nieuw artikel",
    art_code: "Code",
    art_name: "Naam",
    art_category: "Categorie",
    art_unit: "Eenheid",
    art_stock: "Voorraad",
    art_min_stock: "Minimumvoorraad",
    art_track_stock: "Voorraad bijhouden",
    art_lines: "Lijnen",
    unit_stuk: "stuk",
    unit_liter: "liter",
    unit_kg: "kg",
    unit_meter: "meter",
    unit_pak: "pak",
    unit_uur: "uur",
    unit_dienst: "dienst",
    excl_vat: "excl. BTW",
    price_incl_vat: "Totaal incl. BTW",
    bill_to: "Facturatiegegevens",
    billing_details: "Facturatiegegevens",
    articles_lines: "Artikelen",
    print_invoice: "Factuur afdrukken",
    printed: "Afgedrukt",
    not_printed: "Niet afgedrukt",
    sale_open_title: "Verkoop nog niet afgewerkt:",
    sale_open_hint: "druk eerst de factuur af of annuleer de verkoop voor u een nieuwe start.",
    cancel_sale: "Verkoop annuleren",
    art_price: "Prijs",
    art_vat: "BTW %",
    art_qty: "Aantal",
    rental_report: "Opbrengst verhuur per maand",
    rental_report_empty: "Nog geen verhuur in dit jaar.",
    rental_times_out: "verhuurd",
    deposits_cash: "Waarborg in kas",
    cash_expected: "Verwacht in kas",
    nav_verhuur: "Verhuur",
    rental_out_today: "Vandaag mee te geven",
    rental_back_today: "Vandaag terug verwacht",
    rental_out_now: "Momenteel uit",
    rental_overdue: "Te laat terug",
    rental_deposit_todo: "Waarborg nog te ontvangen",
    rental_deposit_open: "Waarborg openstaand",
    deposit: "Voorschot",
    deposit_paid: "Voorschot betaald",
    deposit_open: "Voorschot openstaand",
    deposit_resend: "Betaallink opnieuw mailen",
    deposit_resend_q: "Betaallink opnieuw versturen?",
    deposit_resend_hint: "We sturen {name} opnieuw een e-mail met de Stripe-betaallink voor het voorschot van {amount}.",
    deposit_resend_sent: "Betaallink opnieuw verstuurd naar",
    amount_due: "Nog te betalen",
    admin_prepayments: "Voorschotten",
    admin_prepayments_desc: "Overzicht van online ontvangen voorschotten per periode voor de boekhouding.",
    deposit_settled: "Verrekend",
    deposit_unsettled: "Nog te verrekenen",
    by_month: "Per maand",
    by_week: "Per week",
    no_deposits_year: "Geen voorschotten in dit jaar.",
    per_year: "Per jaar",
    per_quarter: "Kwartaal",
    custom_range: "Aangepast",
    pick_range_hint: "Kies een van- en tot-datum om het rapport te tonen.",
    vat_breakdown: "Uitsplitsing per aangifteperiode",
    btw: "Btw",
    drilldown_hint: "Klik om de onderliggende voorschotten te tonen",
    showing: "Getoond",
    show_all: "Toon alles",
    yes: "Ja",
    no: "Nee",
    deposit_received: "Waarborg ontvangen",
    deposit_refund: "Terugbetaald",
    deposit_refunded: "waarborg terugbetaald",
    admin_revenue: "Omzet per maand",
    admin_revenue_desc: "Standplaatsen, toeristenbelasting, verhuur en winkel samen per maand. Facturen van vóór deze versie staan onder 'Overige'.",
    rev_pitch: "Standplaatsen", rev_tax: "Toeristenbelasting", rev_rental: "Verhuur", rev_shop: "Winkel", rev_other: "Overige", rev_total: "Totaal",
    deposit_receipt: "Waarborgbewijs",
    admin_rentals: "Verhuur",
    admin_rentals_desc: "Artikelen die je verhuurt (ijskast, kinderbed…) met hun prijs, waarborg en omschrijving in alle talen.",
    admin_tariffs: "Tarieven",
    group_daily: "Dagelijks",
    group_billing: "Boekhouding",
    group_manage: "Beheer",
    collapse: "Inklappen",
    theme_dark: "Donkere modus",
    theme_light: "Lichte modus",
    theme_auto_hint: "Avonddienst: volgt automatisch de zonsondergang van de camping",
    kpi_arrivals: "Aankomsten",
    kpi_overdue: "te laat",
    kpi_departures: "Vertrekkend",
    kpi_open_invoices: "Openstaande facturen",
    kpi_late_rentals: "Laattijdige verhuur",
    kpi_stock: "Voorraad",
    extend_stay: "Verlengen",
    extend_other_date: "Andere vertrekdatum",
    extend_ok: "Verblijf verlengd tot",
    day: "dag",
    days: "dagen",
    kpi_stock_negative: "artikelen negatief",
    ai_translate: "Vertaal met AI",
    art_names: "Naam in andere talen (voor bon en factuur van de gast)",
    art_names_hint: "Merknamen, volumes en maten blijven ongewijzigd. Leeg laten? Dan wordt automatisch de Nederlandse naam gebruikt.",
    art_translate_all: "Alle vertalingen aanvullen",
    ai_translating: "Bezig…",
    ai_translated: "Vertalingen ingevuld",
    twofa_sent: "Code verstuurd naar",
    twofa_sub: "Vul de code in die we per sms stuurden naar",
    twofa_code: "Sms-code (6 cijfers)",
    twofa_confirm: "Bevestigen",
    twofa_resend: "Code opnieuw versturen",
    t_twofa: "Tweestapsverificatie via sms",
    t_twofa_short: "2FA",
    t_twofa_on: "Aan",
    t_twofa_hint: "Beheerders van deze camping krijgen bij het aanmelden een code per sms. Het nummer komt uit hun gebruikersfiche (met landcode, bv. +34 612 345 678).",
    t_turnstile: "Cloudflare-verificatie (anti-bot)",
    t_turnstile_short: "Bot-check",
    t_turnstile_hint: "Bezoekers lossen bij het aanmelden en op de publieke formulieren een korte, meestal onzichtbare Cloudflare-controle op. Staat standaard aan; enkel de hoofdbeheerder kan dit wijzigen.",
    t_demo_short: "Demo",
    t_demo: "Demo toestaan voor deze camping",
    t_demo_hint: "Laat deze camping demo-mode gebruiken (dummy-data). Enkel de hoofdbeheerder kan dit toestaan. Staat dit uit, dan ziet de camping niets van de demo-functies. 'Ja' wordt rood getoond omdat demo niet bedoeld is voor echt gebruik.",
    flag_confirm: "'{flag}' {state} voor {name}?",
    flag_on: "aanzetten",
    flag_off: "uitzetten",
    user_phone_hint: "Met landcode, bv. +34 612 345 678 — hierop komt de sms-code bij tweestapsverificatie.",
    admin_tariffs_desc: "Basistarief per zone, periodetarieven, prijs per item en pakketten.",
    tariff_base: "Basistarieven per zone",
    tariff_base_desc: "Dit tarief geldt telkens er geen periodetarief voor die datum bestaat.",
    tariff_periods: "Periodetarieven",
    tariff_periods_desc: "Tarief voor een bepaalde periode. Laat de zone leeg om het voor alle zones te laten gelden.",
    tariff_items: "Tarief per item",
    tariff_items_desc: "Prijs per item uit het incheckformulier en de kaartafdruk. Eigen items kan je zelf toevoegen.",
    tariff_packages: "Pakketten",
    tariff_packages_desc: "Combineer items in één pakket, bv. 1 caravan + 2 personen + hond.",
    tariff_price_night: "Prijs",
    tariff_tourist_tax: "Toeristenbelasting",
    tariff_children_free: "Kinderen vrijgesteld",
    tariff_default: "standaard",
    tariff_period_name: "Naam",
    tariff_from: "Van",
    tariff_to: "Tot",
    tariff_all_zones: "Alle zones",
    tariff_pct: "% op basistarief",
    tariff_apply_pct: "Bereken",
    tariff_pct_hint: "Bereken de prijzen als % op het basistarief. Daarna blijft elk bedrag vrij aanpasbaar.",
    tariff_overrides: "Itemtarieven voor deze periode",
    tariff_item_key: "Sleutel",
    tariff_item_label: "Item",
    tariff_item_mode: "Berekening",
    tariff_mode_night: "Per nacht",
    tariff_mode_once: "Eenmalig",
    tariff_mode_stay: "Per verblijf",
    tariff_mode_fixed: "Vast totaalbedrag",
    tariff_mode_discount: "% korting op de som",
    tariff_new_item: "Nieuw item",
    tariff_countable: "Met aantal",
    tariff_new_package: "Nieuw pakket",
    tariff_package: "Pakket",
    tariff_package_mode: "Berekening",
    tariff_package_content: "Inhoud",
    tariff_package_total: "Totaalprijs",
    tariff_discount_pct: "% korting",
    tariff_include_pitch: "Standplaats zit in het pakket",
    tariff_package_hint: "Bij een vast totaalbedrag vervangt het pakket de losse prijzen van die items.",
    tariff_save_first: "Bewaar de periode eerst",
    tariff_calculated: "Tarieven berekend",
    tariff_name_required: "Naam is verplicht",
    tariff_price_estimate: "Prijsindicatie",
    tariff_no_package: "Geen pakket",
    tariff_no_tariffs: "Nog geen tarieven ingesteld (Admin → Tarieven).",
    new_rental_item: "Nieuw verhuurartikel",
    rental_names: "Omschrijving per taal (voor de afrekening van de gast)",
    rental_pricing: "Berekening", pricing_day: "Per dag", pricing_week: "Per week", pricing_stay: "Per verblijf",
    rental_qty_owned: "Aantal in bezit", rental_deposit: "Waarborg",
    rentals: "Verhuur", rental_add: "Verhuur toevoegen", rental_item: "Verhuurartikel",
    rental_none: "Nog niets verhuurd voor deze boeking.",
    rental_available: "beschikbaar", rental_return: "Ingeleverd", rental_returned: "ingeleverd",
    rental_billed_until: "afgerekend tot", rental_deposit_note: "Waarborg (apart, terug bij inlevering)",
    change_period: "Periode aanpassen", until_date: "Tot",
    interim_invoice: "Tussentijdse afrekening", bill_until: "Afrekenen tot", end_last_month: "Einde vorige maand",
    admin_suppliers: "Leveranciers",
    admin_suppliers_desc: "Je leveranciers met hun gegevens en de afgesproken prijzen per artikel.",
    new_supplier: "Nieuwe leverancier",
    select_supplier: "Kies een leverancier…",
    sup_name: "Naam", sup_contact: "Contactpersoon", sup_mobile: "GSM", sup_website: "Website",
    sup_street: "Straat", sup_number: "Nummer", sup_postal: "Postcode", sup_city: "Gemeente",
    sup_vat: "BTW-nummer", sup_company_nr: "Ondernemingsnummer", sup_iban: "IBAN", sup_bic: "BIC",
    sup_customer_nr: "Ons klantnummer", sup_payment_terms: "Betalingstermijn", sup_delivery_days: "Leverdagen",
    sup_prices: "Afgesproken prijzen",
    sup_prices_desc: "Per artikel één of meer lijnen: vanaf welk aantal geldt welke prijs per stuk (vb. 1 stuk = 5 €, vanaf 10 stuks = 4,80 €).",
    sup_from_qty: "Vanaf aantal", sup_unit_price: "Prijs/stuk",
    stays: "Verblijven", stay_now: "Verblijft nu", stay_future: "Komt nog", stay_past: "Afgelopen",
    admin_purchases: "Inkomende facturen",
    admin_purchases_desc: "Leveringen van leveranciers; deze verhogen de voorraad.",
    admin_sales_inv: "Uitgaande facturen",
    admin_sales_desc: "Historiek van alle aangemaakte verkoopfacturen (boekhouding).",
    invoice_footer_note: "Factuur opgemaakt in euro. Bedragen inclusief BTW zoals hierboven berekend.",
    vat_of: "op",
    view_planning: "Planning",
    view_map: "Kaart",
    view_today: "Vandaag",
    toggle_view_hint: "Kies hier kaart of planning",
    print_plus_hint: "Print + registerkaart",
    planning_hint: "Sleep een reservering om te verplaatsen · dubbelklik voor details · scroll om te navigeren",
    jump_to_pitch: "Plaats bovenaan…",
    quick_booking: "Snelle reservatie",
    quick_booking_now: "Snelle boeking",
    quick_max_nights: "Vrij tot de volgende boeking: max. nachten",
    quick_free_until: "de plaats is opnieuw bezet vanaf",
    quick_mode_reserved: "Reservatie (komt later)",
    quick_mode_booking: "Boeking — gast is aanwezig",
    planning_months_back: "Planning: maanden terug",
    planning_months_ahead: "Planning: maanden vooruit",
    beschikbaar_dagen: "Beschikbaar: dagen voor nieuwe klanten",
    available_new: "Beschikbaar nieuw",
    mark_occupied: "Markeer als bezet",
    search_guest: "Zoek een gast…",
    marked_occupied: "Plaats staat op bezet",
    which_guest: "Door welke klant is deze plaats bezet?",
    occupy_without_guest: "Bezet zonder naam",
    back_to_tray: "Terug naar bakje",
    back_to_tray_done: "Plaats staat terug in het bakje",
    drop_here_hint: "Sleep een bolletje hierin om het terug in het bakje te zetten",
    admin_cashclose: "Dagafsluiting kassa",
    admin_cashclose_desc: "Dagoverzicht van de verkopen, kasgeld tellen en de dag vastzetten.",
    admin_guestbook: "Gastenboek",
    loading_data: "Gegevens worden opgehaald…",
    pay_card: "Kaart",
    sale_pick_first: "Klik eerst op de gast of op ‘Passant’ hierboven",
    sale_pick_lines: "Voeg minstens één artikel toe",
    invoice_finish: "Factuur afwerken",
    invoice_finish_hint: "Kies hoe de gast zijn factuur krijgt. U kan beide kiezen; achteraf kan de factuur altijd opnieuw afgedrukt of gemaild worden via Facturen.",
    invoice_finish_print_hint: "Opent de factuur in een nieuw venster",
    invoice_finish_no_email: "Geen e-mailadres bekend",
    invoice_finish_confirm: "Afwerken",
    cash_card_total: "Kaart",
    cash_card_hint: "Kaartbetalingen zitten niet in de kassa en tellen dus niet mee in het te tellen kasgeld.",
    number_from: "Nummer (van)",
    number_to: "tot (optioneel)",
    pitch_bulk_hint: "Laat 'tot' leeg om één plaats aan te maken. Maximaal 50 per keer. Bestaande plaatsen worden overgeslagen.",
    pitches_created: "{n} plaatsen aangemaakt",
    pitches_skipped: "{n} bestonden al en zijn overgeslagen",
    admin_guestbook_desc: "Beoordelingen van gasten die bij u verbleven. Zij krijgen een paar dagen na hun vertrek automatisch een vriendelijke uitnodiging.",
    gb_invited: "Uitgenodigd",
    gb_submitted: "Ingevuld",
    gb_rate: "Responsgraad",
    gb_overall: "Algemeen",
    gb_cleanliness: "Netheid",
    gb_sanitary: "Sanitair",
    gb_welcome: "Onthaal",
    gb_value: "Prijs-kwaliteit",
    gb_comment: "Reactie",
    gb_public: "Mag publiek",
    gb_public_hint: "Enkel wat u hier aanvinkt komt op de publieke gastenboekpagina. Standaard blijft alles intern.",
    gb_waiting: "Nog niet ingevuld",
    gb_send_now: "Uitnodigingen nu versturen",
    gb_dry_run: "Eerst tellen",
    gb_sent_count: "{n} uitnodiging(en) verstuurd",
    gb_candidates: "{n} gast(en) komen in aanmerking",
    gb_none: "Er zijn nog geen beoordelingen.",
    gb_enabled: "Automatisch een beoordeling vragen",
    gb_delay: "Aantal dagen na het vertrek",
    gb_guest: "Gast",
    gb_stay: "Verblijf",
    gb_public_page: "Publieke pagina",
    setup_review_enabled: "Automatisch een beoordeling vragen",
    setup_review_days: "Aantal dagen na het vertrek",
    admin_email: "Mail & SMS",
    sms_title: "SMS (Spryng)",
    sms_desc: "Uitgaande SMS (verificatiecodes, waarschuwingen).",
    sms_enabled: "SMS via Spryng gebruiken",
    sms_originator: "Afzender (naam/nummer)",
    sms_route: "Route",
    sms_token: "API-token",
    sms_test: "Test-SMS",
    sms_test_ok: "Test-SMS verstuurd",
    admin_email_desc: "Deze pagina heeft twee delen: UITGAANDE mail (SMTP) om mails te versturen én te antwoorden, en de INKOMENDE receptie-mailbox (IMAP) om gastmails te lezen. Stel ze allebei in voor volledige werking.",
    smtp_section_title: "Uitgaande mail (SMTP) — versturen & antwoorden",
    smtp_section_desc: "De server waarmee CampAd Pro mails verstuurt: facturen én je antwoorden op gastmails. Zonder deze instelling kun je wél mails ontvangen, maar niet versturen.",
    mail_need_smtp_warn: "Je ontvangt mails via de receptie-mailbox, maar om te kunnen antwoorden of versturen moet je hieronder eerst de uitgaande mailserver (SMTP) invullen en aanzetten.",
    smtp_enabled: "Eigen mailserver gebruiken (uitgaand/SMTP)",
    smtp_host: "SMTP-server",
    smtp_port: "Poort",
    smtp_security: "Encryptie",
    smtp_username: "Gebruikersnaam",
    smtp_from_email: "Afzender e-mail",
    smtp_from_name: "Afzender naam",
    smtp_password: "Wachtwoord",
    smtp_password_set: "ingesteld",
    smtp_test: "Verbinding testen",
    smtp_test_ok: "Verbinding met de mailserver gelukt",
    smtp_fallback_hint: "De factuur wordt verstuurd in de taal van de gast, met de PDF als bijlage.",
    cash_close: "Kassa afsluiten",
    cash_closed: "Kassa afgesloten",
    cash_counted: "Geteld kasgeld",
    cash_difference: "Verschil",
    cash_unprinted: "Nog niet afgedrukte facturen",
    cash_closures: "Eerdere afsluitingen",
    cash_auto: "automatisch",
    email_invoice: "Factuur mailen",
    email_sent: "Factuur verstuurd naar",
    no_email_print: "Geen e-mailadres bekend — druk de factuur af.",
    no_vat_number_warning: "Let op: er is nog geen BTW-nummer ingesteld voor de camping. Vul dit in bij Admin → Camping voordat u facturen afdrukt.",
    no_stock_tracking: "niet bijgehouden",
    low_stock: "Onder minimum",
    low_stock_alert: "Voorraadalarm",
    oos_note_required: "Een opmerking is verplicht bij 'buiten dienst'",
    oos_only_from_free: "Een plaats kan enkel buiten dienst gezet worden als ze vrij is",
    oos_until: "Buiten dienst tot",
    oos_until_hint: "Laat leeg voor permanent — de plaats blijft buiten dienst tot je ze zelf weer vrijgeeft.",
    oos_permanent: "Permanent buiten dienst",
    map_search_ph: "Plaats of naam…",
    map_search_btn: "Zoeken",
    map_search_none: "Niets gevonden op de kaart",
    no_reservation_found: "Geen reservatie gevonden voor deze plaats",
    no_active_stay: "Geen lopend verblijf op deze plaats",
    remove_reservation_q: "Reservatie verwijderen?",
    remove_reservation_hint: "De reservatie van {name} wordt verwijderd en de plaats komt vrij. De klantgegevens blijven bewaard.",
    reservation_removed_guest_kept: "Reservatie verwijderd — klantgegevens bewaard",
    setup_stock_alert_hour: "Uur voorraadalarm",
    setup_stock_alert_enabled: "Dagelijkse voorraadmail",
    setup_stock_alert_hint: "Elke dag op dit uur krijgen alle beheerders de artikelen onder minimum per mail.",
    setup_audit_retention: "Logboek bewaren",
    setup_audit_retention_unit: "dagen",
    setup_audit_retention_hint: "Het wijzigingslogboek bewaart entries zo lang. Elke nacht om middernacht worden oudere entries automatisch verwijderd.",
    setup_intro_music: "Welkomstmuziek",
    setup_intro_music_on: "Muziek na het aanmelden",
    setup_intro_music_hint: "Vivaldi — De Vier Jaargetijden, \"Lente\" (publiek domein) speelt kort na het aanmelden.",
    setup_stationery: "Briefpapier / voettekst",
    setup_stationery_hint: "Deze gegevens komen in de voettekst van facturen, kassabonnen, waarborgbewijzen en inschrijvingsfiches. De dagen worden afgedrukt in de taal van de klant.",
    setup_bank_name: "Banknaam",
    setup_iban: "IBAN",
    setup_bic: "BIC",
    setup_footer_extra: "Extra voettekst (bv. ondernemingsnummer)",
    setup_opening_hours: "Openingsuren receptie",
    setup_closed: "Gesloten",
    setup_hour_seasons: "Seizoensuren",
    setup_hour_seasons_hint: "Voeg periodes toe (bv. hoogseizoen 15/06 → 15/09). Periodes over de jaarwisseling mogen ook. Documenten tonen de uren van de lopende periode; buiten die periodes gelden de standaarduren hierboven.",
    setup_season_name: "Naam seizoen",
    settle_merged: "Plaatsen samen afgerekend (zelfde vertrekdatum)",
    settle_parallel_warn: "Deze gast staat ook op",
    settle_parallel_ask: "Mee afrekenen en afsluiten op de afrekendatum?",
    settle_sales_added: "Nog niet afgerekende verkopen toegevoegd aan de factuur",
    settle_open_invoices: "Nog openstaande facturen van deze gast",
    settle_total_open: "Totaal openstaand",
    overdue_dep_title: "Te laat vertrokken",
    overdue_dep_msg_one: "gast is zijn vertrekdatum voorbij",
    overdue_dep_msg_many: "gasten zijn hun vertrekdatum voorbij",
    overdue_dep_view: "Details bekijken",
    overdue_dep_hide: "Details verbergen",
    overdue_dep_days: "dagen te laat",
    overdue_dep_day: "dag te laat",
    overdue_dep_open: "Openstaand",
    outstanding_title: "Nog openstaand",
    outstanding_none: "Deze gast heeft niets openstaan.",
    outstanding_sales: "Verkopen op rekening",
    outstanding_deposits: "Openstaande waarborgen",
    mobile_apps: "Mobiele apps (Inspection / Visitors)",
    mobile_apps_hint: "Afmetingen van de plattegrond en de GPS-kalibratie die de mobiele apps gebruiken. Oorsprong: linkerbovenhoek.",
    plan_width: "Planbreedte",
    plan_height: "Planhoogte",
    plan_unit_px: "Eenheid: pixels van de plattegrond (zelfde waarden als de web-app).",
    calib_nw_lat: "NW breedtegraad",
    calib_nw_lng: "NW lengtegraad",
    calib_se_lat: "ZO breedtegraad",
    calib_se_lng: "ZO lengtegraad",
    calib_bearing: "Rotatie (°)",
    calib_opacity: "Doorzichtigheid (0-1)",
    admin_inspection: "Controle (app)",
    admin_inspection_desc: "Meldingen en live aanwezigheid van de controleurs",
    inspection_reports: "Meldingen uit de controle-app",
    inspection_presence: "Controleurs op de camping",
    inspection_open: "Toon openstaande",
    inspection_handled: "Toon afgehandelde",
    inspection_new_report: "Nieuwe controle-melding",
    inspection_goto: "Naar de meldingen",
    reset_pw: "Wachtwoord terugzetten",
    reset_pw_confirm: "Wachtwoord terugzetten naar het startwachtwoord (= het e-mailadres)?",
    reset_pw_done: "Wachtwoord teruggezet naar het e-mailadres",
    reset_pw_tooltip: "Wachtwoord reset: zet het wachtwoord terug naar het e-mailadres en de gebruiker moet het bij de volgende login zelf aanpassen",
    reset_pw_hint: "De gebruiker logt in met het e-mailadres als wachtwoord en moet dan een nieuw wachtwoord kiezen.",
    reset_pw_legend: "Het gele sleuteltje = wachtwoord reset: terug naar het startwachtwoord (= e-mailadres), de gebruiker moet het bij de volgende login zelf aanpassen.",
    admin_maintenance: "Onderhoud",
    admin_maintenance_desc: "Plaatsstatussen gelijkzetten en testdata opruimen",
    admin_menu: "Menu-indeling",
    admin_menu_desc: "Bepaal per rol welke menu-items zichtbaar zijn en in welke groep/volgorde",
    menu_role: "Rol",
    menu_hint: "Items worden in het zijmenu gegroepeerd per groep; de volgorde hieronder bepaalt de volgorde binnen elke groep. De Hoofdbeheerder ziet altijd alles.",
    menu_visible: "Zichtbaar",
    menu_group: "Groep",
    menu_reset: "Terug naar standaard",
    menu_drag: "Versleep om de volgorde te wijzigen",
    menu_saved: "Menu-indeling opgeslagen",
    menu_groups: "Groepen",
    menu_add_group: "Groep toevoegen",
    menu_delete_group: "Groep verwijderen",
    menu_items_label: "Menu-items",
    maint_pitches: "Plaatsstatussen gelijkzetten",
    maint_pitches_hint: "Zet de status van elke plaats gelijk met de reservaties van vandaag. Plaatsen die buiten dienst staan blijven ongemoeid.",
    maint_pitches_confirm: "Alle plaatsstatussen gelijkzetten met de reservaties?",
    maint_to_fix: "Af te stemmen plaatsen",
    maint_sync_now: "Nu gelijkzetten",
    maint_testdata: "Testdata opruimen",
    maint_testdata_hint: "Verwijdert gasten, reservaties, facturen en verkopen die als test herkenbaar zijn. Facturen en verkopen met een correcte nummering (bv. 2026-0005) blijven altijd staan.",
    maint_testdata_confirm: "Deze testdata definitief verwijderen? Dit kan niet ongedaan gemaakt worden.",
    maint_found: "Gevonden testrecords",
    maint_cleanup_now: "Nu opruimen",
    maint_guest: "Gast",
    maint_reservation: "Reservatie",
    maint_invoice: "Factuur",
    maint_sale: "Verkoop",
    mark_handled: "Afgehandeld",
    insp_observed: "Vastgestelde status",
    insp_photo: "Foto bekijken",
    insp_cat_status_klopt_niet: "Status klopt niet",
    insp_cat_verkeerde_locatie: "Verkeerde locatie",
    insp_cat_onbruikbaar: "Onbruikbaar",
    insp_cat_andere: "Andere",

    pay_link: "Betaallink",
    pay_link_copied: "Betaallink gekopieerd",
    pay_online: "Online betaald",
    payment_ok_title: "Betaling ontvangen!",
    payment_ok_text: "Bedankt. Uw factuur staat op betaald.",
    payment_pending_title: "Betaling wordt verwerkt…",
    payment_pending_text: "We wachten op de bevestiging van de bank. Houd deze pagina even open.",
    payment_failed_title: "Betaling niet voltooid",
    payment_failed_text: "Probeer het opnieuw of vraag het aan de receptie.",
    payment_cancel_title: "Betaling geannuleerd",
    payment_cancel_text: "Er is niets aangerekend. U kan het later opnieuw proberen.",




    order_advice: "Besteladvies",
    order_advice_desc: "Artikelen onder minimum, gegroepeerd per vaste leverancier",
    order_advice_none: "Geen artikelen onder minimum — niets te bestellen",
    no_supplier: "Zonder vaste leverancier",
    art_supplier: "Vaste leverancier",
    art_order_qty: "Bestelaantal",
    art_order_qty_hint: "Laat 0 om automatisch het tekort tot aan het minimum te bestellen.",
    order_qty_short: "Te bestellen",
    order_mail: "Bestelling mailen",
    order_print: "Bestelling afdrukken",
    order_mail_sent: "Bestelling verstuurd",
    order_mail_to: "Naar",
    order_mail_subject: "Onderwerp",
    order_mail_message: "Begeleidende tekst",
    order_no_email: "Deze leverancier heeft geen e-mailadres",
    low_stock_msg: "artikel(en) onder de minimumvoorraad",
    goto_stock: "Naar de voorraad",
    search_article: "Zoek artikel…",
    stock_desc: "Voorraad wijzigt enkel door een verkoop, een levering met inkomende factuur of een correctie door een beheerder.",
    stock_rule_hint: "De voorraad zelf kan niet ingetypt worden: gebruik een levering of een correctie.",
    stock_history: "Voorraadhistoriek",
    move_kind: "Reden",
    move_sale: "Verkoop",
    move_delivery: "Levering",
    move_correction: "Correctie",
    new_correction: "Correctie boeken (breuk, inventaris)",
    correction_reason: "Reden",
    deliveries: "Leveringen (inkomende facturen)",
    new_delivery: "Nieuwe levering",
    book_delivery: "Levering boeken",
    delivery_booked: "Levering geboekt",
    delivery_hint: "Bij het boeken gaat de voorraad van elke lijn omhoog en wordt de beweging aan deze inkomende factuur gekoppeld.",
    supplier: "Leverancier",
    purchase_price: "Inkoopprijs",
    select_article: "Artikel kiezen…",
    ask_admin_article: "Nieuw artikel? Vraag je beheerder.",
    sale_step_1: "Standplaats",
    sale_step_2: "Klant en betaling",
    sale_step_3: "Artikelen",
    search_stay: "Zoek op plaats of naam…",
    walkin: "Passant (geen standplaats)",
    walkin_title: "Walk-in aanmaken",
    walkin_hint: "Maakt een voorlopige boeking (max 48u) en stuurt meteen een QR-link + welkomstmail (24u geldig) in de taal van de gast.",
    walkin_need_fields: "Voornaam en e-mailadres zijn verplicht",
    walkin_created: "Walk-in aangemaakt",
    walkin_mail_sent: "Welkomstmail verstuurd",
    walkin_qr_hint: "Laat de gast deze QR-code scannen om zelf in te checken.",
    walkin_create: "Aanmaken + mailen",
    walkin_hours: "Uren (max 48)",
    actions: "Acties",
    bf_last_name: "Achternaam",
    bf_email: "E-mail",
    nav_jobs: "Jobs",
    jobs_none: "Geen taken gevonden",
    job_task: "Taak",
    job_assignee: "Controleur",
    job_unassigned: "Niet toegewezen",
    job_mark_done: "Afgewerkt",
    job_done: "Job afgewerkt",
    job_new: "Nieuwe taak",
    job_edit: "Taak bewerken",
    job_title: "Titel",
    job_category: "Categorie",
    job_priority: "Prioriteit",
    job_due: "Vervaldatum",
    job_detail: "Detail",
    job_status: "Status",
    job_saved: "Taak opgeslagen",
    job_deleted: "Taak verwijderd",
    job_delete_confirm: "Deze taak verwijderen?",
    job_all_assignees: "Alle medewerkers",
    tab_active: "Actief",
    tab_done: "Klaar",
    tab_all: "Alles",
    cat_power: "Stroom", cat_repair: "Herstelling", cat_cleaning: "Schoonmaak",
    cat_inspection: "Controle", cat_delivery: "Levering", cat_other: "Andere",
    prio_laag: "Laag", prio_normaal: "Normaal", prio_hoog: "Hoog", prio_dringend: "Dringend",
    status_open: "Open", status_assigned: "Toegewezen", status_busy: "Bezig",
    status_done: "Klaar", status_cancelled: "Geannuleerd",
    demo_off_purge_confirm: "Demo uitzetten voor {name}? Hierbij worden {n} demo-gegevens definitief verwijderd.",
    sale_billing: "Facturatie",
    sale_private: "Privé",
    sale_company: "Op bedrijf",
    no_company: "Bij deze gast staat geen bedrijf: de verkoop gaat op privénaam.",
    payment: "Betaling",
    pay_cash: "Cash betaald",
    pay_account: "Op rekening (eindafrekening)",
    save_cash: "Verkoop + cash betaald",
    save_account: "Verkoop op rekening",
    stock_negative_warning: "voorraad wordt negatief",
    back: "Terug",
    next: "Volgende",
    company: "Bedrijf",
    company_on_account: "Op rekening van een bedrijf",
    company_name: "Bedrijfsnaam",
    company_hint: "Deze gegevens komen op de factuur als er op bedrijf afgerekend wordt.",
    parking: "Parkeerstatus",
    find_parking: "Ga naar de parkeerstatus op de kaart",
    search_placeholder: "Zoek op naam, nummerplaat of plaats…",
    search_in_screen: "Zoek in dit scherm…",
    booker: "Boeker",
    occupants: "Boeker en medereizigers",
    tab_adult: "Volwassene",
    tab_child: "Kind",
    complete: "Compleet",
    complete_hint: "Vul het verblijf volledig in en klik Compleet om de medereizigers te kunnen invullen.",
    stay_approved: "Verblijf goedgekeurd",
    stay_approved_hint: "Je kan nu de medereizigers invullen.",
    id_required_over12: "ID- of paspoortnummer is verplicht boven 12 jaar.",
    same_address_hint: "Adres (voorstel: zelfde als de boeker, aanpasbaar)",
    occupant_period: "Verblijf van deze persoon (binnen de boeking)",
    no_extra_occupants: "Geen medereizigers: verhoog het aantal volwassenen of kinderen bij het verblijf.",
    occupants_incomplete: "Medereizigers nog niet volledig",
    dblclick_hint: "dubbelklik om in te zoomen, shift+dubbelklik om uit te zoomen",
    multi_select_hint: "Ctrl+klik (of Shift+klik) om meerdere te selecteren, klik daarna op de kaart waar het raster moet beginnen",
    selected_n: "{n} geselecteerd",
    placed_n: "{n} plaatsen op de kaart gezet",
    grid_place: "In raster op de kaart zetten",
    pan_hint: "sleep de kaart met de muis om te verschuiven",
    size: "Afmeting",
    size_1: "Klein",
    size_2: "Middel",
    size_3: "Groot",
    tenants: "Campings (klanten)",
    tenants_desc: "Alleen de hoofdbeheerder ziet deze tabel. Domein bepaalt welke camping bij een adres hoort, het e-maildomein bepaalt welke gebruikers mogen aangemaakt worden.",
    t_slug_hint: "bv. cap-blanch (leeg = automatisch uit de naam)",
    t_slug_fixed: "De code is de sleutel van alle gegevens van deze camping en kan nadien niet meer gewijzigd worden.",
    t_domain: "Domein",
    t_domain_hint: "Meerdere webadressen? Scheid ze met een komma. Het buitenscherm en het inlogscherm volgen altijd het webadres waarmee je de app opent.",
    t_handover: "Webadres overnemen",
    t_handover_desc: "Het webadres {domains} verhuist naar de camping die je hieronder kiest. {name} wordt daarna op niet-actief gezet: niemand kan er nog in werken, maar er gaat niets verloren. Dit kan alleen als deze camping geen gegevens meer bevat.",
    t_handover_target: "Verhuizen naar",
    t_handover_do: "Webadres verhuizen",
    t_handover_ok: "Webadres {domains} is verhuisd en de oude camping staat op niet-actief",
    t_delete_confirm: "Camping {name} definitief verwijderen? Dit kan alleen als er geen gegevens meer aan hangen en is niet omkeerbaar.",
    t_delete_ok: "Camping {name} is verwijderd",
    t_name: "Naam camping",
    t_email_domain: "E-maildomein gebruikers",
    t_slug: "Code",
    t_admin_email: "E-mail eerste beheerder (optioneel)",
    new_tenant: "Nieuwe camping",
    switch_tenant: "Werk in deze camping",
    switched: "Actieve camping gewijzigd",
    active_camp: "Actieve camping",
    t_users: "Gebruikers",
    t_pitches: "Plaatsen",
    zones: "Zones",
    new_zone: "Nieuwe zone",
    zone_code: "Code",
    zone_name: "Naam",
    zone_new_inline: "Nieuwe zone aanmaken…",
    zone_created: "Zone aangemaakt",
    zones_desc: "Zones bepalen de indeling van de camping. Bij het aanmaken van een plaats kies je een bestaande zone of maak je er een nieuwe aan.",
    role_superadmin: "Hoofdbeheerder",
    setup: "Setup — camping",
    setup_desc: "Alle camping-specifieke gegevens. Deze waarden worden gebruikt in de sidebar, het aanmeldscherm, de fiches, de facturen en de e-mails.",
    setup_payment_title: "Betaalverzoek",
    setup_payment_desc: "Bepaalt welk bedrag een gast moet betalen bij een online betaalverzoek.",
    setup_payment_full: "Volledig bedrag",
    setup_payment_deposit: "Voorschot",
    setup_deposit_type: "Soort voorschot",
    setup_deposit_percent: "Percentage",
    setup_deposit_amount: "Vast bedrag",
    setup_camp_name: "Naam camping",
    camping: "Camping",
    setup_street: "Straat en nummer",
    setup_postal_city: "Postcode en gemeente",
    setup_country: "Land",
    setup_phone: "Telefoon",
    setup_email: "E-mailadres",
    setup_website: "Website (knop op aanmeldscherm)",
    setup_gps: "GPS-coördinaten",
    setup_vat_number: "BTW/CIF-nummer",
    setup_vat_rate: "Standaard BTW %",
    setup_tourist_tax: "Toeristenbelasting per persoon/nacht",
    setup_currency: "Munt",
    setup_default_lang: "Standaardtaal interface",
    setup_base_lang: "Basistaal (bron voor vertalingen)",
    setup_base_lang_hint: "De taal waarin de gast-mails en kaarten geschreven zijn en waaruit naar alle andere EU-talen vertaald wordt. Kies er exact één: NL, ES of EN.",
    pretranslate_label: "Talen voorbereiden",
    pretranslate: "Alle talen nu voorvertalen",
    pretranslate_hint: "Zet de mails en kaarten voor gasten eenmalig klaar in alle EU-talen, zodat de allereerste gast in een nieuwe taal niet hoeft te wachten. Dit gebeurt op de achtergrond.",
    pretranslate_started: "Voorvertalen gestart — dit loopt op de achtergrond",
    pretranslate_done: "Alle talen staan klaar",
    setup_logo: "Logo (sidebar, fiche, factuur)",
    setup_logo_tent: "Klein logo (ingeklapte sidebar)",
    setup_emergency: "Noodnummers (fiche)",
    setup_info_items: "Algemene informatie op de fiche",
    setup_label: "Omschrijving",
    setup_number: "Nummer",
    upload: "Uploaden",
    save: "Opslaan",
    add: "Rij toevoegen",
    tagline: "Campingbeheer",
    login_title: "Welkom terug",
    login_sub: "Log in om het campingbeheer te openen",
    forgot_password: "Wachtwoord vergeten?",
    reset_phone: "Gsm-nummer",
    reset_email_label: "E-mailadres",
    reset_request_sub: "Geef je e-mailadres en gsm-nummer in. Je krijgt een e-mail met een herstellink en een sms met een code.",
    reset_request_btn: "Herstel aanvragen",
    reset_sent_msg: "Als dit account bestaat, sturen we je een e-mail (en sms) met herstelinstructies.",
    back_to_login: "Terug naar aanmelden",
    reset_title: "Nieuw wachtwoord instellen",
    reset_code: "Sms-code (6 cijfers)",
    reset_submit: "Wachtwoord instellen",
    reset_done: "Je wachtwoord is gewijzigd. Je kan nu aanmelden.",
    reset_invalid_link: "De herstellink is ongeldig of verlopen. Vraag een nieuwe aan via het aanmeldscherm.",
    reset_pw_mismatch: "De wachtwoorden komen niet overeen.",
    email: "E-mailadres",
    password: "Wachtwoord",
    login: "Inloggen",
    logout: "Uitloggen",
    logging_in: "Bezig met inloggen...",
    nav_dashboard: "Overzicht",
    nav_aankomend: "Aankomsten",
    nav_zoekers: "Zoekers",
    assign_pitch: "Plaats toewijzen",
    overdue_label: "Te laat",
    no_zoekers: "Geen zoekers zonder plaats",
    nav_reservaties: "Reservaties",
    nav_vertrekkend: "Vertrekkend",
    nav_afrekening: "Tussentijdse afrekening",
    nav_verhuizen: "Verhuizen",
    nav_verbeteringen: "Verbeteringen",
    nav_gasten: "Gasten",
    nav_verkopen: "Losse verkopen",
    nav_facturen: "Facturen maken",
    nav_admin: "Admin",
    menu: "Menu",
    campsite_overview: "Campingoverzicht",
    occupancy_zone: "Bezetting per zone",
    kpi_vrij: "Vrij volgens systeem",
    kpi_bezet: "Bezet",
    kpi_controle: "Controle nodig",
    kpi_rood: "Rood lintje",
    legend: "Legenda",
    arriving_today: "Aankomsten vandaag",
    departing_today: "Vertrek vandaag",
    zone: "Zone",
    free: "Vrij",
    occupied: "Bezet",
    reserved: "Gereserveerd",
    pitch: "Plek",
    status: "Status",
    note: "Notitie",
    save: "Opslaan",
    cancel: "Annuleren",
    close: "Sluiten",
    u_barcode: "Barcodenummer",
    users_hide_inactive: "Inactieve verbergen",
    users_show_inactive: "Inactieve tonen",
    users_info: "Gegevens",
    users_search: "Zoek op roepnaam, naam, e-mail of rol...",
    guests_search: "Zoek op naam, nummerplaat, plaats of e-mail...",
    pitch_note_placeholder: "Korte notitie...",
    pitch_note_saved: "Notitie opgeslagen",
    add: "Toevoegen",
    edit: "Bewerken",
    delete: "Verwijderen",
    guest: "Gast",
    guests: "Gasten",
    new_guest: "Nieuwe gast",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone: "Telefoon",
    language: "Taal",
    country: "Land",
    license_plate: "Kenteken",
    notes: "Notities",
    documents: "Documenten",
    upload: "Uploaden",
    upload_hint: "Toegestaan: PDF, JPG, PNG, WEBP, HEIC · max 15 MB",
    upload_bad_type: "Dit bestandstype kan niet. Toegestaan: PDF, JPG, PNG, WEBP, HEIC.",
    upload_too_big: "Bestand te groot (max 15 MB).",
    finder_title: "Plaats zoeken voor periode",
    finder_search: "Zoeken",
    finder_direct: "Meteen vrij (0 verhuizingen)",
    finder_one: "Beschikbaar met 1 verhuis",
    finder_two: "Beschikbaar met 2 verhuizen",
    finder_none: "Geen plaatsen gevonden voor deze periode",
    finder_move_arrow: "verhuis op",
    move_planned: "Geplande verhuizingen",
    move_pending: "Nog uit te voeren",
    move_done: "Reeds uitgevoerd",
    move_execute: "Uitgevoerd",
    move_due: "Vandaag",
    move_other_zone: "andere zone",
    finder_plan_title: "Reserveren met verhuizing",
    finder_create: "Reserveren",
    finder_created: "Reservatie met geplande verhuizing(en) aangemaakt",
    finder_first: "Voornaam",
    finder_last: "Naam",
    finder_persons: "Personen",
    reservation: "Reservatie",
    reservations: "Reservaties",
    new_reservation: "Nieuwe reservatie",
    arrival: "Aankomst",
    departure: "Vertrek",
    persons: "Personen",
    checkin: "Inchecken",
    print_registration: "Kaart + inschrijvingsformulier afdrukken",
    checkout: "Uitchecken",
    to_reservation: "Naar reservatie",
    pitch3d_hint: "Klik op een plaats voor gast en verblijf",
    move: "Verhuizen",
    to_pitch: "Naar plek",
    invoice: "Factuur",
    invoices: "Facturen",
    new_invoice: "Nieuwe factuur",
    invoice_number: "Factuurnummer",
    description: "Omschrijving",
    qty: "Aantal",
    unit_price: "Prijs",
    subtotal: "Subtotaal",
    tax: "BTW",
    total: "Totaal",
    new: "Nieuwe",
    users: "Gebruikers",
    main_booker: "Hoofdboeker",
    ribbon_guest: "Rood lintje — werkt voor de camping, voorkeurplaats (optioneel)",
    until: "tot",
    free_until: "vrij tot",
    drop_photos: "Sleep foto's of PDF's hierheen",
    still_needed: "Nog nodig",
    departure_before_arrival: "Vertrek ligt vóór aankomst",
    quote_range_warn: "De periode lijkt onrealistisch lang. Controleer de datums (jaartal).",
    quote_per_month: "gemiddeld per maand",
    inv_unpaid: "Onbetaald",
    inv_paid: "Betaald",
    pay: "Betalen",
    pay_registered: "Betaling geregistreerd",
    pay_m_cash: "Cash",
    pay_m_card: "Kaart",
    pay_m_split: "Gesplitst",
    pay_split_note: "Gesplitste betaling: deel cash, deel kaart.",
    bf_first_name: "Voornaam", bf_last_name: "Achternaam", bf_email: "E-mail", bf_birth_date: "Geboortedatum", bf_street: "Straat", bf_house_number: "Huisnummer",
    bf_postal_code: "Postcode", bf_city: "Woonplaats", bf_country: "Land", bf_passport_number: "Paspoortnummer", bf_passport_country: "Land van uitgifte", bf_passport_place: "Plaats van uitgifte",
    plate: "Nummerplaat",
    print_fiche: "Fiche printen",
    print_fiche_map: "Fiche + kaart printen",
    confirm_delete_reservation: "Deze reservatie wissen?",
    passport_docs: "Documenten (paspoort / ID)",
    take_photo: "Foto nemen",
    choose_files: "Bestanden kiezen",
    docs_uploaded: "document(en) opgeladen",
    open: "Openen",
    nav_verblijven: "Verblijven",
    search_staying: "Zoek op naam, roepnaam of locatie…",
    no_staying: "Geen verblijven gevonden",
    email_invalid: "Ongeldig e-mailadres (bv. naam@domein.be)",
    email_no_domain: "Dit domein bestaat niet of ontvangt geen e-mail",
    type_pitch: "Typ de locatie, bv. T12…",
    no_free_pitch: "Geen vrije locatie gevonden voor deze periode",
    pick_existing_guest: "Bestaande gast kiezen…",
    chosen_pitch: "Gekozen locatie",
    period: "Periode",
    your_stay: "Uw verblijf",
    passport: "Paspoortnummer",
    issue_country: "Land van uitgifte",
    issue_place: "Plaats van uitgifte",
    card_number: "Kaartnummer",
    valid_until: "Geldig tot",
    power: "Stroomkeuze",
    stay_adults: "Volwassenen", stay_children: "Kinderen (4-12 j)", stay_dogs: "Hond",
    stay_car: "Auto", stay_caravan: "Caravan", stay_mobilhome: "Mobilhome", stay_trailer: "Aanhanger", stay_tent: "Tent",
    stay_moto: "Moto", stay_boat: "Boot", stay_mobilhome9: "Mobilhome > 9 m", stay_bungalow: "Bungalow", stay_cabin: "Hut",
    conflict_bungalow_cabin: "Bungalow kan niet samen met hut",
    conflict_unit_accommodation: "Caravan, mobilhome of tent kan niet samen met bungalow of hut",
    save_provisional: "Voorlopig afsluiten",
    save_definitive: "Definitief afsluiten",
    definitive_hint: "Definitief: alle gegevens van de hoofdboeker verplicht (kaartnummer en geldig tot zijn optioneel); bevestiging wordt gemaild in de taal van de hoofdboeker.",
    provisional_hint: "Voorlopig: enkel locatie, voornaam en achternaam verplicht.",
    missing_fields: "Vul alle gemarkeerde verplichte velden in",
    mail_sent: "Bevestigingsmail verzonden",
    provisional: "Voorlopig",
    birth_future: "Geboortedatum kan niet in de toekomst liggen",
    new_user: "Nieuwe gebruiker",
    u_number: "Nummer",
    cash_opening: "Beginkas",
    cash_keep: "Wisselgeld in kassa",
    live_updated: "Live · bijgewerkt",
    admin_deposits: "Afstortingen",
    deposits_desc: "Alle afstortingen met doorlopend nummer, per maand of per jaar (financiële klasse 4 of 5).",
    deposits_next_number: "Volgend nummer",
    deposits_seq_hint: "Nummers lopen per jaar door en kunnen niet lager gezet worden dan het laatst gebruikte nummer.",
    deposit_cancel: "Annuleren",
    deposit_cancelled: "Geannuleerd",
    deposit_cancel_hint: "Het nummer blijft bestaan, maar het bedrag telt niet meer mee.",
    deposit_cancel_reason: "Reden van annulering",
    cash_deposit_interim: "Tussentijds afstorten",
    cash_deposit_where: "Afstorten gebeurt via Admin → Dagafsluiting.",
    cash_deposit_interim_hint: "Het bedrag gaat direct van de kasstand af en je krijgt een bon om mee te nemen.",
    cash_deposit_account: "Bankrekening",
    cash_deposit_receipt: "Afstortingsbon",
    cash_deposit_origin: "Herkomst",
    cash_sign_staff: "Handtekening medewerker",
    cash_sign_bank: "Handtekening bank",
    cash_banked_today: "Tussentijds afgestort",
    cash_account_paid: "Cash op openstaande facturen",
    cash_account_card: "Kaart op openstaande facturen (ter info)",
    cash_account_hint: "Cash-betalingen van openstaande (op rekening) facturen tellen mee in de kas op de betaaldatum. Kaartbetalingen zijn enkel ter info.",
    cash_online_deposits: "Online voorschotten ontvangen",
    cash_online_deposits_hint: "Online betaalde voorschotten (vooruitbetalingen via Stripe). Apart vermeld — tellen niet mee in de kaslade.",
    admin_season: "Jaaroverzicht",
    season_desc: "Omzet, kasverschillen en uren per medewerker over een jaar of seizoen (alleen financiële klasse 5).",
    season_year: "Jaar",
    season_from: "Van",
    season_to: "Tot",
    season_staff: "Per medewerker",
    m_jan: "januari",
    m_feb: "februari",
    m_mar: "maart",
    m_apr: "april",
    m_may: "mei",
    m_jun: "juni",
    m_jul: "juli",
    m_aug: "augustus",
    m_sep: "september",
    m_oct: "oktober",
    m_nov: "november",
    m_dec: "december",
    cash_max_enabled: "Waarschuwen bij volle kassa",
    cash_max_limit: "Maximum in kassa (€)",
    cash_max_hint: "Zit er meer contant in de kassa dan dit bedrag, dan krijgt de receptie een waarschuwing om tussentijds af te storten.",
    cash_level_warning: "Er zit veel contant in de kassa — stort tussentijds af",
    cash_sellers_today: "Verkocht die dag",
    cash_deposit: "Afstorting",
    cash_deposit_register: "Afstorting registreren",
    cash_deposit_by: "Gebracht naar de bank door",
    cash_deposit_by_ph: "naam van de medewerker",
    amount: "Bedrag",
    cash_count_show: "Tellen per biljet/munt",
    cash_count_hide: "Telhulp sluiten",
    cash_count_hint: "Vul het aantal in; het totaal wordt automatisch berekend.",
    cash_diff_weeks: "Kasverschillen per week",
    cash_diff_list: "Kasverschil-lijst",
    cash_diff_history: "Eerdere kasverschillen per verkoper",
    cash_diff_history_opt: "Historiek per verkoper meenemen",
    cash_last_8: "8 weken",
    cash_last_13: "13 weken",
    cash_this_year: "Dit jaar",
    cash_days_with_diff: "Dagen met verschil",
    cash_max_diff: "Grootste verschil",
    admin_seller_revenue: "Omzet per medewerker",
    seller_revenue_desc: "Omzet per medewerker op basis van de badge bij de verkoop.",
    cash_alert_enabled: "Waarschuwen bij kasverschil",
    cash_alert_limit: "Grensbedrag (€)",
    cash_alert_hint: "Is het verschil groter dan dit bedrag, dan krijgen de beheerders met financiële klasse 5 meteen een mail.",
    cash_to_deposit: "Af te storten",
    cash_not_closed: "Nog niet afgesloten",
    cash_signature: "Gecontroleerd door / datum",
    seller: "Medewerker",
    staff_scan: "Badge scannen om van medewerker te wisselen",
    staff_scan_ph: "Scan badge of typ personeelsnummer",
    shift_note_hint: "Korte notitie voor de volgende dienst (optioneel)",
    shift_note_ph: "bv. sanitair B gepoetst · plaats A12 klaagt over water",
    shift_notes_title: "Meldingen van de dienst",
    hours_mail_enabled: "Weekoverzicht mailen",
    hours_mail_day: "Dag",
    hours_mail_hour: "Uur",
    hours_mail_hint: "Het overzicht van de vorige week gaat naar alle beheerders met financiële klasse 5.",
    u_min_week_hours: "Min. uren per week",
    u_min_week_hint: "0 = geen minimum (glijdende uren)",
    admin_hours: "Urenregistratie",
    my_hours: "Mijn uren",
    break: "Pauze",
    break_hint: "Pauze: je wordt afgemeld en de tijd wordt als pauze geregistreerd",
    hours_week: "Week",
    hours_month: "Maand",
    hours_worked: "Gewerkt",
    hours_planned: "Gepland",
    hours_diff: "Verschil",
    hours_min: "Minimum",
    hours_days_worked: "Gewerkte dagen",
    hours_desc: "Uren komen automatisch uit het aan- en afmelden. Klik op een dag om de sessies te bekijken of te corrigeren.",
    hours_desc_own: "Je eigen uren, automatisch bijgehouden bij elk aan- en afmelden.",
    hours_none: "Geen registraties op deze dag",
    hours_open: "loopt nog",
    hours_idle: "Inactiviteit",
    hours_auto: "Automatisch afgesloten",
    hours_manual: "Handmatig",
    hours_add: "Registratie toevoegen",
    u_badge: "Badge",
    login_identifier: "E-mailadres of badgenummer",
    login_identifier_ph: "naam@voorbeeld.com of scan je badge",
    u_staff_number: "Personeelsnummer",
    u_staff_hint: "Optioneel, moet uniek zijn",
    u_number_hint: "Automatisch gegenereerd (EAN13)",
    u_idle: "Automatisch afmelden na (min, minimum 60)",
    u_nickname: "Roepnaam",
    u_birth: "Geboortedatum",
    u_role: "Type/rol",
    u_street: "Straat",
    u_house: "Huisnr.",
    u_postal: "Postcode",
    u_city: "Woonplaats",
    u_workdays: "Standaard werkdagen en tijden",
    role_admin: "Beheerder",
    u_finance_class: "Financiële klasse",
    u_finance_hint: "Extra financiële rechten voor een gewone gebruiker. Beheerders hebben altijd alles.",
    fin_0: "0 – geen financiële rechten",
    fin_1: "1 – facturen en afrekenen",
    fin_2: "2 – ook dagafsluiting",
    fin_3: "3 – ook financiële overzichten",
    fin_4: "4 – ook tarieven aanpassen",
    fin_5: "5 – alles op financieel gebied",
    role_reception: "Reception",
    role_controller: "Controller",
    role_personeel: "Personeel",
    day_mon: "Ma", day_tue: "Di", day_wed: "Wo", day_thu: "Do", day_fri: "Vr", day_sat: "Za", day_sun: "Zo",
    active: "Actief",
    inactive: "Gedeactiveerd",
    activate: "Activeren",
    deactivate: "Deactiveren",
    pw_pending: "wachtwoord nog te wijzigen",
    user_pw_info: "Het tijdelijke wachtwoord is gelijk aan het e-mailadres. Bij de eerste aanmelding moet de gebruiker een nieuw wachtwoord kiezen.",
    user_created_hint: "Gebruiker aangemaakt — tijdelijk wachtwoord = e-mailadres",
    nav_wachtwoord: "Wachtwoord",
    change_password: "Wachtwoord wijzigen",
    current_password: "Huidig wachtwoord",
    new_password: "Nieuw wachtwoord",
    repeat_password: "Herhaal nieuw wachtwoord",
    pw_requirements: "Vereisten",
    pw_rule_length: "Minimaal 10 tekens",
    pw_rule_upper: "Minstens 1 hoofdletter",
    pw_rule_lower: "Minstens 1 kleine letter",
    pw_rule_digit: "Minstens 1 cijfer",
    pw_rule_special: "Minstens 1 leesteken",
    pw_rule_match: "Beide nieuwe wachtwoorden zijn gelijk",
    pw_changed: "Wachtwoord gewijzigd",
    pw_first_login: "Eerste aanmelding: kies eerst een nieuw wachtwoord. Je huidige wachtwoord is je e-mailadres.",
    guest_created: "Gast aangemaakt en geselecteerd",
    save_guest: "Gast opslaan",
    final_invoice: "Eindafrekening",
    checkout_and_invoice: "Uitchecken + eindafrekening",
    checkout_only: "Uitchecken zonder factuur",
    no_departures: "Geen vertrekkende gasten die nog moeten uitchecken",
    nights: "nachten",
    pitch_fee: "Standplaats",
    tourist_tax: "Toeristenbelasting",
    electricity: "Elektriciteit",
    add_line: "Regel toevoegen",
    description: "Omschrijving",
    qty: "Aantal",
    unit_price: "Prijs",
    subtotal: "Subtotaal",
    vat: "BTW",
    checked_out_ok: "Uitgecheckt",
    sales_included: "Losse verkopen van deze gast",
    new_arrival: "Nieuwe aankomst (reservatie + inchecken)",
    no_arrivals: "Geen aankomsten die nog moeten inchecken",
    checked_in_ok: "Ingecheckt",
    vrij: "Vrij",
    bezet: "Bezet",
    gereserveerd: "Gereserveerd",
    add_line: "Regel toevoegen",
    send: "Versturen",
    send_email: "Verstuur per e-mail",
    sent: "Verzonden",
    open: "Open",
    view: "Bekijken",
    sales: "Losse verkopen",
    new_sale: "Nieuwe verkoop",
    date: "Datum",
    needs_attention: "Plekken die aandacht nodig hebben",
    mark_free: "Markeer als vrij",
    no_data: "Geen gegevens",
    settings: "Instellingen",
    camping_map: "Campingkaart",
    upload_map: "Kaart uploaden",
    logged_in_as: "Ingelogd als",
    select_guest: "Selecteer gast",
    select_pitch: "Selecteer plek",
    saved: "Opgeslagen",
    use: "gebruiken",
    move_from: "Van locatie",
    move_to: "Naar locatie",
    move_pick_free: "Kies een vrije locatie",
    move_none_free: "Geen vrije locaties in deze zone",
    move_all_zones: "Alle zones",
    move_reason: "Reden van de verhuis",
    invoice_mark_paid: "Betaald afvinken",
    invoice_unpay: "Terug op open zetten",
    invoice_marked_paid: "Factuur op betaald gezet",
    invoice_paid_today: "De betaaldatum wordt vandaag.",
    payment_method: "Betaalwijze",
    pay_cash: "Cash",
    pay_card: "Kaart",
    pay_transfer: "Overschrijving",
    pay_other: "Andere",
    move_free_whole_stay: "De lijst toont enkel plaatsen die vrij blijven tot het einde van dit verblijf.",
    move_reason_default: "Op verzoek van de klant",
    invoice_delivery_ask: "Wil je deze factuur afdrukken of doormailen naar de gast?",
    invoice_print_and_mail: "Afdrukken én mailen",
    invoice_later: "Later regelen",
    invoice_mailed: "Factuur gemaild naar de gast",
    setup_login_style: "Aanmeldscherm",
    setup_reminder_days: "Betaalherinnering na (dagen)",
    setup_reminder_repeat: "Herinnering herhalen na (dagen)",
    setup_reminder_max: "max. aantal",
    setup_reminder_repeat_hint: "Na de eerste herinnering volgt er pas opnieuw één na dit aantal dagen. Vul 0 in bij 'max. aantal' om onbeperkt te blijven herinneren.",
    setup_reminder_enabled: "Automatisch versturen",
    setup_overdue_reminder: "Herinnering te-late gasten",
    setup_display: "Buitenscherm aan de ingang",
    setup_demo: "Demo",
    setup_demo_on: "Demo-gegevens toelaten",
    setup_demo_on_ok: "Demo staat aan — op elk operationeel scherm staat nu een rode knop",
    demo_fill_label: "Demo-bezetting",
    demo_fill_hint: "Demo: vul de camping willekeurig met demo-plaatsen tot het gewenste % bezet en % gereserveerd (zonder klant). Verdwijnt bij Demo uit.",
    demo_fill_occupied: "% bezet",
    demo_fill_reserved: "% gereserveerd",
    demo_fill_apply: "Toepassen",
    demo_fill_reset: "Wissen",
    demo_fill_sum_err: "Bezet + gereserveerd mag samen niet meer dan 100% zijn",
    demo_fill_done: "Demo-bezetting bijgewerkt — {b} bezet, {r} gereserveerd bij",
    setup_demo_off_ok: "Demo uit, alle demo-gegevens verwijderd",
    setup_demo_purge_confirm: "Dit verwijdert {n} demo-gegevens (gasten, reservaties, facturen, verkopen, verhuringen, beoordelingen). Doorgaan?",
    setup_demo_hint: "Staat dit aangevinkt, dan verschijnt op elk operationeel scherm (nooit in Admin) rechtsonder een rode knop. Elke druk maakt op dat scherm 1 dummy-gegeven bij, zodat je in bulk kan testen. Bij het uitvinken worden alle demo-gegevens weer verwijderd.",
    setup_demo_allowed: "Demo toestaan voor deze camping",
    setup_demo_allowed_hint: "Enkel de hoofdbeheerder kan demo toestaan. Zolang dit uit staat, ziet deze camping niets van de demo-functies.",
    setup_demo_unavailable: "Demo is niet beschikbaar voor deze camping. Vraag de hoofdbeheerder om het in te schakelen.",
    pitch_continue: "Doorgaan",
    dummy_add: "Demo bijmaken",
    dummy_added: "Demo-gegeven bijgemaakt",
    dummy_added_bulk: "Demo-gegevens bijgemaakt",
    dummy_add_hint: "Kort indrukken = 1 demo-gegeven bij, lang indrukken = 10 in één keer",
    demo_banner: "Demo-modus actief — bijgemaakte gegevens worden gewist zodra je het vinkje weghaalt",
    demo_banner_count: "demo-gegevens",
    setup_display_none: "Nog geen code — klik op 'Nieuwe code'",
    setup_display_copy: "Kopieer",
    setup_display_copied: "Link gekopieerd",
    setup_display_mismatch: "Let op: je werkt nu in {work}, maar dit webadres hoort bij {host}. Het buitenscherm volgt altijd het webadres — schakel eerst over naar {host} (Admin → Campings → Werk in deze camping) en laad daar het logo en de openingsuren op.",
    setup_display_new: "Nieuwe code",
    setup_display_new_ok: "Nieuwe code aangemaakt — oude link werkt niet meer",
    setup_display_hint: "Open deze link op de tv of tablet buiten: toont 'welkom' en het aantal vrije plaatsen in 25 talen. Groen onder 90% bezetting, oranje boven 90%, rood met 'VOLZET' boven 98%. Vernieuwt zichzelf live bij elke wijziging.",
    setup_overdue_reminder_hint: "Elke ochtend om 09:00 een vriendelijke mail (en sms zodra Spryng actief is) naar gasten die hun vertrekdatum voorbij zijn — maximaal één per dag.",
    setup_interim_reminder: "Herinnering tussentijdse afrekening (dagen)",
    setup_interim_reminder_hint: "Stuurt de gast automatisch een vriendelijke mail wanneer de laatste tussentijdse afrekening (of de aankomst) langer dan dit aantal dagen geleden is. Loopt mee met de dagelijkse herinneringen om 09:00.",
    setup_interim_auto: "Automatische tussentijdse factuur (min. dagen)",
    setup_interim_auto_hint: "Maakt maandelijks automatisch een tussentijdse factuur aan voor gasten die langer verblijven dan dit aantal dagen. Alleen de nieuwe periode sinds de vorige afrekening wordt aangerekend, openstaande verkopen en voorschotten worden mee verrekend en de PDF wordt als bijlage gemaild. Loopt mee om 09:00.",
    setup_reminder_hint: "Elke ochtend krijgt een gast met een openstaande factuur een vriendelijke herinnering met de factuur-PDF. Daarna wordt dit maximaal wekelijks herhaald.",
    setup_dunning: "Betaalherinneringen (aanmaningen)",
    setup_dunning_hint: "Verstuurt automatisch betaalherinneringen voor openstaande facturen, met de factuur als PDF-bijlage en in de taal van de gast. Loopt elke ochtend om 09:00.",
    setup_dunning_tiers: "Aanmaningen na (dagen): 1e · 2e · 3e",
    setup_dunning_tiers_hint: "Drie opeenvolgende aanmaningen met oplopende toon: een vriendelijke herinnering (1e), een duidelijke aanmaning (2e) en een laatste aanmaning (3e). Standaard na 15, 30 en 45 dagen. Per factuur wordt elke trap hoogstens één keer verstuurd.",
    invoice_reminders_run: "Herinneringen nu versturen",
    invoice_reminders_done: "Herinneringen verstuurd",
    dunning_label: "Aanmaningen",
    dunning_none: "Nog geen aanmaning verstuurd",
    dunning_tier_name_1: "1e herinnering",
    dunning_tier_name_2: "2e aanmaning",
    dunning_tier_name_3: "Laatste aanmaning",
    dunning_overdue: "dagen te laat",
    dunning_filter_label: "Filter op aanmaning:",
    dunning_filter_all: "Alle",
    dunning_customer_number: "Klantnummer",
    dunning_report_summary_title: "Overzicht aanmaningen",
    dunning_report_incasso_title: "Incassodossier",
    dunning_report_generated: "Opgemaakt op",
    dunning_stays: "Verblijven",
    dunning_total_due: "Totaal openstaand",
    dunning_print_summary: "Overzicht afdrukken",
    dunning_print_incasso: "Incassodossier afdrukken",
    setup_login_style_sober: "Zakelijk",
    setup_login_style_original: "Origineel (foto)",
    setup_login_style_scene3d: "3D-scène",
    demo_reset: "Demo herstellen",
    demo_reset_confirm: "De demodata van Camping CampAd Pro volledig terugzetten?",
    demo_reset_done: "Demo-omgeving hersteld",
    meter_reading: "Meterstand elektriciteit",
    meter_arrival: "Meterstand bij aankomst (kWh)",
    meter_now: "Huidige meterstand",
    meter_start_label: "Beginstand",
    meter_consumption: "Verbruik",
    meter_last_known: "Laatst gekende stand",
    meter_last_unknown: "Nog geen meterstand gekend",
    meter_recalc: "Herbereken",
    tariff_power: "Elektriciteit",
    tariff_power_desc: "Tarief per kWh voor het verbruik tussen de meterstanden. Per periode kan een ander kWh-tarief ingesteld worden.",
    tariff_kwh_price: "Prijs per kWh",
    tariff_mode_month: "Per begonnen maand",
    tariff_mode_month_prorata: "Per maand, pro rata per dag",
    deleted: "Verwijderd",
    created: "Aangemaakt",
    doc_language: "Documenttaal",
    interim_billing: "Tussentijdse afrekening",
    checked_in_guests: "Ingecheckte gasten",
    create_invoice_for: "Factuur maken voor",
    total_pitches: "Totaal plekken",
    edit_layout: "Plaatsen verplaatsen",
    editing_layout: "Sleep de markeringen naar de juiste plek op de kaart",
    done: "Klaar",
    reset_positions: "Standaardposities",
    assign_guest: "Gast koppelen",
    occupied_by: "Bezet door",
    none_selected: "Geen",
    flags: "Markeringen",
    parking_capacity: "Capaciteit",
    parking_occupied: "Bezet",
    accommodation: "Accommodatie",
    zoom_in: "Inzoomen",
    zoom_out: "Uitzoomen",
    map_hint: "Klik op een plek voor details · bij bezetting zie je de gastnaam als je erover beweegt",
    map_help: "Uitleg kaart",
    handover_today: "Overdracht vandaag",
    map_update: "Kaart update",
    map_update_desc: "Plaatsen aanmaken, op de kaart plaatsen, verslepen of verwijderen (enkel vrije plaatsen).",
    new_pitch: "Nieuwe plaats aanmaken",
    zone: "Zone",
    number: "Nummer",
    label_optional: "Label (optioneel)",
    label_optional_hint: "Eigen naam voor één losse plaats, bv. T20X. Dan geen reeks mogelijk.",
    type: "Type",
    shape: "Vorm",
    color: "Kleur",
    add: "Toevoegen",
    kind_pitch: "Standplaats",
    kind_bungalow: "Bungalow",
    kind_cabin: "Hut",
    shape_circle: "Rond",
    shape_square: "Vierkant",
    shape_diamond: "Ruit",
    unplaced_pitches: "Nog te plaatsen — sleep naar de kaart",
    unplaced_empty: "Alle plaatsen staan op de kaart.",
    pitch_created: "Plaats aangemaakt — sleep ze nu op de kaart",
    delete_only_free: "Alleen vrije plaatsen kunnen verwijderd worden",
    zoom_hint: "scrollen met de muis om te zoomen",
    fit_width: "Passend in de breedte",
    fit_height: "Passend in de hoogte",
    total_occupancy: "Totale bezetting",
    totals: "Totalen",
    red_ribbons: "Rode lintjes",
    red_ribbons_total: "Totaal aantal rode lintjes (voorraad)",
    print: "Afdrukken",
    print_map: "Kaart afdrukken (A4)",
    print_plus: "Print+",
    print_plus_title: "Print+ · kaart + reservatie",
    print_plus_desc: "Registreer de aankomst: we zoeken de klant op (mailadres eerst), maken meteen een voorlopige reservatie aan en drukken de kaart met het invulformulier af. De gast kan de vragenlijst later zelf aanvullen via de app.",
    print_plus_confirm: "Print + reservatie",
    existing_guest_found: "Bestaande klant gevonden — gegevens ingevuld",
    reservation_created: "Voorlopige reservatie aangemaakt",
    print_plus_send_card: "Invulkaart + plattegrond meteen naar de gast mailen",
    card_sent_to: "Invulkaart gemaild naar {email}",
    card_mailed: "Kaart gemaild",
    confirm_long_stay: "De periode is langer dan 6 maanden — bevestig dat dit klopt.",
    check: "Zoek",
    print_planning: "Planning afdrukken (A3)",
    print_planning_desc: "Kies de maand. De planning wordt liggend op A3 afgedrukt, klaar om achter de balie te hangen.",
    month: "Maand",
    same_pitch: "zelfde plaats",
    linked_stays: "Aansluitende verblijven",
    chain_all_booking: "Alles als boeking",
    merge_stays: "Samenvoegen",
    jump_search: "Plaats, gast, nummerplaat, tel of e-mail…",
    act_merge: "samengevoegd",
    undo: "Ongedaan maken",
    redo: "Opnieuw uitvoeren",
    act_quick_booking: "snelle reservatie",
    act_quick_checkin: "snelle boeking",
    act_move: "verplaatsen",
    act_resize: "duur aangepast",
    act_split: "gesplitst",
    act_move_split: "verhuisd",
    act_chain_checkin: "alles als boeking",
    move_date: "Verhuisdatum",
    split_move_desc: "Dubbelklik op een balk om vanaf een bepaalde dag te verhuizen. Het verblijf wordt gesplitst: de oude plaats blijft in de historiek staan.",
    history: "Historiek",
    planning_month_title: "Maandplanning",
    broken_block_legend: "Loopt door buiten de maand",
    print_period_desc: "Geef de verwachte verblijfsperiode op. Onder de kaart komt een overzicht van de vrije plaatsen per zone in die periode.",
    from: "Van",
    to: "Tot",
    period: "Periode",
    free_pitches_period: "Vrije plaatsen in de periode",
    total: "Totaal",
    admin_interfaces: "Interfaces",
    maint_ses: "SES.HOSPEDAJES — niet-conforme verblijven",
    maint_ses_hint: "Reservaties en verblijven waarvan de verplichte reizigersgegevens (geboortedatum, document, adres, herkenbaar land, contact) ontbreken, kunnen niet aan de Guardia Civil gemeld worden. Opruimen verwijdert deze reservaties en zet hun plaatsen op vrij. Gasten blijven bewaard.",
    maint_ses_now: "Niet-conforme verblijven verwijderen en plaatsen vrijzetten",
    maint_ses_confirm: "Alle vermelde reservaties worden definitief verwijderd en de plaatsen vrijgezet. Doorgaan?",
    nav_interfaces: "Interfaces",
    iface_tab_overheid: "Overheid",
    iface_tab_boekhouding: "Boekhouding",
    credit_note: "Creditnota",
    credit_note_confirm: "Een creditnota aanmaken voor deze factuur? De factuur wordt daarna vergrendeld.",
    credit_note_created: "Creditnota aangemaakt:",
    credited: "Gecrediteerd",
    edit_invoice: "Factuur bewerken",
    accounting_locked: "Doorgestuurd naar de boekhouding — vergrendeld",
    acc_manual_export: "Handmatige export",
    acc_automate: "Automatiseren",
    acc_selection: "Selectie",
    acc_documents: "document(en)",
    acc_csv_sep: "CSV-scheiding",
    acc_csv_sep_hint: "Scheidingsteken voor CSV (bv. ; of ,)",
    acc_format: "Formaat downloaden",
    acc_export_note: "Een handmatige export markeert de documenten als 'verstuurd'; nadien zijn ze vergrendeld.",
    acc_export_done: "Export gedownload",
    acc_export_empty: "Geen documenten in deze selectie",
    acc_scope_unsent: "Nog niet verstuurd",
    acc_scope_week: "Deze week",
    acc_scope_quarter: "Dit kwartaal",
    acc_scope_year: "Dit jaar",
    fmt_text: "Platte tekst",
    acc_trigger: "Trigger",
    acc_trigger_manual: "Handmatig",
    acc_trigger_daily: "Dagelijks automatisch",
    acc_trigger_weekly: "Wekelijks automatisch",
    acc_trigger_quarterly: "Per kwartaal automatisch",
    acc_destinations: "Bestemmingen",
    acc_vars_hint: "Variabelen in de omschrijving: {camping}, {datum}, {periode}, {aantal}",
    acc_sender: "Afzender",
    acc_recipient: "Bestemmeling",
    acc_description: "Omschrijving (met variabelen)",
    acc_path: "Map/pad",
    acc_user: "Gebruiker",
    acc_password: "Wachtwoord",
    acc_no_dest: "Nog geen bestemmingen ingesteld",
    acc_run_now: "Nu verzenden",
    acc_grp_documents: "Documenten",
    acc_grp_spreadsheets: "Rekenbladen",
    acc_grp_data: "Gegevens",
    acc_what_to_send: "Wat verzenden",
    acc_when: "Wanneer",
    acc_add_dest: "Bestemming toevoegen",
    acc_sent_now: "Verzonden",
    xm_title: "Zelf-gedefinieerde XML",
    xm_enable: "Zelf-gedefinieerde XML gebruiken",
    xm_enable_hint: "Vervangt de standaard-XML door je eigen veldnamen en structuur.",
    xm_structure: "XML-structuur",
    xm_root: "Hoofd-element",
    xm_doc_el: "Document-element",
    xm_line_wrap: "Regels-omhulsel",
    xm_line_el: "Regel-element",
    xm_sources: "Welke documenten",
    xm_src_invoices: "Facturen",
    xm_src_credits: "Creditnota's",
    xm_src_sales: "Verkopen op rekening",
    xm_xsd: "XSD-schema",
    xm_xsd_hint: "Upload een XSD om de doelveldnamen te kiezen. Zonder XSD typ je de namen zelf.",
    xm_xsd_upload: "XSD uploaden",
    xm_xsd_loaded: "velden gevonden",
    xm_not_in_xsd: "niet in XSD",
    fill_required: "Vul de blauw gemarkeerde verplichte velden in.",
    xm_xsd_clear: "XSD wissen",
    xm_doc_fields: "Documentvelden",
    xm_line_fields: "Regelvelden (per factuur-/verkoopregel)",
    xm_app_field: "App-veld",
    xm_xml_field: "XML-veldnaam",
    xm_add_row: "Veld koppelen",
    xm_pick: "Kies…",
    xm_preview: "Voorbeeld tonen",
    xm_preview_title: "XML-voorbeeld",
    xm_no_fields: "Nog geen velden gekoppeld",
    xm_autofill: "Alle velden invullen",
    accf_number: "Nummer",
    accf_doc_type: "Type document",
    accf_date: "Datum",
    accf_guest_name: "Klant",
    accf_guest_number: "Klantnummer",
    accf_vat_number: "Btw-nummer",
    accf_status: "Status",
    accf_payment_method: "Betaalwijze",
    accf_subtotal: "Subtotaal",
    accf_tax_rate: "Btw-tarief",
    accf_tax_amount: "Btw-bedrag",
    accf_total: "Totaal",
    accf_amount_due: "Te betalen",
    accf_currency: "Munt",
    accf_credit_of_number: "Creditnota van",
    accf_line_code: "Artikelcode",
    accf_line_description: "Omschrijving",
    accf_line_qty: "Aantal",
    accf_line_unit_price: "Eenheidsprijs",
    accf_line_vat_rate: "Btw-tarief (regel)",
    accf_line_total: "Regeltotaal",
    nav_mailbox: "Mailbox",
    mb_inbox: "Postvak IN",
    mb_sent: "Verzonden",
    mb_archive: "Archief",
    mb_trash: "Prullenbak",
    mb_search: "Zoek op afzender of onderwerp…",
    mb_new: "Nieuw bericht",
    mb_reply: "Beantwoorden",
    mb_forward: "Doorsturen",
    mb_send: "Verzenden",
    mb_to: "Aan",
    mb_subject: "Onderwerp",
    mb_message: "Bericht",
    mb_sent_ok: "Bericht verzonden",
    mb_moved: "Bericht verplaatst",
    mb_mark_unread: "Markeer als ongelezen",
    mb_empty: "Geen berichten in deze map",
    mb_pick: "Kies een bericht om te lezen",
    mb_no_access: "Je hebt geen toegang tot de gedeelde mailbox. Vraag een beheerder om 'Mailbox toegang' aan te vinken.",
    mb_not_configured: "De gedeelde receptie-mailbox is nog niet ingesteld. Een beheerder kan dit doen bij Admin > Mail & SMS.",
    mb_known_guest: "Gekende gast",
    mb_provisional: "voorlopig",
    mb_open_guest: "Open gastenfiche →",
    mb_signature_hint: "Wordt ondertekend als {name} namens de camping.",
    mb_quote_hint: "Het originele bericht wordt eronder geciteerd.",
    mb_forward_hint: "Het originele bericht wordt als bijlage meegestuurd.",
    mb_emails_of_guest: "E-mails van deze gast",
    imap_title: "Inkomende receptie-mailbox (IMAP) — ontvangen & lezen",
    imap_desc: "Enkel voor het ontvangen en lezen van gastmails in CampAd Pro. Het versturen van antwoorden gebeurt via de uitgaande mailserver (SMTP) hierboven en wordt bewaard in de map Verzonden.",
    imap_enabled: "Receptie-mailbox inschakelen (inkomend/IMAP)",
    imap_host: "IMAP-server",
    imap_sent: "Map Verzonden",
    imap_archive: "Map Archief",
    imap_trash: "Map Prullenbak",
    imap_test_ok: "Verbinding geslaagd",
    imap_folders: "Mappen",
    mb_do_search: "Zoeken",
    mb_unanswered: "Onbeantwoorde mails",
    mb_unread: "Ongelezen mails",
    mb_templates: "Antwoordsjablonen",
    mb_quick_reply: "Snel antwoord",
    mb_pick_template: "Kies een sjabloon…",
    mb_tpl_name: "Naam",
    mb_tpl_new: "Nieuw sjabloon",
    mb_tpl_delete_confirm: "Dit sjabloon verwijderen?",
    mb_tpl_placeholders: "Beschikbare velden",
    mb_make_reservation: "Reservering aanmaken",
    mb_from_mail: "Vanuit e-mail",
    mb_pitch_type: "Type plaats",
    mb_dogs: "hond(en)",
    mb_emails: "E-mails",
    mb_no_email: "Deze gast heeft geen e-mailadres.",
    mb_none_with_guest: "Nog geen e-mails gewisseld met deze gast.",
    guest_data: "Gegevens",
    mb_prefilled: "Gegevens van de afzender zijn ingevuld — kies een plaats en de data en bewaar als voorlopig.",
    mb_review_title: "Reservatie uit e-mail",
    mb_review_hint: "Controleer de gegevens uit de mail en vul aan waar nodig.",
    mb_ask_info: "Vraag meer info",
    mb_still_needed: "nog nodig",
    mb_not_booking_warn: "De AI herkende dit niet duidelijk als een reservatie-aanvraag.",
    mb_requested_pitch: "Gevraagde plaats",
    avail_green: "Beschikbaar",
    avail_orange: "Beschikbaar mits verhuis",
    avail_red: "Niet beschikbaar",
    avail_unknown: "Onbekende plaats",
    avail_checking: "Beschikbaarheid controleren…",
    avail_need_dates: "Vul aankomst en vertrek in voor de beschikbaarheid.",
    avail_alts: "Vrije plaatsen in zone {zone}:",
    avail_no_alts: "Geen vrije plaatsen in dezelfde zone.",
    avail_move_on: "Op {date}: verhuizen van plaats {from} naar {to}",
    move_plan_title: "Verhuisplan wordt mee aangemaakt",
    move_plan_single: "Toch één plaats",
    move_plan_moves: "verhuizing(en) ingepland",
    admin_vat: "BTW-overzicht",
    admin_vat_desc: "Verschuldigde BTW per kwartaal (verkopen, facturen, voorschotten) met aankoop-BTW en saldo.",
    incl_vat: "Incl. BTW",
    saldo: "Saldo",
    vat_due: "Verschuldigde BTW",
    vat_input: "Aankoop-BTW",
    vat_to_pay: "Te betalen",
    vat_to_reclaim: "Terug te vorderen",
    vat_deposit_note: "Voorschotten staan apart en worden verrekend in de facturen (niet in het saldo).",
    vat_input_note: "Aankoop-BTW komt uit voorraad-aankopen én vrije kostenregels (Beheer → Kosten).",
    admin_expenses: "Kosten",
    admin_expenses_desc: "Algemene aankopen (energie, onderhoud…) met bedrag + BTW%, tellen mee in de aankoop-BTW.",
    expense_new: "Nieuwe kost",
    expenses_hint: "Voeg hier algemene kosten toe (energie, onderhoud, verzekeringen…). De BTW telt mee in het BTW-overzicht.",
    expense_desc_ph: "bv. Elektriciteit, onderhoud zwembad…",
    interim_last: "Laatste afrekening",
    interim_due: "Nieuwe afrekening aanbevolen",
    invoices_unpaid: "Onbetaald",
    invoices_paid: "Betaald",
    no_unpaid_invoices: "Geen onbetaalde facturen.",
    no_paid_invoices: "Nog geen betaalde facturen.",
    u_mailbox_access: "Mailbox toegang",
    u_mailbox_hint: "Mag de gedeelde receptie-mailbox lezen en beantwoorden (beheerders altijd).",
    ses_send_interval: "Bundelen per",
    ses_interval_0: "Meteen verzenden",
    ses_send_interval_hint: "Met een bundelinterval worden meldingen gegroepeerd (bv. elk half uur of uur) zodat de dienst niet overbelast raakt.",
    ses_will_send_at: "Wordt verzonden om",
    ovw_ok: "De meldingen lopen automatisch. Geen openstaande problemen.",
    ovw_attention: "Er zijn meldingen die aandacht vragen (geweigerd of over de termijn).",
    ovw_disabled: "De interface staat uit — er wordt niets gemeld.",
    ovw_manual: "Automatisch verzenden staat uit — een beheerder verzendt handmatig.",
    ovw_manage: "Beheren",
    ovw_next_send: "Volgende verzending",
    ovw_recent: "Recente meldingen",
    iface_accounting: "Boekhouding",
    xls_desc: "Exporteer gegevens als Excel-bestand (.xlsx) om ze te delen of verder te verwerken.",
    xls_pitches: "Locaties en bezetting",
    xls_pitches_desc: "Alle plaatsen met wie er zit of komt, van wanneer tot wanneer.",
    xls_finance: "Financieel in en uit",
    xls_finance_desc: "Verkopen, betaalde facturen, inkopen en afstortingen in de gekozen periode, met aparte kolommen voor cash en kaart.",
    xls_download: "Excel downloaden",
    xls_done: "Excel-bestand gedownload",
    ses_checkin_title: "Melding Guardia Civil",
    ses_checkin_missing: "deze gegevens zijn nog nodig vóór het inchecken",
    ses_checkin_ok: "alle reizigersgegevens zijn volledig",
    provisional_list: "Voorlopige boekingen",
    maint_ses_done: "Eenmalige opruiming uitgevoerd op",
    setup_provisional_reminder: "Herinnering voorlopige boeking (dagen vóór aankomst)",
    setup_provisional_reminder_hint: "Gasten met een nog voorlopige boeking krijgen zoveel dagen vóór aankomst automatisch een e-mail met een link om hun gegevens zelf aan te vullen; daarna is de boeking definitief.",
    send_complete_link: "Aanvul-link mailen",
    complete_link_sent: "Aanvul-link verstuurd naar",
    extend_complete_link: "Link verlengen (+24u)",
    complete_link_extended: "Link verlengd en opnieuw verstuurd naar",
    completion_complete: "100% ingevuld",
    completion_incomplete: "Onvolledig",
    link_expired: "Aanvul-link verlopen — verleng of verstuur opnieuw",
    send_confirmation_card: "Bevestigingskaart mailen",
    confirmation_card_sent: "Bevestigingskaart verstuurd naar",
    admin_loginlog: "Aanmeldlogboek",
    admin_loginlog_desc: "Geblokkeerde en mislukte aanmeldpogingen per dag, met IP-adres — zo zie je hoeveel bots tegengehouden worden.",
    admin_audit: "Wijzigingslogboek",
    admin_audit_desc: "Wie heeft welke gebruiker gewijzigd, en wanneer. Zo zie je precies wat elke beheerder aanpaste.",
    audit_when: "Tijdstip",
    audit_actor: "Wie",
    audit_action: "Actie",
    audit_target: "Betrokken gebruiker",
    audit_details: "Details",
    audit_none: "Geen wijzigingen in deze periode",
    audit_all_actions: "Alle acties",
    audit_search: "Zoek op e-mail…",
    audit_activated: "Geactiveerd",
    audit_deactivated: "Gedeactiveerd",
    audit_a_user_created: "Gebruiker aangemaakt",
    audit_a_user_updated: "Gebruiker gewijzigd",
    audit_a_user_active_changed: "Actief gewijzigd",
    audit_a_user_password_reset: "Wachtwoord teruggezet",
    audit_a_settings_updated: "Instellingen gewijzigd",
    audit_a_tariff_updated: "Tarief gewijzigd",
    audit_a_reservation_created: "Reservatie aangemaakt",
    audit_a_reservation_updated: "Reservatie gewijzigd",
    audit_a_reservation_extended: "Reservatie verlengd",
    audit_a_reservation_moved: "Reservatie verplaatst",
    audit_a_reservation_checkin: "Ingecheckt",
    audit_a_reservation_deleted: "Reservatie verwijderd",
    audit_a_sale_created: "Verkoop aangemaakt",
    audit_a_sale_deleted: "Verkoop verwijderd",
    audit_a_cash_closed: "Kassa afgesloten",
    audit_a_cash_deposit_created: "Afstorting",
    audit_a_cash_deposit_cancelled: "Afstorting geannuleerd",
    audit_stat_today: "Vandaag",
    audit_stat_week: "Deze week (7 dagen)",
    audit_stat_by_actor: "Per medewerker (30 dagen)",
    audit_export_csv: "CSV",
    audit_export_pdf: "PDF",
    ll_total: "Pogingen",
    ll_bots: "Bots geblokkeerd",
    ll_period: "Periode",
    ll_since: "sinds",
    ll_per_day: "Per dag",
    ll_per_ip: "Per IP-adres",
    ll_recent: "Recente pogingen",
    ll_none: "Geen geblokkeerde pogingen in deze periode.",
    ll_last: "Laatste",
    ll_when: "Wanneer",
    ll_reason: "Reden",
    ll_identifier: "Gebruikersnaam",
    ll_honeypot: "Honeypot (bot)",
    ll_too_fast: "Te snel (bot)",
    ll_challenge: "Puzzel mislukt (bot)",
    ll_turnstile: "Turnstile geweigerd",
    ll_ip_locked: "IP geblokkeerd",
    ll_account_locked: "Account geblokkeerd",
    ll_wrong_password: "Fout wachtwoord",
    ll_block: "Blokkeren",
    ll_unblock: "Vrijgeven",
    ll_blocked: "Geblokkeerd:",
    ll_unblocked: "Vrijgegeven:",
    ll_blocked_badge: "GEBLOKKEERD",
    ll_blocklist: "Permanent geblokkeerde IP-adressen",
    ll_ip_blocklist: "Blokkeerlijst (bot)",
    ll_day_title: "Aanmeldingen per dag",
    ll_ok: "geslaagd",
    ll_failed: "mislukt",
    ll_day_none: "Geen aanmeldingen op deze dag.",
    ll_login_ok: "Aangemeld",
    ll_out: "afgemeld/pauze",
    ll_logout: "Afgemeld",
    ll_logout_auto: "Automatisch afgemeld",
    ll_pause: "Pauze",
    hours_day: "Dag",
    hours_total: "Totaal",
    hours_day_none: "Niemand aangemeld op deze dag.",
    hours_open: "nog aangemeld",
    hours_reason_logout: "Afgemeld",
    hours_reason_break: "Pauze",
    hours_reason_idle: "Automatisch afgesloten",
    hours_reason_auto: "Automatisch afgesloten",
    hours_reason_manual: "Handmatig ingevoerd",
    hours_reason_open: "Nog aangemeld",
    hours_break: "Pauze",
    hours_no_break: "geen pauze",
    hours_no_break_hint: "Meer dan 6 uur gewerkt zonder pauze",
    idle_warn_title: "Nog aangemeld blijven?",
    idle_warn_text: "Je wordt automatisch afgemeld over",
    idle_stay: "Aangemeld blijven",
    draft_found: "Onafgewerkte reservatie teruggevonden",
    draft_saved_at: "Automatisch bewaard bij afmelden op",
    draft_resume: "Hervatten",
    draft_discard: "Weggooien",
    draft_resumed: "Concept hervat — ga verder waar je gebleven was",
    draft_found_other: "Onafgewerkte reservatie van",
    draft_take: "Overnemen en afwerken",
    draft_taken_title: "Jouw concept is afgewerkt",
    draft_taken_text: "je onafgewerkte reservatie werd overgenomen door",
    admin_interfaces_desc: "Koppelingen met externe diensten: overheid (Guardia Civil), boekhouding en andere pakketten.",
    iface_available: "Beschikbaar",
    iface_soon: "Binnenkort",
    iface_open: "Open",
    iface_on: "Ingeschakeld",
    iface_off: "Uitgeschakeld",
    iface_pending: "In behandeling",
    iface_rejected: "Geweigerd",
    iface_last_sent: "Laatst verzonden",
    iface_never: "nog nooit",
    iface_back: "Alle interfaces",
    ses_title: "SES.HOSPEDAJES",
    ses_subtitle: "Registro de viajeros · Ministerio del Interior · Real Decreto 933/2021",
    ses_tab_settings: "Instellingen",
    ses_tab_files: "Bestanden",
    ses_tab_log: "Logboek",
    ses_readonly: "Alleen lezen — wijzigen vereist financiële klasse 5.",
    ses_enabled: "Interface actief",
    ses_mode: "Omgeving",
    ses_mode_test: "Test (preproductie)",
    ses_mode_live: "Productie (live)",
    ses_mode_hint: "Nooit beide tegelijk: alle meldingen gaan naar de gekozen omgeving. Productie vereist volledige productiegegevens.",
    ses_codes: "SES-identificatie",
    ses_arrendador: "codigoArrendador (exploitant)",
    ses_establecimiento: "codigoEstablecimiento (vestiging)",
    ses_aplicacion: "Naam van de toepassing (aplicacion)",
    ses_creds_test: "Webservice-gebruiker — test",
    ses_creds_live: "Webservice-gebruiker — productie",
    ses_user: "Gebruikersnaam",
    ses_password: "Wachtwoord",
    ses_pw_set: "ingesteld",
    ses_events: "Gebeurtenissen die een melding maken",
    ses_ev_rh: "Reservaties (RH)",
    ses_ev_rh_desc: "Nieuwe of gewijzigde reservatie → reserveringsmelding.",
    ses_ev_pv: "Aankomend (PV)",
    ses_ev_pv_desc: "Check-in → aankomstregistratie met alle reizigers.",
    ses_ev_cancel: "Annuleringen (B)",
    ses_ev_cancel_desc: "Verwijderde reservatie → annulering van de aanvaarde melding.",
    ses_sending: "Verzending",
    ses_auto_send: "Automatisch verzenden",
    ses_send_time: "Verzenduur (Europe/Madrid)",
    ses_send_time_hint: "Alles wordt op dit uur verzonden; wat daarna tot 24:00 nog wijzigt gaat meteen. Leeg = alles meteen.",
    ses_max_batch: "Max. meldingen per aanvraag",
    ses_payment: "Standaard betaalwijze (TIPO_PAGO)",
    ses_mail_to: "Standaard e-mailadres voor bestanden",
    ses_access: "Toegang",
    ses_reception_files: "Receptie mag bestanden bekijken en mailen",
    ses_endpoints: "Endpoints (v3.1.2)",
    ses_files_desc: "Elke melding is een XML-bestand. Verzonden bestanden zijn onveranderlijk; een correctie = annulering + nieuwe versie.",
    ses_filter_all: "Alles",
    ses_filter_open: "Openstaand",
    ses_filter_accepted: "Aanvaard",
    ses_filter_rejected: "Geweigerd",
    ses_search: "Zoek op gast of plaats…",
    ses_col_file: "Bestand",
    ses_col_content: "Inhoud",
    ses_col_status: "Status",
    ses_col_created: "Aangemaakt",
    ses_late: "Over de 24u-termijn",
    ses_process_now: "Wachtrij nu verwerken",
    ses_check_now: "Status opvragen",
    ses_st_incomplete: "Onvolledig",
    ses_st_ready: "Klaar",
    ses_st_sending: "Bezig met verzenden",
    ses_st_received: "Ontvangen (batch)",
    ses_st_processing: "In verwerking",
    ses_st_accepted: "Aanvaard",
    ses_st_rejected: "Geweigerd",
    ses_st_uncertain: "Onzeker",
    ses_st_cancel_requested: "Annulering aangevraagd",
    ses_st_cancelled: "Geannuleerd",
    ses_st_withdrawn: "Ingetrokken",
    ses_missing: "Ontbrekende gegevens",
    ses_view: "Bekijken",
    ses_xml: "XML-inhoud",
    ses_edit: "Bewerken",
    ses_save_xml: "XML opslaan",
    ses_send: "Nu verzenden",
    ses_resend: "Opnieuw verzenden",
    ses_rebuild: "Opnieuw opbouwen uit de reservatie",
    ses_cancel: "Annuleren bij SES",
    ses_withdraw: "Intrekken",
    ses_download: "Downloaden",
    ses_mail: "Mailen",
    ses_mail_to_label: "Naar",
    ses_mail_lang: "Taal van het bericht",
    ses_mail_note: "Opmerking (optioneel)",
    ses_mail_send: "Verzenden per e-mail",
    ses_mailed: "Gemaild",
    ses_batch: "Batch (lote)",
    ses_codigo: "Communicatiecode",
    ses_error: "Fout",
    ses_version: "Versie",
    ses_deadline: "Uiterlijk",
    ses_by: "door",
    ses_log_desc: "Alles wat de interface doet, chronologisch.",
    ses_mode_badge_test: "TEST",
    ses_mode_badge_live: "LIVE",
    ses_no_creds: "Zonder toegangsgegevens blijven bestanden op \"Klaar\" staan tot ze ingevuld zijn.",
    ses_immutable: "Verzonden bestand — onveranderlijk",
  },
  en: {
    app_name: "CampAd Pro",
    admin_camping: "Campsite",
    admin_camping_desc: "Campsite details",
    admin_map: "Site plan",
    admin_map_desc: "Map and pitches",
    admin_stock: "Stock",
    admin_stock_desc: "Articles and deliveries",
    articles: "Articles",
    new_article: "New article",
    art_code: "Code",
    art_name: "Name",
    art_category: "Category",
    art_unit: "Unit",
    art_stock: "Stock",
    art_min_stock: "Minimum stock",
    art_track_stock: "Track stock",
    art_lines: "Lines",
    unit_stuk: "piece",
    unit_liter: "litre",
    unit_kg: "kg",
    unit_meter: "metre",
    unit_pak: "pack",
    unit_uur: "hour",
    unit_dienst: "service",
    excl_vat: "excl. VAT",
    price_incl_vat: "Total incl. VAT",
    bill_to: "Billing details",
    billing_details: "Billing details",
    articles_lines: "Articles",
    print_invoice: "Print invoice",
    printed: "Printed",
    not_printed: "Not printed",
    sale_open_title: "Sale not finished yet:",
    sale_open_hint: "print the invoice first or cancel the sale before starting a new one.",
    cancel_sale: "Cancel sale",
    art_price: "Price",
    art_vat: "VAT %",
    art_qty: "Quantity",
    rental_report: "Rental revenue per month",
    rental_report_empty: "No rentals in this year yet.",
    rental_times_out: "times out",
    deposits_cash: "Deposits in till",
    cash_expected: "Expected in till",
    nav_verhuur: "Rentals",
    rental_out_today: "To hand out today",
    rental_back_today: "Expected back today",
    rental_out_now: "Currently out",
    rental_overdue: "Overdue",
    rental_deposit_todo: "Deposit to collect",
    rental_deposit_open: "Deposit outstanding",
    deposit: "Deposit",
    deposit_paid: "Deposit paid",
    deposit_open: "Deposit outstanding",
    deposit_resend: "Resend payment link",
    deposit_resend_q: "Resend payment link?",
    deposit_resend_hint: "We will e-mail {name} again with the Stripe payment link for the deposit of {amount}.",
    deposit_resend_sent: "Payment link resent to",
    amount_due: "Amount due",
    admin_prepayments: "Prepayments",
    admin_prepayments_desc: "Overview of online deposits received per period for accounting.",
    deposit_settled: "Settled",
    deposit_unsettled: "To settle",
    by_month: "By month",
    by_week: "By week",
    no_deposits_year: "No deposits in this year.",
    per_year: "By year",
    per_quarter: "Quarter",
    custom_range: "Custom",
    pick_range_hint: "Pick a from and to date to show the report.",
    vat_breakdown: "Breakdown per declaration period",
    btw: "VAT",
    drilldown_hint: "Click to show the underlying deposits",
    showing: "Showing",
    show_all: "Show all",
    yes: "Yes",
    no: "No",
    deposit_received: "Deposit received",
    deposit_refund: "Refunded",
    deposit_refunded: "deposit refunded",
    admin_revenue: "Revenue per month",
    admin_revenue_desc: "Pitches, tourist tax, rentals and shop together per month. Invoices from before this version appear under 'Other'.",
    rev_pitch: "Pitches", rev_tax: "Tourist tax", rev_rental: "Rentals", rev_shop: "Shop", rev_other: "Other", rev_total: "Total",
    deposit_receipt: "Deposit receipt",
    admin_rentals: "Rentals",
    admin_rentals_desc: "Items you rent out (fridge, cot…) with price, deposit and description in every language.",
    admin_tariffs: "Tariffs",
    group_daily: "Daily",
    group_billing: "Accounting",
    group_manage: "Management",
    collapse: "Collapse",
    theme_dark: "Dark mode",
    theme_light: "Light mode",
    theme_auto_hint: "Evening shift: follows the campsite's sunset automatically",
    kpi_arrivals: "Arrivals",
    kpi_overdue: "overdue",
    kpi_departures: "Departing",
    kpi_open_invoices: "Open invoices",
    kpi_late_rentals: "Overdue rentals",
    kpi_stock: "Stock",
    extend_stay: "Extend",
    extend_other_date: "Other departure date",
    extend_ok: "Stay extended to",
    day: "day",
    days: "days",
    kpi_stock_negative: "items negative",
    ai_translate: "Translate with AI",
    art_names: "Name in other languages (for the guest's receipt and invoice)",
    art_names_hint: "Brand names, volumes and sizes stay unchanged. Left empty? Then the Dutch name is used.",
    art_translate_all: "Fill in all translations",
    ai_translating: "Working…",
    ai_translated: "Translations filled in",
    twofa_sent: "Code sent to",
    twofa_sub: "Enter the code we sent by SMS to",
    twofa_code: "SMS code (6 digits)",
    twofa_confirm: "Confirm",
    twofa_resend: "Send a new code",
    t_twofa: "Two-step verification by SMS",
    t_twofa_short: "2FA",
    t_twofa_on: "On",
    t_twofa_hint: "Administrators of this campsite receive a code by SMS when signing in. The number comes from their user profile (with country code, e.g. +34 612 345 678).",
    t_turnstile: "Cloudflare verification (anti-bot)",
    t_turnstile_short: "Bot check",
    t_turnstile_hint: "Visitors solve a short, mostly invisible Cloudflare check when signing in and on public forms. Enabled by default; only the main administrator can change this.",
    t_demo_short: "Demo",
    t_demo: "Allow demo for this campsite",
    t_demo_hint: "Let this campsite use demo mode (dummy data). Only the main administrator can allow this. When off, the campsite sees none of the demo features. 'Yes' is shown in red because demo is not meant for real use.",
    flag_confirm: "Turn '{flag}' {state} for {name}?",
    flag_on: "on",
    flag_off: "off",
    user_phone_hint: "With country code, e.g. +34 612 345 678 — the two-step verification code is sent here.",
    admin_tariffs_desc: "Base rate per zone, period rates, price per item and packages.",
    tariff_base: "Base rates per zone",
    tariff_base_desc: "This rate applies whenever no period rate exists for that date.",
    tariff_periods: "Period rates",
    tariff_periods_desc: "Rate for a given period. Leave the zone empty to apply it to all zones.",
    tariff_items: "Rate per item",
    tariff_items_desc: "Price per item of the check-in form and the printed card. You can add your own items.",
    tariff_packages: "Packages",
    tariff_packages_desc: "Combine items into one package, e.g. 1 caravan + 2 persons + dog.",
    tariff_price_night: "Price",
    tariff_tourist_tax: "Tourist tax",
    tariff_children_free: "Children exempt",
    tariff_default: "default",
    tariff_period_name: "Name",
    tariff_from: "From",
    tariff_to: "To",
    tariff_all_zones: "All zones",
    tariff_pct: "% on base rate",
    tariff_apply_pct: "Calculate",
    tariff_pct_hint: "Calculate prices as a % of the base rate. Every amount stays editable afterwards.",
    tariff_overrides: "Item rates for this period",
    tariff_item_key: "Key",
    tariff_item_label: "Item",
    tariff_item_mode: "Calculation",
    tariff_mode_night: "Per night",
    tariff_mode_once: "One-off",
    tariff_mode_stay: "Per stay",
    tariff_mode_fixed: "Fixed total",
    tariff_mode_discount: "% discount on the sum",
    tariff_new_item: "New item",
    tariff_countable: "With quantity",
    tariff_new_package: "New package",
    tariff_package: "Package",
    tariff_package_mode: "Calculation",
    tariff_package_content: "Contents",
    tariff_package_total: "Total price",
    tariff_discount_pct: "% discount",
    tariff_include_pitch: "Pitch included in the package",
    tariff_package_hint: "With a fixed total the package replaces the individual prices of those items.",
    tariff_save_first: "Save the period first",
    tariff_calculated: "Rates calculated",
    tariff_name_required: "Name is required",
    tariff_price_estimate: "Price estimate",
    tariff_no_package: "No package",
    tariff_no_tariffs: "No tariffs set yet (Admin → Tariffs).",
    new_rental_item: "New rental item",
    rental_names: "Description per language (for the guest's invoice)",
    rental_pricing: "Calculation", pricing_day: "Per day", pricing_week: "Per week", pricing_stay: "Per stay",
    rental_qty_owned: "Owned", rental_deposit: "Deposit",
    rentals: "Rentals", rental_add: "Add rental", rental_item: "Rental item",
    rental_none: "Nothing rented for this booking yet.",
    rental_available: "available", rental_return: "Returned", rental_returned: "returned",
    rental_billed_until: "billed until", rental_deposit_note: "Deposit (separate, refunded on return)",
    change_period: "Change period", until_date: "Until",
    interim_invoice: "Interim billing", bill_until: "Bill until", end_last_month: "End of last month",
    admin_suppliers: "Suppliers",
    admin_suppliers_desc: "Your suppliers with their details and the agreed prices per article.",
    new_supplier: "New supplier",
    select_supplier: "Choose a supplier…",
    sup_name: "Name", sup_contact: "Contact person", sup_mobile: "Mobile", sup_website: "Website",
    sup_street: "Street", sup_number: "Number", sup_postal: "Postal code", sup_city: "City",
    sup_vat: "VAT number", sup_company_nr: "Company number", sup_iban: "IBAN", sup_bic: "BIC",
    sup_customer_nr: "Our customer number", sup_payment_terms: "Payment terms", sup_delivery_days: "Delivery days",
    sup_prices: "Agreed prices",
    sup_prices_desc: "Per article one or more lines: from which quantity which unit price applies (e.g. 1 pc = €5, from 10 pcs = €4.80).",
    sup_from_qty: "From qty", sup_unit_price: "Unit price",
    stays: "Stays", stay_now: "Staying now", stay_future: "Upcoming", stay_past: "Past",
    admin_purchases: "Incoming invoices",
    admin_purchases_desc: "Supplier deliveries; these increase stock.",
    admin_sales_inv: "Outgoing invoices",
    admin_sales_desc: "History of all sales invoices created (bookkeeping).",
    invoice_footer_note: "Invoice issued in euro. Amounts including VAT as calculated above.",
    vat_of: "on",
    view_planning: "Planning",
    view_map: "Map",
    view_today: "Today",
    toggle_view_hint: "Choose map or planning here",
    print_plus_hint: "Print + registration card",
    planning_hint: "Drag a booking to move it · double-click for details · scroll to navigate",
    jump_to_pitch: "Pitch to top…",
    quick_booking: "Quick booking",
    quick_booking_now: "Quick check-in",
    quick_max_nights: "Free until the next booking: max nights",
    quick_free_until: "the pitch is taken again from",
    quick_mode_reserved: "Reservation (arriving later)",
    quick_mode_booking: "Booking — guest is here",
    planning_months_back: "Planning: months back",
    planning_months_ahead: "Planning: months ahead",
    beschikbaar_dagen: "Available: days for new guests",
    available_new: "Available (new)",
    mark_occupied: "Mark as occupied",
    search_guest: "Search a guest…",
    marked_occupied: "Pitch is now occupied",
    which_guest: "Which guest occupies this pitch?",
    occupy_without_guest: "Occupied, no name",
    back_to_tray: "Back to tray",
    back_to_tray_done: "Pitch moved back to the tray",
    drop_here_hint: "Drag a marker in here to put it back in the tray",
    admin_cashclose: "Cash register closing",
    admin_cashclose_desc: "Daily overview of sales, count the cash and lock the day.",
    admin_guestbook: "Guestbook",
    loading_data: "Loading data…",
    pay_card: "Card",
    sale_pick_first: "First click the guest or ‘Walk-in’ above",
    sale_pick_lines: "Add at least one article",
    invoice_finish: "Complete invoice",
    invoice_finish_hint: "Choose how the guest receives the invoice. You can pick both; the invoice can always be reprinted or re-sent later via Invoices.",
    invoice_finish_print_hint: "Opens the invoice in a new window",
    invoice_finish_no_email: "No email address on file",
    invoice_finish_confirm: "Complete",
    cash_card_total: "Card",
    cash_card_hint: "Card payments are not in the till and therefore do not count towards the cash to be counted.",
    number_from: "Number (from)",
    number_to: "to (optional)",
    pitch_bulk_hint: "Leave 'to' empty to create a single pitch. Maximum 50 at a time. Existing pitches are skipped.",
    pitches_created: "{n} pitches created",
    pitches_skipped: "{n} already existed and were skipped",
    admin_guestbook_desc: "Reviews from guests who stayed with you. They automatically receive a friendly invitation a few days after they leave.",
    gb_invited: "Invited",
    gb_submitted: "Completed",
    gb_rate: "Response rate",
    gb_overall: "Overall",
    gb_cleanliness: "Cleanliness",
    gb_sanitary: "Sanitary facilities",
    gb_welcome: "Welcome",
    gb_value: "Value for money",
    gb_comment: "Comment",
    gb_public: "May be public",
    gb_public_hint: "Only what you tick here appears on the public guestbook page. Everything stays internal by default.",
    gb_waiting: "Not completed yet",
    gb_send_now: "Send invitations now",
    gb_dry_run: "Count first",
    gb_sent_count: "{n} invitation(s) sent",
    gb_candidates: "{n} guest(s) are eligible",
    gb_none: "There are no reviews yet.",
    gb_enabled: "Ask for a review automatically",
    gb_delay: "Days after departure",
    gb_guest: "Guest",
    gb_stay: "Stay",
    gb_public_page: "Public page",
    setup_review_enabled: "Ask for a review automatically",
    setup_review_days: "Days after departure",
    admin_email: "Mail & SMS",
    sms_title: "SMS (Spryng)",
    sms_desc: "Outgoing SMS (verification codes, warnings).",
    sms_enabled: "Use SMS via Spryng",
    sms_originator: "Sender (name/number)",
    sms_route: "Route",
    sms_token: "API token",
    sms_test: "Test SMS",
    sms_test_ok: "Test SMS sent",
    admin_email_desc: "This page has two parts: OUTGOING mail (SMTP) to send and reply to e-mails, and the INCOMING reception mailbox (IMAP) to read guest e-mails. Set up both for full functionality.",
    smtp_section_title: "Outgoing mail (SMTP) — sending & replying",
    smtp_section_desc: "The server CampAd Pro uses to send mail: invoices and your replies to guest e-mails. Without this you can receive mail but cannot send.",
    mail_need_smtp_warn: "You receive e-mails through the reception mailbox, but to reply or send you must first fill in and enable the outgoing mail server (SMTP) below.",
    smtp_enabled: "Use my own mail server (outgoing/SMTP)",
    smtp_host: "SMTP server",
    smtp_port: "Port",
    smtp_security: "Encryption",
    smtp_username: "Username",
    smtp_from_email: "Sender email",
    smtp_from_name: "Sender name",
    smtp_password: "Password",
    smtp_password_set: "set",
    smtp_test: "Test connection",
    smtp_test_ok: "Connection to the mail server succeeded",
    smtp_fallback_hint: "The invoice is sent in the guest's own language, with the PDF attached.",
    cash_close: "Close register",
    cash_closed: "Register closed",
    cash_counted: "Counted cash",
    cash_difference: "Difference",
    cash_unprinted: "Invoices not printed yet",
    cash_closures: "Previous closings",
    cash_auto: "automatic",
    email_invoice: "Email invoice",
    email_sent: "Invoice sent to",
    no_email_print: "No email address known — print the invoice.",
    no_vat_number_warning: "Note: no VAT number is set for the campsite yet. Fill it in under Admin → Campsite before printing invoices.",
    no_stock_tracking: "not tracked",
    low_stock: "Below minimum",
    low_stock_alert: "Stock alert",
    oos_note_required: "A remark is required for 'out of service'",
    oos_only_from_free: "A pitch can only be set out of service when it is free",
    oos_until: "Out of service until",
    oos_until_hint: "Leave empty for permanent — the pitch stays out of service until you free it yourself.",
    oos_permanent: "Permanently out of service",
    map_search_ph: "Pitch or name…",
    map_search_btn: "Search",
    map_search_none: "Nothing found on the map",
    no_reservation_found: "No reservation found for this pitch",
    no_active_stay: "No current stay on this pitch",
    remove_reservation_q: "Remove reservation?",
    remove_reservation_hint: "The reservation of {name} will be removed and the pitch becomes free. The customer details are kept.",
    reservation_removed_guest_kept: "Reservation removed — customer details kept",
    setup_stock_alert_hour: "Stock alert hour",
    setup_stock_alert_enabled: "Daily stock e-mail",
    setup_stock_alert_hint: "Every day at this hour all managers receive the articles below minimum by e-mail.",
    setup_audit_retention: "Keep change log",
    setup_audit_retention_unit: "days",
    setup_audit_retention_hint: "The change log keeps entries for this many days. Older entries are removed automatically every night at midnight.",
    setup_intro_music: "Welcome music",
    setup_intro_music_on: "Music after signing in",
    setup_intro_music_hint: "Vivaldi — The Four Seasons, \"Spring\" (public domain) plays briefly after signing in.",
    setup_stationery: "Stationery / document footer",
    setup_stationery_hint: "These details appear in the footer of invoices, receipts, deposit slips and registration forms. Days are printed in the guest's language.",
    setup_bank_name: "Bank name",
    setup_iban: "IBAN",
    setup_bic: "BIC",
    setup_footer_extra: "Extra footer line (e.g. company number)",
    setup_opening_hours: "Reception opening hours",
    setup_closed: "Closed",
    setup_hour_seasons: "Seasonal opening hours",
    setup_hour_seasons_hint: "Add periods (e.g. high season 15/06 → 15/09). Periods crossing the year-end are allowed. Documents show the hours of the current period; outside those periods the standard hours above are used.",
    setup_season_name: "Season name",
    settle_merged: "Pitches settled together (same departure date)",
    settle_parallel_warn: "This guest also occupies",
    settle_parallel_ask: "Settle it too and close it on the settlement date?",
    settle_sales_added: "Unsettled sales added to the invoice",
    settle_open_invoices: "Invoices still open for this guest",
    settle_total_open: "Total outstanding",
    overdue_dep_title: "Overdue departures",
    overdue_dep_msg_one: "guest is past their departure date",
    overdue_dep_msg_many: "guests are past their departure date",
    overdue_dep_view: "Show details",
    overdue_dep_hide: "Hide details",
    overdue_dep_days: "days overdue",
    overdue_dep_day: "day overdue",
    overdue_dep_open: "Outstanding",
    outstanding_title: "Still outstanding",
    outstanding_none: "This guest has nothing outstanding.",
    outstanding_sales: "Sales on account",
    outstanding_deposits: "Open deposits",
    mobile_apps: "Mobile apps (Inspection / Visitors)",
    mobile_apps_hint: "Plan size and GPS calibration used by the mobile apps. Origin: top-left corner.",
    plan_width: "Plan width",
    plan_height: "Plan height",
    plan_unit_px: "Unit: pixels of the plan (same as the web app).",
    calib_nw_lat: "NW latitude",
    calib_nw_lng: "NW longitude",
    calib_se_lat: "SE latitude",
    calib_se_lng: "SE longitude",
    calib_bearing: "Rotation (°)",
    calib_opacity: "Opacity (0-1)",
    admin_inspection: "Inspection (app)",
    admin_inspection_desc: "Reports and live presence of the inspectors",
    inspection_reports: "Reports from the inspection app",
    inspection_presence: "Inspectors on site",
    inspection_open: "Show open",
    inspection_handled: "Show handled",
    inspection_new_report: "New inspection report",
    inspection_goto: "Go to reports",
    reset_pw: "Reset password",
    reset_pw_confirm: "Reset the password to the starting password (= the e-mail address)?",
    reset_pw_done: "Password reset to the e-mail address",
    reset_pw_tooltip: "Password reset: sets the password back to the e-mail address; the user must choose a new one at the next login",
    reset_pw_hint: "The user logs in with the e-mail address as password and must then choose a new password.",
    reset_pw_legend: "The yellow key = password reset: back to the starting password (= e-mail address); the user must change it at the next login.",
    admin_maintenance: "Maintenance",
    admin_maintenance_desc: "Sync pitch statuses and clean up test data",
    admin_menu: "Menu layout",
    admin_menu_desc: "Decide per role which menu items are visible and in which group/order",
    menu_role: "Role",
    menu_hint: "Items are grouped in the sidebar per group; the order below sets the order within each group. The main administrator always sees everything.",
    menu_visible: "Visible",
    menu_group: "Group",
    menu_reset: "Reset to default",
    menu_drag: "Drag to change the order",
    menu_saved: "Menu layout saved",
    menu_groups: "Groups",
    menu_add_group: "Add group",
    menu_delete_group: "Delete group",
    menu_items_label: "Menu items",
    maint_pitches: "Sync pitch statuses",
    maint_pitches_hint: "Aligns every pitch status with today's reservations. Pitches that are out of order stay untouched.",
    maint_pitches_confirm: "Align all pitch statuses with the reservations?",
    maint_to_fix: "Pitches to align",
    maint_sync_now: "Sync now",
    maint_testdata: "Clean up test data",
    maint_testdata_hint: "Deletes guests, reservations, invoices and sales that look like test data. Invoices and sales with proper numbering (e.g. 2026-0005) are always kept.",
    maint_testdata_confirm: "Permanently delete this test data? This cannot be undone.",
    maint_found: "Test records found",
    maint_cleanup_now: "Clean up now",
    maint_guest: "Guest",
    maint_reservation: "Reservation",
    maint_invoice: "Invoice",
    maint_sale: "Sale",
    mark_handled: "Handled",
    insp_observed: "Observed status",
    insp_photo: "View photo",
    insp_cat_status_klopt_niet: "Status does not match",
    insp_cat_verkeerde_locatie: "Wrong location",
    insp_cat_onbruikbaar: "Unusable",
    insp_cat_andere: "Other",

    pay_link: "Payment link",
    pay_link_copied: "Payment link copied",
    pay_online: "Paid online",
    payment_ok_title: "Payment received!",
    payment_ok_text: "Thank you. Your invoice is marked as paid.",
    payment_pending_title: "Processing payment…",
    payment_pending_text: "We are waiting for confirmation from the bank. Please keep this page open.",
    payment_failed_title: "Payment not completed",
    payment_failed_text: "Please try again or ask at the reception desk.",
    payment_cancel_title: "Payment cancelled",
    payment_cancel_text: "Nothing has been charged. You can try again whenever you like.",




    order_advice: "Order advice",
    order_advice_desc: "Articles below minimum, grouped per default supplier",
    order_advice_none: "No articles below minimum — nothing to order",
    no_supplier: "Without default supplier",
    art_supplier: "Default supplier",
    art_order_qty: "Order quantity",
    art_order_qty_hint: "Leave 0 to order exactly the shortage up to the minimum.",
    order_qty_short: "To order",
    order_mail: "E-mail order",
    order_print: "Print order",
    order_mail_sent: "Order sent",
    order_mail_to: "To",
    order_mail_subject: "Subject",
    order_mail_message: "Message",
    order_no_email: "This supplier has no e-mail address",
    low_stock_msg: "article(s) at or below the minimum stock",
    goto_stock: "Go to stock",
    search_article: "Search article…",
    stock_desc: "Stock only changes through a sale, a delivery with incoming invoice or a correction by an administrator.",
    stock_rule_hint: "Stock cannot be typed in: use a delivery or a correction.",
    stock_history: "Stock history",
    move_kind: "Reason",
    move_sale: "Sale",
    move_delivery: "Delivery",
    move_correction: "Correction",
    new_correction: "Book a correction (breakage, stocktake)",
    correction_reason: "Reason",
    deliveries: "Deliveries (incoming invoices)",
    new_delivery: "New delivery",
    book_delivery: "Book delivery",
    delivery_booked: "Delivery booked",
    delivery_hint: "On booking, the stock of each line increases and the movement is linked to this incoming invoice.",
    supplier: "Supplier",
    purchase_price: "Purchase price",
    select_article: "Choose article…",
    ask_admin_article: "New article? Ask your administrator.",
    sale_step_1: "Pitch",
    sale_step_2: "Customer and payment",
    sale_step_3: "Articles",
    search_stay: "Search by pitch or name…",
    walkin: "Walk-in (no pitch)",
    walkin_title: "Create walk-in",
    walkin_hint: "Creates a provisional booking (max 48h) and immediately sends a QR link + welcome email (valid 24h) in the guest's language.",
    walkin_need_fields: "First name and email are required",
    walkin_created: "Walk-in created",
    walkin_mail_sent: "Welcome email sent",
    walkin_qr_hint: "Let the guest scan this QR code to check in themselves.",
    walkin_create: "Create + email",
    walkin_hours: "Hours (max 48)",
    actions: "Actions",
    bf_last_name: "Surname",
    bf_email: "E-mail",
    nav_jobs: "Jobs",
    jobs_none: "No tasks found",
    job_task: "Task",
    job_assignee: "Controller",
    job_unassigned: "Unassigned",
    job_mark_done: "Done",
    job_done: "Job completed",
    job_new: "New task",
    job_edit: "Edit task",
    job_title: "Title",
    job_category: "Category",
    job_priority: "Priority",
    job_due: "Due date",
    job_detail: "Detail",
    job_status: "Status",
    job_saved: "Task saved",
    job_deleted: "Task deleted",
    job_delete_confirm: "Delete this task?",
    job_all_assignees: "All staff",
    tab_active: "Active",
    tab_done: "Done",
    tab_all: "All",
    cat_power: "Power", cat_repair: "Repair", cat_cleaning: "Cleaning",
    cat_inspection: "Inspection", cat_delivery: "Delivery", cat_other: "Other",
    prio_laag: "Low", prio_normaal: "Normal", prio_hoog: "High", prio_dringend: "Urgent",
    status_open: "Open", status_assigned: "Assigned", status_busy: "In progress",
    status_done: "Done", status_cancelled: "Cancelled",
    demo_off_purge_confirm: "Turn demo off for {name}? This permanently removes {n} demo records.",
    sale_billing: "Billing",
    sale_private: "Private",
    sale_company: "To company",
    no_company: "This guest has no company: the sale is billed privately.",
    payment: "Payment",
    pay_cash: "Paid cash",
    pay_account: "On account (final invoice)",
    save_cash: "Sale + paid cash",
    save_account: "Sale on account",
    stock_negative_warning: "stock will go negative",
    back: "Back",
    next: "Next",
    company: "Company",
    company_on_account: "Billed to a company",
    company_name: "Company name",
    company_hint: "These details appear on the invoice when billing to the company.",
    parking: "Parking status",
    find_parking: "Go to the parking status on the map",
    search_placeholder: "Search by name, licence plate or pitch…",
    search_in_screen: "Search in this screen…",
    booker: "Booker",
    occupants: "Booker and fellow guests",
    tab_adult: "Adult",
    tab_child: "Child",
    complete: "Complete",
    complete_hint: "Fill in the stay completely and click Complete to unlock the fellow guests.",
    stay_approved: "Stay approved",
    stay_approved_hint: "You can now fill in the fellow guests.",
    id_required_over12: "An ID or passport number is required from the age of 12.",
    same_address_hint: "Address (suggested: same as the booker, editable)",
    occupant_period: "Stay of this person (within the booking)",
    no_extra_occupants: "No fellow guests: increase the number of adults or children in the stay.",
    occupants_incomplete: "Fellow guests incomplete",
    dblclick_hint: "double-click to zoom in, Shift+double-click to zoom out",
    multi_select_hint: "Ctrl+click (or Shift+click) to select several, then click the map where the grid should start",
    selected_n: "{n} selected",
    placed_n: "{n} pitches placed on the map",
    grid_place: "Place in a grid on the map",
    pan_hint: "drag the map with the mouse to move it",
    size: "Size",
    size_1: "Small",
    size_2: "Medium",
    size_3: "Large",
    tenants: "Campsites (clients)",
    tenants_desc: "Only the head administrator sees this table. The domain determines which campsite belongs to an address; the e-mail domain determines which users may be created.",
    t_slug_hint: "e.g. cap-blanch (empty = derived from the name)",
    t_slug_fixed: "The code is the key to all data of this campsite and cannot be changed afterwards.",
    t_domain: "Domain",
    t_domain_hint: "Several web addresses? Separate them with a comma. The outdoor screen and login screen always follow the address you open the app with.",
    t_handover: "Take over address",
    t_handover_desc: "The web address {domains} moves to the campsite you select below. {name} is then set to inactive: nobody can work in it anymore, but nothing is lost. This is only possible when that campsite holds no data.",
    t_handover_target: "Move to",
    t_handover_do: "Move web address",
    t_handover_ok: "Web address {domains} has moved and the old campsite is now inactive",
    t_delete_confirm: "Permanently delete campsite {name}? Only possible when no data is attached and cannot be undone.",
    t_delete_ok: "Campsite {name} has been deleted",
    t_name: "Campsite name",
    t_email_domain: "User e-mail domain",
    t_slug: "Code",
    t_admin_email: "E-mail of first administrator (optional)",
    new_tenant: "New campsite",
    switch_tenant: "Work in this campsite",
    switched: "Active campsite changed",
    active_camp: "Active campsite",
    t_users: "Users",
    t_pitches: "Pitches",
    zones: "Zones",
    new_zone: "New zone",
    zone_code: "Code",
    zone_name: "Name",
    zone_new_inline: "Create new zone…",
    zone_created: "Zone created",
    zones_desc: "Zones define the layout of the campsite. When creating a pitch you pick an existing zone or create a new one.",
    setup: "Setup — campsite",
    setup_desc: "All campsite-specific data. These values are used in the sidebar, the registration forms, the invoices and the e-mails.",
    setup_payment_title: "Payment request",
    setup_payment_desc: "Determines the amount a guest must pay for an online payment request.",
    setup_payment_full: "Full amount",
    setup_payment_deposit: "Deposit",
    setup_deposit_type: "Deposit type",
    setup_deposit_percent: "Percentage",
    setup_deposit_amount: "Fixed amount",
    setup_camp_name: "Campsite name",
    camping: "Campsite",
    setup_street: "Street and number",
    setup_postal_city: "Postcode and town",
    setup_country: "Country",
    setup_phone: "Phone",
    setup_email: "E-mail address",
    setup_website: "Website",
    setup_gps: "GPS coordinates",
    setup_vat_number: "VAT/CIF number",
    setup_vat_rate: "Default VAT %",
    setup_tourist_tax: "Tourist tax per person/night",
    setup_currency: "Currency",
    setup_default_lang: "Default interface language",
    setup_base_lang: "Base language (source for translations)",
    setup_base_lang_hint: "The language the guest emails and cards are written in and from which all other EU languages are translated. Pick exactly one: NL, ES or EN.",
    pretranslate_label: "Prepare languages",
    pretranslate: "Pre-translate all languages now",
    pretranslate_hint: "Prepares the guest emails and cards once in every EU language, so the very first guest in a new language doesn't have to wait. This runs in the background.",
    pretranslate_started: "Pre-translation started — running in the background",
    pretranslate_done: "All languages are ready",
    setup_logo: "Logo (sidebar, form, invoice)",
    setup_logo_tent: "Small logo (collapsed sidebar)",
    setup_emergency: "Emergency numbers (form)",
    setup_info_items: "General information on the form",
    setup_label: "Description",
    setup_number: "Number",
    tagline: "Campsite management",
    login_title: "Welcome back",
    login_sub: "Sign in to open the campsite management",
    forgot_password: "Forgot your password?",
    reset_phone: "Mobile number",
    reset_email_label: "E-mail address",
    reset_request_sub: "Enter your e-mail and mobile number. You will receive an e-mail with a recovery link and an SMS with a code.",
    reset_request_btn: "Request recovery",
    reset_sent_msg: "If this account exists, we have sent an e-mail (and SMS) with recovery instructions.",
    back_to_login: "Back to sign in",
    reset_title: "Set a new password",
    reset_code: "SMS code (6 digits)",
    reset_submit: "Set password",
    reset_done: "Your password has been changed. You can sign in now.",
    reset_invalid_link: "The recovery link is invalid or expired. Request a new one on the sign-in screen.",
    reset_pw_mismatch: "The passwords do not match.",
    email: "E-mail address",
    password: "Password",
    login: "Sign in",
    logout: "Sign out",
    logging_in: "Signing in...",
    nav_dashboard: "Overview",
    nav_aankomend: "Arrivals",
    nav_zoekers: "Searchers",
    assign_pitch: "Assign pitch",
    overdue_label: "Overdue",
    no_zoekers: "No searchers without a pitch",
    nav_reservaties: "Reservations",
    nav_vertrekkend: "Departing",
    nav_afrekening: "Interim billing",
    nav_verhuizen: "Move guest",
    nav_verbeteringen: "Improvements",
    nav_gasten: "Guests",
    nav_verkopen: "Individual sales",
    nav_facturen: "Create invoices",
    nav_admin: "Admin",
    nav_verblijven: "Staying",
    nav_wachtwoord: "Password",
    menu: "Menu",
    campsite_overview: "Campsite overview",
    occupancy_zone: "Occupancy per zone",
    kpi_vrij: "Free according to system",
    kpi_bezet: "Occupied",
    kpi_controle: "Check needed",
    kpi_rood: "Red ribbon",
    legend: "Legend",
    arriving_today: "Arrivals today",
    departing_today: "Departures today",
    zone: "Zone",
    free: "Free",
    occupied: "Occupied",
    reserved: "Reserved",
    pitch: "Pitch",
    status: "Status",
    note: "Note",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    u_barcode: "Barcode number",
    users_hide_inactive: "Hide inactive",
    users_show_inactive: "Show inactive",
    users_info: "Details",
    users_search: "Search by nickname, name, e-mail or role...",
    guests_search: "Search by name, licence plate, pitch or e-mail...",
    pitch_note_placeholder: "Short note...",
    pitch_note_saved: "Note saved",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    guest: "Guest",
    guests: "Guests",
    new_guest: "New guest",
    first_name: "First name",
    last_name: "Surname",
    phone: "Phone",
    language: "Language",
    country: "Country",
    license_plate: "Licence plate",
    notes: "Notes",
    documents: "Documents",
    upload: "Upload",
    upload_hint: "Allowed: PDF, JPG, PNG, WEBP, HEIC · max 15 MB",
    upload_bad_type: "This file type is not allowed. Allowed: PDF, JPG, PNG, WEBP, HEIC.",
    upload_too_big: "File too large (max 15 MB).",
    finder_title: "Find a pitch for a period",
    finder_search: "Search",
    finder_direct: "Immediately free (0 moves)",
    finder_one: "Available with 1 move",
    finder_two: "Available with 2 moves",
    finder_none: "No pitches found for this period",
    finder_move_arrow: "move on",
    move_planned: "Scheduled moves",
    move_pending: "To execute",
    move_done: "Already executed",
    move_execute: "Executed",
    move_due: "Today",
    move_other_zone: "other zone",
    finder_plan_title: "Book with move",
    finder_create: "Book",
    finder_created: "Reservation with scheduled move(s) created",
    finder_first: "First name",
    finder_last: "Surname",
    finder_persons: "Persons",
    reservation: "Reservation",
    reservations: "Reservations",
    new_reservation: "New reservation",
    arrival: "Arrival",
    departure: "Departure",
    persons: "Persons",
    checkin: "Check in",
    print_registration: "Print card + registration form",
    checkout: "Check out",
    to_reservation: "To reservation",
    pitch3d_hint: "Click a pitch for guest and stay",
    move: "Move",
    to_pitch: "To pitch",
    invoice: "Invoice",
    invoices: "Invoices",
    new_invoice: "New invoice",
    invoice_number: "Invoice number",
    description: "Description",
    qty: "Quantity",
    unit_price: "Price",
    subtotal: "Subtotal",
    tax: "VAT",
    vat: "VAT",
    total: "Total",
    new: "New",
    users: "Users",
    main_booker: "Main booker",
    ribbon_guest: "Red ribbon — works for the campsite, preferred pitch (optional)",
    until: "until",
    free_until: "free until",
    drop_photos: "Drag photos or PDFs here",
    still_needed: "Still needed",
    departure_before_arrival: "Departure is before arrival",
    quote_range_warn: "This period looks unrealistically long. Please check the dates (year).",
    quote_per_month: "average per month",
    inv_unpaid: "Unpaid",
    inv_paid: "Paid",
    pay: "Pay",
    pay_registered: "Payment registered",
    pay_m_cash: "Cash",
    pay_m_card: "Card",
    pay_m_split: "Split",
    pay_split_note: "Split payment: part cash, part card.",
    bf_first_name: "First name", bf_last_name: "Surname", bf_email: "E-mail", bf_birth_date: "Date of birth", bf_street: "Street", bf_house_number: "House number",
    bf_postal_code: "Postcode", bf_city: "Town", bf_country: "Country", bf_passport_number: "Passport number", bf_passport_country: "Country of issue", bf_passport_place: "Place of issue",
    plate: "Licence plate",
    print_fiche: "Print form",
    print_fiche_map: "Print form + map",
    confirm_delete_reservation: "Delete this reservation?",
    passport_docs: "Documents (passport / ID)",
    take_photo: "Take photo",
    choose_files: "Choose files",
    docs_uploaded: "document(s) uploaded",
    open: "Open",
    search_staying: "Search by name, nickname or pitch…",
    no_staying: "No stays found",
    email_invalid: "Invalid e-mail address (e.g. name@domain.com)",
    email_no_domain: "This domain does not exist or does not receive e-mail",
    type_pitch: "Type the pitch, e.g. T12…",
    no_free_pitch: "No free pitch found for this period",
    pick_existing_guest: "Choose existing guest…",
    chosen_pitch: "Chosen pitch",
    period: "Period",
    your_stay: "Your stay",
    passport: "Passport number",
    issue_country: "Country of issue",
    issue_place: "Place of issue",
    card_number: "Card number",
    valid_until: "Valid until",
    power: "Power option",
    stay_adults: "Adults", stay_children: "Children (4-12 y)", stay_dogs: "Dog",
    stay_car: "Car", stay_caravan: "Caravan", stay_mobilhome: "Motorhome", stay_trailer: "Trailer", stay_tent: "Tent",
    stay_moto: "Motorcycle", stay_boat: "Boat", stay_mobilhome9: "Motorhome > 9 m", stay_bungalow: "Bungalow", stay_cabin: "Cabin",
    conflict_bungalow_cabin: "Bungalow cannot be combined with a cabin",
    conflict_unit_accommodation: "Caravan, motorhome or tent cannot be combined with a bungalow or cabin",
    save_provisional: "Save as provisional",
    save_definitive: "Save as definitive",
    definitive_hint: "Definitive: all details of the main booker are required (card number and valid until are optional); the confirmation is e-mailed in the language of the main booker.",
    provisional_hint: "Provisional: only pitch, first name and surname are required.",
    missing_fields: "Please complete all highlighted required fields",
    mail_sent: "Confirmation e-mail sent",
    provisional: "Provisional",
    birth_future: "Date of birth cannot be in the future",
    new_user: "New user",
    u_number: "Number",
    cash_opening: "Opening float",
    cash_keep: "Float kept in till",
    live_updated: "Live · updated",
    admin_deposits: "Bank deposits",
    deposits_desc: "All deposits with a running number, per month or per year (finance class 4 or 5).",
    deposits_next_number: "Next number",
    deposits_seq_hint: "Numbers run per year and cannot be set lower than the last one used.",
    deposit_cancel: "Cancel deposit",
    deposit_cancelled: "Cancelled",
    deposit_cancel_hint: "The number stays, but the amount no longer counts.",
    deposit_cancel_reason: "Reason for cancelling",
    cash_deposit_interim: "Interim deposit",
    cash_deposit_where: "Deposits are made via Admin → Daily closing.",
    cash_deposit_interim_hint: "The amount is deducted from the till straight away and you get a receipt to take along.",
    cash_deposit_account: "Bank account",
    cash_deposit_receipt: "Deposit receipt",
    cash_deposit_origin: "Origin",
    cash_sign_staff: "Signature staff member",
    cash_sign_bank: "Signature bank",
    cash_banked_today: "Deposited during the day",
    cash_account_paid: "Cash on open invoices",
    cash_account_card: "Card on open invoices (info)",
    cash_account_hint: "Cash payments of open (on account) invoices count in the till on the payment date. Card payments are shown for information only.",
    cash_online_deposits: "Online deposits received",
    cash_online_deposits_hint: "Deposits paid online (prepayments via Stripe). Listed separately — not counted in the cash drawer.",
    admin_season: "Year overview",
    season_desc: "Revenue, cash differences and hours per staff member for a year or season (finance class 5 only).",
    season_year: "Year",
    season_from: "From",
    season_to: "To",
    season_staff: "Per staff member",
    m_jan: "January",
    m_feb: "February",
    m_mar: "March",
    m_apr: "April",
    m_may: "May",
    m_jun: "June",
    m_jul: "July",
    m_aug: "August",
    m_sep: "September",
    m_oct: "October",
    m_nov: "November",
    m_dec: "December",
    cash_max_enabled: "Alert when till is full",
    cash_max_limit: "Maximum in till (€)",
    cash_max_hint: "If there is more cash in the till than this amount, reception gets a warning to deposit part of it.",
    cash_level_warning: "A lot of cash in the till — make an interim deposit",
    cash_sellers_today: "Sold that day",
    cash_deposit: "Bank deposit",
    cash_deposit_register: "Register deposit",
    cash_deposit_by: "Taken to the bank by",
    cash_deposit_by_ph: "name of the staff member",
    amount: "Amount",
    cash_count_show: "Count notes & coins",
    cash_count_hide: "Close counter",
    cash_count_hint: "Enter the quantity; the total is calculated automatically.",
    cash_diff_weeks: "Cash differences per week",
    cash_diff_list: "Cash difference list",
    cash_diff_history: "Previous cash differences per seller",
    cash_diff_history_opt: "Include history per seller",
    cash_last_8: "8 weeks",
    cash_last_13: "13 weeks",
    cash_this_year: "This year",
    cash_days_with_diff: "Days with difference",
    cash_max_diff: "Largest difference",
    admin_seller_revenue: "Revenue per staff member",
    seller_revenue_desc: "Revenue per staff member based on the badge used at the sale.",
    cash_alert_enabled: "Alert on cash difference",
    cash_alert_limit: "Threshold (€)",
    cash_alert_hint: "If the difference exceeds this amount, admins with finance class 5 are e-mailed immediately.",
    cash_to_deposit: "To deposit",
    cash_not_closed: "Not closed yet",
    cash_signature: "Checked by / date",
    seller: "Staff member",
    staff_scan: "Scan badge to switch staff member",
    staff_scan_ph: "Scan badge or type staff number",
    shift_note_hint: "Short note for the next shift (optional)",
    shift_note_ph: "e.g. toilets B cleaned · pitch A12 reports water issue",
    shift_notes_title: "Shift notes",
    hours_mail_enabled: "E-mail weekly overview",
    hours_mail_day: "Day",
    hours_mail_hour: "Hour",
    hours_mail_hint: "Last week's overview goes to all admins with finance class 5.",
    u_min_week_hours: "Min. hours per week",
    u_min_week_hint: "0 = no minimum (flexible hours)",
    admin_hours: "Time tracking",
    my_hours: "My hours",
    break: "Break",
    break_hint: "Break: you are signed out and the time is logged as a break",
    hours_week: "Week",
    hours_month: "Month",
    hours_worked: "Worked",
    hours_planned: "Planned",
    hours_diff: "Difference",
    hours_min: "Minimum",
    hours_days_worked: "Days worked",
    hours_desc: "Hours come from signing in and out. Click a day to review or correct the sessions.",
    hours_desc_own: "Your own hours, tracked automatically on every sign in and out.",
    hours_none: "No entries on this day",
    hours_open: "still running",
    hours_idle: "Inactivity",
    hours_auto: "Closed automatically",
    hours_manual: "Manual",
    hours_add: "Add entry",
    u_badge: "Badge",
    login_identifier: "E-mail address or badge number",
    login_identifier_ph: "name@example.com or scan your badge",
    u_staff_number: "Staff number",
    u_staff_hint: "Optional, must be unique",
    u_number_hint: "Automatically generated (EAN13)",
    u_idle: "Automatic sign-out after (min, minimum 60)",
    u_nickname: "Nickname",
    u_birth: "Date of birth",
    u_role: "Type/role",
    u_street: "Street",
    u_house: "No.",
    u_postal: "Postcode",
    u_city: "Town",
    u_workdays: "Default working days and hours",
    role_admin: "Administrator",
    u_finance_class: "Finance class",
    u_finance_hint: "Extra financial rights for a regular user. Administrators always have everything.",
    fin_0: "0 – no financial rights",
    fin_1: "1 – invoices and billing",
    fin_2: "2 – also day closing",
    fin_3: "3 – also financial overviews",
    fin_4: "4 – also editing tariffs",
    fin_5: "5 – everything financial",
    role_reception: "Reception",
    role_controller: "Controller",
    role_personeel: "Staff",
    role_superadmin: "Head administrator",
    day_mon: "Mon", day_tue: "Tue", day_wed: "Wed", day_thu: "Thu", day_fri: "Fri", day_sat: "Sat", day_sun: "Sun",
    active: "Active",
    inactive: "Deactivated",
    activate: "Activate",
    deactivate: "Deactivate",
    pw_pending: "password still to be changed",
    user_pw_info: "The temporary password equals the e-mail address. At the first sign-in the user must choose a new password.",
    user_created_hint: "User created — temporary password = e-mail address",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password",
    repeat_password: "Repeat new password",
    pw_requirements: "Requirements",
    pw_rule_length: "At least 10 characters",
    pw_rule_upper: "At least 1 capital letter",
    pw_rule_lower: "At least 1 lower-case letter",
    pw_rule_digit: "At least 1 digit",
    pw_rule_special: "At least 1 special character",
    pw_rule_match: "Both new passwords match",
    pw_changed: "Password changed",
    pw_first_login: "First sign-in: choose a new password. Your current password is your e-mail address.",
    guest_created: "Guest created and selected",
    save_guest: "Save guest",
    final_invoice: "Final invoice",
    checkout_and_invoice: "Check out + final invoice",
    checkout_only: "Check out without invoice",
    no_departures: "No departing guests left to check out",
    nights: "nights",
    pitch_fee: "Pitch",
    tourist_tax: "Tourist tax",
    electricity: "Electricity",
    add_line: "Add line",
    checked_out_ok: "Checked out",
    sales_included: "Individual sales for this guest",
    new_arrival: "New arrival (reservation + check in)",
    no_arrivals: "No arrivals left to check in",
    checked_in_ok: "Checked in",
    vrij: "Free",
    bezet: "Occupied",
    gereserveerd: "Reserved",
    send: "Send",
    send_email: "Send by e-mail",
    sent: "Sent",
    view: "View",
    sales: "Individual sales",
    new_sale: "New sale",
    date: "Date",
    needs_attention: "Pitches that need attention",
    mark_free: "Mark as free",
    no_data: "No data",
    settings: "Settings",
    camping_map: "Campsite map",
    upload_map: "Upload map",
    logged_in_as: "Signed in as",
    select_guest: "Select guest",
    select_pitch: "Select pitch",
    saved: "Saved",
    use: "use",
    move_from: "From pitch",
    move_to: "To pitch",
    move_pick_free: "Pick a free pitch",
    move_none_free: "No free pitches in this zone",
    move_all_zones: "All zones",
    move_reason: "Reason for the move",
    invoice_mark_paid: "Mark as paid",
    invoice_unpay: "Set back to open",
    invoice_marked_paid: "Invoice marked as paid",
    invoice_paid_today: "Today's date is used as payment date.",
    payment_method: "Payment method",
    pay_cash: "Cash",
    pay_card: "Card",
    pay_transfer: "Bank transfer",
    pay_other: "Other",
    move_free_whole_stay: "The list only shows pitches that stay free until the end of this stay.",
    move_reason_default: "At the guest's request",
    invoice_delivery_ask: "Do you want to print this invoice or e-mail it to the guest?",
    invoice_print_and_mail: "Print and e-mail",
    invoice_later: "Handle later",
    invoice_mailed: "Invoice e-mailed to the guest",
    setup_login_style: "Sign-in screen",
    setup_reminder_days: "Payment reminder after (days)",
    setup_reminder_repeat: "Repeat reminder after (days)",
    setup_reminder_max: "max. number",
    setup_reminder_repeat_hint: "After the first reminder, the next one only follows after this many days. Enter 0 as 'max. number' to keep reminding indefinitely.",
    setup_reminder_enabled: "Send automatically",
    setup_overdue_reminder: "Reminder for overdue guests",
    setup_display: "Outdoor screen at the entrance",
    setup_demo: "Demo",
    setup_demo_on: "Allow demo data",
    setup_demo_on_ok: "Demo is on — every operational screen now shows a red button",
    demo_fill_label: "Demo occupancy",
    demo_fill_hint: "Demo: randomly fill the campsite with demo pitches up to the chosen % occupied and % reserved (no guest). Clears when Demo is turned off.",
    demo_fill_occupied: "% occupied",
    demo_fill_reserved: "% reserved",
    demo_fill_apply: "Apply",
    demo_fill_reset: "Clear",
    demo_fill_sum_err: "Occupied + reserved together cannot exceed 100%",
    demo_fill_done: "Demo occupancy updated — added {b} occupied, {r} reserved",
    setup_demo_off_ok: "Demo off, all demo data removed",
    setup_demo_purge_confirm: "This removes {n} demo records (guests, bookings, invoices, sales, rentals, reviews). Continue?",
    setup_demo_hint: "When ticked, a red button appears at the bottom right of every operational screen (never in Admin). Each press adds 1 dummy record on that screen so you can test in bulk. Unticking removes all demo data again.",
    setup_demo_allowed: "Allow demo for this campsite",
    setup_demo_allowed_hint: "Only the superadmin can allow demo. While this is off, this campsite sees none of the demo features.",
    setup_demo_unavailable: "Demo is not available for this campsite. Ask the superadmin to enable it.",
    pitch_continue: "Continue",
    dummy_add: "Add demo",
    dummy_added: "Demo record added",
    dummy_added_bulk: "Demo records added",
    dummy_add_hint: "Short press = add 1 demo record, long press = 10 at once",
    demo_banner: "Demo mode active — added records are deleted as soon as you untick the box",
    demo_banner_count: "demo records",
    setup_display_none: "No code yet — click 'New code'",
    setup_display_copy: "Copy",
    setup_display_copied: "Link copied",
    setup_display_mismatch: "Note: you are working in {work}, but this web address belongs to {host}. The outdoor screen always follows the web address — switch to {host} first (Admin → Campsites → Work in this campsite) and upload the logo and opening hours there.",
    setup_display_new: "New code",
    setup_display_new_ok: "New code created — the old link no longer works",
    setup_display_hint: "Open this link on the TV or tablet outside: shows 'welcome' and the number of free pitches in 25 languages. Green below 90% occupancy, orange above 90%, red with 'FULLY BOOKED' above 98%. Refreshes itself live on every change.",
    setup_overdue_reminder_hint: "Every morning at 09:00 a friendly email (and SMS once Spryng is active) to guests past their departure date — at most one per day.",
    setup_interim_reminder: "Interim settlement reminder (days)",
    setup_interim_reminder_hint: "Automatically emails the guest a friendly note when the last interim settlement (or arrival) is more than this many days ago. Runs with the daily 09:00 reminders.",
    setup_interim_auto: "Automatic interim invoice (min. days)",
    setup_interim_auto_hint: "Automatically creates a monthly interim invoice for guests staying longer than this many days. Only the new period since the last settlement is charged, open account sales and prepayments are deducted, and the PDF is emailed as an attachment. Runs at 09:00.",
    setup_reminder_hint: "Every morning a guest with an outstanding invoice gets a friendly reminder including the invoice PDF, repeated weekly at most.",
    setup_dunning: "Payment reminders (dunning)",
    setup_dunning_hint: "Automatically sends payment reminders for outstanding invoices, with the invoice as a PDF attachment and in the guest's language. Runs every morning at 09:00.",
    setup_dunning_tiers: "Reminders after (days): 1st · 2nd · 3rd",
    setup_dunning_tiers_hint: "Three successive reminders with escalating tone: a friendly reminder (1st), a clear reminder (2nd) and a final notice (3rd). Default after 15, 30 and 45 days. Each tier is sent at most once per invoice.",
    invoice_reminders_run: "Send reminders now",
    invoice_reminders_done: "Reminders sent",
    dunning_label: "Payment reminders",
    dunning_none: "No reminder sent yet",
    dunning_tier_name_1: "1st reminder",
    dunning_tier_name_2: "2nd reminder",
    dunning_tier_name_3: "Final notice",
    dunning_overdue: "days overdue",
    dunning_filter_label: "Filter by reminder:",
    dunning_filter_all: "All",
    dunning_customer_number: "Customer no.",
    dunning_report_summary_title: "Reminder overview",
    dunning_report_incasso_title: "Collections file",
    dunning_report_generated: "Generated on",
    dunning_stays: "Stays",
    dunning_total_due: "Total outstanding",
    dunning_print_summary: "Print overview",
    dunning_print_incasso: "Print collections file",
    setup_login_style_sober: "Business",
    setup_login_style_original: "Original (photo)",
    setup_login_style_scene3d: "3D scene",
    demo_reset: "Reset demo",
    demo_reset_confirm: "Fully reset the demo data of Camping CampAd Pro?",
    demo_reset_done: "Demo environment restored",
    meter_reading: "Electricity meter",
    meter_arrival: "Meter reading on arrival (kWh)",
    meter_now: "Current reading",
    meter_start_label: "Start reading",
    meter_consumption: "Consumption",
    meter_last_known: "Last known reading",
    meter_last_unknown: "No meter reading yet",
    meter_recalc: "Recalculate",
    tariff_power: "Electricity",
    tariff_power_desc: "Price per kWh for consumption between meter readings. A period can override the kWh price.",
    tariff_kwh_price: "Price per kWh",
    tariff_mode_month: "Per started month",
    tariff_mode_month_prorata: "Per month, pro rata per day",
    deleted: "Deleted",
    created: "Created",
    doc_language: "Document language",
    interim_billing: "Interim billing",
    checked_in_guests: "Checked-in guests",
    create_invoice_for: "Create invoice for",
    total_pitches: "Total pitches",
    edit_layout: "Move pitches",
    editing_layout: "Drag the markers to the right spot on the map",
    done: "Done",
    reset_positions: "Default positions",
    assign_guest: "Link guest",
    occupied_by: "Occupied by",
    none_selected: "None",
    flags: "Markers",
    parking_capacity: "Capacity",
    parking_occupied: "Occupied",
    accommodation: "Accommodation",
    zoom_in: "Zoom in",
    zoom_out: "Zoom out",
    map_hint: "Click a pitch for details · hover to see the guest name when occupied",
    map_help: "Map help",
    handover_today: "Handover today",
    map_update: "Map update",
    map_update_desc: "Create pitches, place them on the map, drag or delete them (free pitches only).",
    new_pitch: "Create new pitch",
    number: "Number",
    label_optional: "Label (optional)",
    label_optional_hint: "Custom name for one single pitch, e.g. T20X. No series possible then.",
    type: "Type",
    shape: "Shape",
    color: "Colour",
    kind_pitch: "Pitch",
    kind_bungalow: "Bungalow",
    kind_cabin: "Cabin",
    shape_circle: "Round",
    shape_square: "Square",
    shape_diamond: "Diamond",
    unplaced_pitches: "Still to place — drag onto the map",
    unplaced_empty: "All pitches are on the map.",
    pitch_created: "Pitch created — drag it onto the map now",
    delete_only_free: "Only free pitches can be deleted",
    zoom_hint: "scroll with the mouse wheel to zoom",
    fit_width: "Fit to width",
    fit_height: "Fit to height",
    total_occupancy: "Total occupancy",
    totals: "Totals",
    red_ribbons: "Red ribbons",
    red_ribbons_total: "Total number of red ribbons (stock)",
    print: "Print",
    print_map: "Print map (A4)",
    print_plus: "Print+",
    print_plus_title: "Print+ · map + booking",
    print_plus_desc: "Register the arrival: we look up the guest (email first), immediately create a provisional booking and print the map with the registration form. The guest can complete the questionnaire later via the app.",
    print_plus_confirm: "Print + booking",
    existing_guest_found: "Existing guest found — details filled in",
    reservation_created: "Provisional booking created",
    print_plus_send_card: "Email the registration card + site map to the guest now",
    card_sent_to: "Registration card emailed to {email}",
    card_mailed: "Card emailed",
    confirm_long_stay: "The period is longer than 6 months — please confirm.",
    check: "Search",
    print_planning: "Print planning (A3)",
    print_planning_desc: "Choose the month. The planning prints landscape on A3, ready for the front desk.",
    month: "Month",
    same_pitch: "same pitch",
    linked_stays: "Linked stays",
    chain_all_booking: "Make all a booking",
    merge_stays: "Merge",
    jump_search: "Pitch, guest, plate, phone or e-mail…",
    act_merge: "merged",
    undo: "Undo",
    redo: "Redo",
    act_quick_booking: "quick reservation",
    act_quick_checkin: "quick booking",
    act_move: "move",
    act_resize: "duration changed",
    act_split: "split",
    act_move_split: "moved",
    act_chain_checkin: "all as booking",
    move_date: "Move date",
    split_move_desc: "Double-click a bar to move from a given day. The stay is split so the history stays correct.",
    history: "History",
    planning_month_title: "Monthly planning",
    broken_block_legend: "Continues outside this month",
    print_period_desc: "Enter the expected stay period. Below the map you get an overview of the free pitches per zone in that period.",
    from: "From",
    to: "To",
    free_pitches_period: "Free pitches in the period",
    admin_interfaces: "Interfaces",
    maint_ses: "SES.HOSPEDAJES — non-compliant stays",
    maint_ses_hint: "Reservations and stays missing the mandatory traveller data (birth date, document, address, recognised country, contact) cannot be reported to the Guardia Civil. Cleaning up deletes these reservations and frees their pitches. Guests are kept.",
    maint_ses_now: "Delete non-compliant stays and free the pitches",
    maint_ses_confirm: "All listed reservations will be permanently deleted and their pitches freed. Continue?",
    nav_interfaces: "Interfaces",
    iface_tab_overheid: "Authorities",
    iface_tab_boekhouding: "Accounting",
    credit_note: "Credit note",
    credit_note_confirm: "Create a credit note for this invoice? The invoice will then be locked.",
    credit_note_created: "Credit note created:",
    credited: "Credited",
    edit_invoice: "Edit invoice",
    accounting_locked: "Sent to accounting — locked",
    acc_manual_export: "Manual export",
    acc_automate: "Automate",
    acc_selection: "Selection",
    acc_documents: "document(s)",
    acc_csv_sep: "CSV separator",
    acc_csv_sep_hint: "Separator for CSV (e.g. ; or ,)",
    acc_format: "Download format",
    acc_export_note: "A manual export marks the documents as 'sent'; afterwards they are locked.",
    acc_export_done: "Export downloaded",
    acc_export_empty: "No documents in this selection",
    acc_scope_unsent: "Not yet sent",
    acc_scope_week: "This week",
    acc_scope_quarter: "This quarter",
    acc_scope_year: "This year",
    fmt_text: "Plain text",
    acc_trigger: "Trigger",
    acc_trigger_manual: "Manual",
    acc_trigger_daily: "Daily automatic",
    acc_trigger_weekly: "Weekly automatic",
    acc_trigger_quarterly: "Quarterly automatic",
    acc_destinations: "Destinations",
    acc_vars_hint: "Variables in the description: {camping}, {datum}, {periode}, {aantal}",
    acc_sender: "Sender",
    acc_recipient: "Recipient",
    acc_description: "Description (with variables)",
    acc_path: "Folder/path",
    acc_user: "User",
    acc_password: "Password",
    acc_no_dest: "No destinations configured yet",
    acc_run_now: "Send now",
    acc_grp_documents: "Documents",
    acc_grp_spreadsheets: "Spreadsheets",
    acc_grp_data: "Data",
    acc_what_to_send: "What to send",
    acc_when: "When",
    acc_add_dest: "Add destination",
    acc_sent_now: "Sent",
    xm_title: "Custom XML",
    xm_enable: "Use custom XML",
    xm_enable_hint: "Replaces the default XML with your own field names and structure.",
    xm_structure: "XML structure",
    xm_root: "Root element",
    xm_doc_el: "Document element",
    xm_line_wrap: "Lines wrapper",
    xm_line_el: "Line element",
    xm_sources: "Which documents",
    xm_src_invoices: "Invoices",
    xm_src_credits: "Credit notes",
    xm_src_sales: "Sales on account",
    xm_xsd: "XSD schema",
    xm_xsd_hint: "Upload an XSD to pick the target field names. Without an XSD, type them yourself.",
    xm_xsd_upload: "Upload XSD",
    xm_xsd_loaded: "fields found",
    xm_not_in_xsd: "not in XSD",
    fill_required: "Please fill in the required fields highlighted in blue.",
    xm_xsd_clear: "Clear XSD",
    xm_doc_fields: "Document fields",
    xm_line_fields: "Line fields (per invoice/sale line)",
    xm_app_field: "App field",
    xm_xml_field: "XML field name",
    xm_add_row: "Map a field",
    xm_pick: "Choose…",
    xm_preview: "Show preview",
    xm_preview_title: "XML preview",
    xm_no_fields: "No fields mapped yet",
    xm_autofill: "Fill all fields",
    accf_number: "Number",
    accf_doc_type: "Document type",
    accf_date: "Date",
    accf_guest_name: "Customer",
    accf_guest_number: "Customer number",
    accf_vat_number: "VAT number",
    accf_status: "Status",
    accf_payment_method: "Payment method",
    accf_subtotal: "Subtotal",
    accf_tax_rate: "VAT rate",
    accf_tax_amount: "VAT amount",
    accf_total: "Total",
    accf_amount_due: "Amount due",
    accf_currency: "Currency",
    accf_credit_of_number: "Credit note of",
    accf_line_code: "Article code",
    accf_line_description: "Description",
    accf_line_qty: "Quantity",
    accf_line_unit_price: "Unit price",
    accf_line_vat_rate: "VAT rate (line)",
    accf_line_total: "Line total",
    nav_mailbox: "Mailbox",
    mb_inbox: "Inbox",
    mb_sent: "Sent",
    mb_archive: "Archive",
    mb_trash: "Trash",
    mb_search: "Search sender or subject…",
    mb_new: "New message",
    mb_reply: "Reply",
    mb_forward: "Forward",
    mb_send: "Send",
    mb_to: "To",
    mb_subject: "Subject",
    mb_message: "Message",
    mb_sent_ok: "Message sent",
    mb_moved: "Message moved",
    mb_mark_unread: "Mark as unread",
    mb_empty: "No messages in this folder",
    mb_pick: "Pick a message to read",
    mb_no_access: "You have no access to the shared mailbox. Ask an administrator to enable 'Mailbox access'.",
    mb_not_configured: "The shared reception mailbox is not configured yet. An administrator can do this in Admin > Mail & SMS.",
    mb_known_guest: "Known guest",
    mb_provisional: "provisional",
    mb_open_guest: "Open guest card →",
    mb_signature_hint: "Signed as {name} on behalf of the campsite.",
    mb_quote_hint: "The original message is quoted below.",
    mb_forward_hint: "The original message is attached.",
    mb_emails_of_guest: "E-mails from this guest",
    imap_title: "Incoming reception mailbox (IMAP) — receiving & reading",
    imap_desc: "Only for receiving and reading guest e-mails in CampAd Pro. Sending replies happens through the outgoing mail server (SMTP) above and is stored in the Sent folder.",
    imap_enabled: "Enable reception mailbox (incoming/IMAP)",
    imap_host: "IMAP server",
    imap_sent: "Sent folder",
    imap_archive: "Archive folder",
    imap_trash: "Trash folder",
    imap_test_ok: "Connection succeeded",
    imap_folders: "Folders",
    mb_do_search: "Search",
    mb_unanswered: "Unanswered e-mails",
    mb_unread: "Unread e-mails",
    mb_templates: "Reply templates",
    mb_quick_reply: "Quick reply",
    mb_pick_template: "Pick a template…",
    mb_tpl_name: "Name",
    mb_tpl_new: "New template",
    mb_tpl_delete_confirm: "Delete this template?",
    mb_tpl_placeholders: "Available fields",
    mb_make_reservation: "Create booking",
    mb_from_mail: "From e-mail",
    mb_pitch_type: "Pitch type",
    mb_dogs: "dog(s)",
    mb_emails: "E-mails",
    mb_no_email: "This guest has no e-mail address.",
    mb_none_with_guest: "No e-mails exchanged with this guest yet.",
    guest_data: "Details",
    mb_prefilled: "Sender details filled in — pick a pitch and dates and save as provisional.",
    mb_review_title: "Booking from e-mail",
    mb_review_hint: "Check the details from the e-mail and complete where needed.",
    mb_ask_info: "Ask for info",
    mb_still_needed: "needed",
    mb_not_booking_warn: "The AI did not clearly recognise this as a booking request.",
    mb_requested_pitch: "Requested pitch",
    avail_green: "Available",
    avail_orange: "Available with a move",
    avail_red: "Not available",
    avail_unknown: "Unknown pitch",
    avail_checking: "Checking availability…",
    avail_need_dates: "Enter arrival and departure to check availability.",
    avail_alts: "Free pitches in zone {zone}:",
    avail_no_alts: "No free pitches in the same zone.",
    avail_move_on: "On {date}: move from pitch {from} to {to}",
    move_plan_title: "Move plan will be created too",
    move_plan_single: "Single pitch instead",
    move_plan_moves: "move(s) scheduled",
    admin_vat: "VAT overview",
    admin_vat_desc: "VAT due per quarter (sales, invoices, deposits) with input VAT and balance.",
    incl_vat: "Incl. VAT",
    saldo: "Balance",
    vat_due: "VAT due",
    vat_input: "Input VAT",
    vat_to_pay: "To pay",
    vat_to_reclaim: "To reclaim",
    vat_deposit_note: "Deposits are shown separately and settled into invoices (not in the balance).",
    vat_input_note: "Input VAT comes from stock purchases and free cost lines (Admin → Expenses).",
    admin_expenses: "Expenses",
    admin_expenses_desc: "General purchases (energy, maintenance…) with amount + VAT%, counted in input VAT.",
    expense_new: "New expense",
    expenses_hint: "Add general costs here (energy, maintenance, insurance…). The VAT is included in the VAT overview.",
    expense_desc_ph: "e.g. Electricity, pool maintenance…",
    interim_last: "Last settlement",
    interim_due: "New settlement recommended",
    invoices_unpaid: "Unpaid",
    invoices_paid: "Paid",
    no_unpaid_invoices: "No unpaid invoices.",
    no_paid_invoices: "No paid invoices yet.",
    u_mailbox_access: "Mailbox access",
    u_mailbox_hint: "May read and answer the shared reception mailbox (administrators always).",
    ses_send_interval: "Bundle every",
    ses_interval_0: "Send immediately",
    ses_send_interval_hint: "With a bundling interval notices are grouped (e.g. every half hour or hour) so the service is not overloaded.",
    ses_will_send_at: "Will be sent at",
    ovw_ok: "Notices run automatically. No open issues.",
    ovw_attention: "Some notices need attention (rejected or past the deadline).",
    ovw_disabled: "The interface is off — nothing is being reported.",
    ovw_manual: "Automatic sending is off — an administrator sends manually.",
    ovw_manage: "Manage",
    ovw_next_send: "Next sending",
    ovw_recent: "Recent notices",
    iface_accounting: "Accounting",
    xls_desc: "Export data as an Excel file (.xlsx) to share or process further.",
    xls_pitches: "Pitches and occupancy",
    xls_pitches_desc: "All pitches with who is staying or arriving, from when until when.",
    xls_finance: "Financial in and out",
    xls_finance_desc: "Sales, paid invoices, purchases and bank deposits in the chosen period, with separate cash and card columns.",
    xls_download: "Download Excel",
    xls_done: "Excel file downloaded",
    ses_checkin_title: "Guardia Civil notice",
    ses_checkin_missing: "this data is still needed before check-in",
    ses_checkin_ok: "all traveller data is complete",
    provisional_list: "Provisional bookings",
    maint_ses_done: "One-time cleanup performed on",
    setup_provisional_reminder: "Provisional booking reminder (days before arrival)",
    setup_provisional_reminder_hint: "Guests with a still provisional booking automatically receive an e-mail this many days before arrival with a link to complete their details; the booking then becomes definitive.",
    send_complete_link: "E-mail completion link",
    complete_link_sent: "Completion link sent to",
    extend_complete_link: "Extend link (+24h)",
    complete_link_extended: "Link extended and resent to",
    completion_complete: "100% complete",
    completion_incomplete: "Incomplete",
    link_expired: "Completion link expired — extend or resend",
    send_confirmation_card: "E-mail confirmation card",
    confirmation_card_sent: "Confirmation card sent to",
    admin_loginlog: "Login log",
    admin_loginlog_desc: "Blocked and failed login attempts per day, with IP address — see how many bots are stopped.",
    admin_audit: "Change log",
    admin_audit_desc: "Who changed which user, and when. See exactly what each administrator modified.",
    audit_when: "Time",
    audit_actor: "Who",
    audit_action: "Action",
    audit_target: "Affected user",
    audit_details: "Details",
    audit_none: "No changes in this period",
    audit_all_actions: "All actions",
    audit_search: "Search by email…",
    audit_activated: "Activated",
    audit_deactivated: "Deactivated",
    audit_a_user_created: "User created",
    audit_a_user_updated: "User updated",
    audit_a_user_active_changed: "Active changed",
    audit_a_user_password_reset: "Password reset",
    audit_a_settings_updated: "Settings changed",
    audit_a_tariff_updated: "Tariff changed",
    audit_a_reservation_created: "Reservation created",
    audit_a_reservation_updated: "Reservation updated",
    audit_a_reservation_extended: "Reservation extended",
    audit_a_reservation_moved: "Reservation moved",
    audit_a_reservation_checkin: "Checked in",
    audit_a_reservation_deleted: "Reservation deleted",
    audit_a_sale_created: "Sale created",
    audit_a_sale_deleted: "Sale deleted",
    audit_a_cash_closed: "Cash day closed",
    audit_a_cash_deposit_created: "Deposit",
    audit_a_cash_deposit_cancelled: "Deposit cancelled",
    audit_stat_today: "Today",
    audit_stat_week: "This week (7 days)",
    audit_stat_by_actor: "Per staff member (30 days)",
    audit_export_csv: "CSV",
    audit_export_pdf: "PDF",
    ll_total: "Attempts",
    ll_bots: "Bots blocked",
    ll_period: "Period",
    ll_since: "since",
    ll_per_day: "Per day",
    ll_per_ip: "Per IP address",
    ll_recent: "Recent attempts",
    ll_none: "No blocked attempts in this period.",
    ll_last: "Last",
    ll_when: "When",
    ll_reason: "Reason",
    ll_identifier: "Username",
    ll_honeypot: "Honeypot (bot)",
    ll_too_fast: "Too fast (bot)",
    ll_challenge: "Puzzle failed (bot)",
    ll_turnstile: "Turnstile rejected",
    ll_ip_locked: "IP blocked",
    ll_account_locked: "Account locked",
    ll_wrong_password: "Wrong password",
    ll_block: "Block",
    ll_unblock: "Unblock",
    ll_blocked: "Blocked:",
    ll_unblocked: "Unblocked:",
    ll_blocked_badge: "BLOCKED",
    ll_blocklist: "Permanently blocked IP addresses",
    ll_ip_blocklist: "Blocklist (bot)",
    ll_day_title: "Logins per day",
    ll_ok: "successful",
    ll_failed: "failed",
    ll_day_none: "No logins on this day.",
    ll_login_ok: "Signed in",
    ll_out: "signed out/break",
    ll_logout: "Signed out",
    ll_logout_auto: "Signed out automatically",
    ll_pause: "Break",
    hours_day: "Day",
    hours_total: "Total",
    hours_day_none: "Nobody signed in on this day.",
    hours_open: "still signed in",
    hours_reason_logout: "Signed out",
    hours_reason_break: "Break",
    hours_reason_idle: "Closed automatically",
    hours_reason_auto: "Closed automatically",
    hours_reason_manual: "Entered manually",
    hours_reason_open: "Still signed in",
    hours_break: "Break",
    hours_no_break: "no break",
    hours_no_break_hint: "Worked more than 6 hours without a break",
    idle_warn_title: "Stay signed in?",
    idle_warn_text: "You will be signed out automatically in",
    idle_stay: "Stay signed in",
    draft_found: "Unfinished reservation recovered",
    draft_saved_at: "Saved automatically at sign-out on",
    draft_resume: "Resume",
    draft_discard: "Discard",
    draft_resumed: "Draft resumed — continue where you left off",
    draft_found_other: "Unfinished reservation by",
    draft_take: "Take over and finish",
    draft_taken_title: "Your draft was completed",
    draft_taken_text: "your unfinished reservation was taken over by",
    admin_interfaces_desc: "Connections with external services: authorities (Guardia Civil), accounting and other packages.",
    iface_available: "Available",
    iface_soon: "Coming soon",
    iface_open: "Open",
    iface_on: "Enabled",
    iface_off: "Disabled",
    iface_pending: "Pending",
    iface_rejected: "Rejected",
    iface_last_sent: "Last sent",
    iface_never: "never",
    iface_back: "All interfaces",
    ses_title: "SES.HOSPEDAJES",
    ses_subtitle: "Registro de viajeros · Ministerio del Interior · Real Decreto 933/2021",
    ses_tab_settings: "Settings",
    ses_tab_files: "Files",
    ses_tab_log: "Log",
    ses_readonly: "Read only — changes require finance class 5.",
    ses_enabled: "Interface active",
    ses_mode: "Environment",
    ses_mode_test: "Test (pre-production)",
    ses_mode_live: "Production (live)",
    ses_mode_hint: "Never both at once: all notices go to the selected environment. Production requires complete production credentials.",
    ses_codes: "SES identification",
    ses_arrendador: "codigoArrendador (operator)",
    ses_establecimiento: "codigoEstablecimiento (establishment)",
    ses_aplicacion: "Application name (aplicacion)",
    ses_creds_test: "Web service user — test",
    ses_creds_live: "Web service user — production",
    ses_user: "Username",
    ses_password: "Password",
    ses_pw_set: "set",
    ses_events: "Events that create a notice",
    ses_ev_rh: "Reservations (RH)",
    ses_ev_rh_desc: "New or changed reservation → reservation notice.",
    ses_ev_pv: "Arrivals (PV)",
    ses_ev_pv_desc: "Check-in → arrival registration with all travellers.",
    ses_ev_cancel: "Cancellations (B)",
    ses_ev_cancel_desc: "Deleted reservation → cancellation of the accepted notice.",
    ses_sending: "Sending",
    ses_auto_send: "Send automatically",
    ses_send_time: "Sending time (Europe/Madrid)",
    ses_send_time_hint: "Everything is sent at this time; changes after it (until midnight) go immediately. Empty = everything immediately.",
    ses_max_batch: "Max. notices per request",
    ses_payment: "Default payment type (TIPO_PAGO)",
    ses_mail_to: "Default e-mail address for files",
    ses_access: "Access",
    ses_reception_files: "Reception may view and e-mail files",
    ses_endpoints: "Endpoints (v3.1.2)",
    ses_files_desc: "Every notice is an XML file. Sent files are immutable; a correction = cancellation + new version.",
    ses_filter_all: "All",
    ses_filter_open: "Open",
    ses_filter_accepted: "Accepted",
    ses_filter_rejected: "Rejected",
    ses_search: "Search guest or pitch…",
    ses_col_file: "File",
    ses_col_content: "Content",
    ses_col_status: "Status",
    ses_col_created: "Created",
    ses_late: "Past the 24h deadline",
    ses_process_now: "Process queue now",
    ses_check_now: "Check status",
    ses_st_incomplete: "Incomplete",
    ses_st_ready: "Ready",
    ses_st_sending: "Sending",
    ses_st_received: "Received (batch)",
    ses_st_processing: "Processing",
    ses_st_accepted: "Accepted",
    ses_st_rejected: "Rejected",
    ses_st_uncertain: "Uncertain",
    ses_st_cancel_requested: "Cancellation requested",
    ses_st_cancelled: "Cancelled",
    ses_st_withdrawn: "Withdrawn",
    ses_missing: "Missing data",
    ses_view: "View",
    ses_xml: "XML content",
    ses_edit: "Edit",
    ses_save_xml: "Save XML",
    ses_send: "Send now",
    ses_resend: "Resend",
    ses_rebuild: "Rebuild from the reservation",
    ses_cancel: "Cancel at SES",
    ses_withdraw: "Withdraw",
    ses_download: "Download",
    ses_mail: "E-mail",
    ses_mail_to_label: "To",
    ses_mail_lang: "Message language",
    ses_mail_note: "Note (optional)",
    ses_mail_send: "Send by e-mail",
    ses_mailed: "E-mailed",
    ses_batch: "Batch (lote)",
    ses_codigo: "Communication code",
    ses_error: "Error",
    ses_version: "Version",
    ses_deadline: "Deadline",
    ses_by: "by",
    ses_log_desc: "Everything the interface does, in order.",
    ses_mode_badge_test: "TEST",
    ses_mode_badge_live: "LIVE",
    ses_no_creds: "Without credentials, files stay on \"Ready\" until they are filled in.",
    ses_immutable: "Sent file — immutable",
  },
  es: {
    app_name: "CampAd Pro",
    admin_camping: "Camping",
    admin_camping_desc: "Datos del camping",
    admin_map: "Plano",
    admin_map_desc: "Mapa y parcelas",
    admin_stock: "Existencias",
    admin_stock_desc: "Artículos y entregas",
    articles: "Artículos",
    new_article: "Nuevo artículo",
    art_code: "Código",
    art_name: "Nombre",
    art_category: "Categoría",
    art_unit: "Unidad",
    art_stock: "Existencias",
    art_min_stock: "Existencias mínimas",
    art_track_stock: "Controlar existencias",
    art_lines: "Líneas",
    unit_stuk: "unidad",
    unit_liter: "litro",
    unit_kg: "kg",
    unit_meter: "metro",
    unit_pak: "paquete",
    unit_uur: "hora",
    unit_dienst: "servicio",
    excl_vat: "sin IVA",
    price_incl_vat: "Total con IVA",
    bill_to: "Datos de facturación",
    billing_details: "Datos de facturación",
    articles_lines: "Artículos",
    print_invoice: "Imprimir factura",
    printed: "Impresa",
    not_printed: "No impresa",
    sale_open_title: "Venta sin finalizar:",
    sale_open_hint: "imprima primero la factura o anule la venta antes de iniciar otra.",
    cancel_sale: "Anular venta",
    art_price: "Precio",
    art_vat: "IVA %",
    art_qty: "Cantidad",
    rental_report: "Ingresos de alquiler por mes",
    rental_report_empty: "Todavía no hay alquileres este año.",
    rental_times_out: "veces alquilado",
    deposits_cash: "Fianzas en caja",
    cash_expected: "Esperado en caja",
    nav_verhuur: "Alquiler",
    rental_out_today: "Entregar hoy",
    rental_back_today: "Se espera hoy",
    rental_out_now: "Fuera ahora",
    rental_overdue: "Devolución atrasada",
    rental_deposit_todo: "Fianza por cobrar",
    rental_deposit_open: "Fianza pendiente",
    deposit: "Anticipo",
    deposit_paid: "Anticipo pagado",
    deposit_open: "Anticipo pendiente",
    deposit_resend: "Reenviar enlace de pago",
    deposit_resend_q: "¿Reenviar el enlace de pago?",
    deposit_resend_hint: "Enviaremos de nuevo a {name} un correo con el enlace de pago de Stripe para el anticipo de {amount}.",
    deposit_resend_sent: "Enlace de pago reenviado a",
    amount_due: "Importe a pagar",
    admin_prepayments: "Anticipos",
    admin_prepayments_desc: "Resumen de anticipos recibidos online por período para la contabilidad.",
    deposit_settled: "Compensado",
    deposit_unsettled: "Por compensar",
    by_month: "Por mes",
    by_week: "Por semana",
    no_deposits_year: "No hay anticipos en este año.",
    per_year: "Por año",
    per_quarter: "Trimestre",
    custom_range: "Personalizado",
    pick_range_hint: "Elija una fecha de inicio y fin para mostrar el informe.",
    vat_breakdown: "Desglose por período de declaración",
    btw: "IVA",
    drilldown_hint: "Haga clic para ver los anticipos subyacentes",
    showing: "Mostrando",
    show_all: "Mostrar todo",
    yes: "Sí",
    no: "No",
    deposit_received: "Fianza recibida",
    deposit_refund: "Devuelta",
    deposit_refunded: "fianza devuelta",
    admin_revenue: "Ingresos por mes",
    admin_revenue_desc: "Parcelas, impuesto turístico, alquiler y tienda por mes. Las facturas anteriores a esta versión aparecen en 'Otros'.",
    rev_pitch: "Parcelas", rev_tax: "Impuesto turístico", rev_rental: "Alquiler", rev_shop: "Tienda", rev_other: "Otros", rev_total: "Total",
    deposit_receipt: "Justificante de fianza",
    admin_rentals: "Alquiler",
    admin_rentals_desc: "Artículos que alquilas (nevera, cuna…) con precio, fianza y descripción en todos los idiomas.",
    admin_tariffs: "Tarifas",
    group_daily: "Diario",
    group_billing: "Contabilidad",
    group_manage: "Gestión",
    collapse: "Replegar",
    theme_dark: "Modo oscuro",
    theme_light: "Modo claro",
    theme_auto_hint: "Turno de noche: sigue automáticamente la puesta de sol del camping",
    kpi_arrivals: "Llegadas",
    kpi_overdue: "atrasados",
    kpi_departures: "Salidas",
    kpi_open_invoices: "Facturas pendientes",
    kpi_late_rentals: "Alquileres atrasados",
    kpi_stock: "Existencias",
    extend_stay: "Prolongar",
    extend_other_date: "Otra fecha de salida",
    extend_ok: "Estancia prolongada hasta el",
    day: "día",
    days: "días",
    kpi_stock_negative: "artículos en negativo",
    ai_translate: "Traducir con IA",
    art_names: "Nombre en otros idiomas (para el ticket y la factura del cliente)",
    art_names_hint: "Las marcas, volúmenes y tamaños no se traducen. ¿Vacío? Entonces se usa el nombre en neerlandés.",
    art_translate_all: "Completar todas las traducciones",
    ai_translating: "Trabajando…",
    ai_translated: "Traducciones completadas",
    twofa_sent: "Código enviado a",
    twofa_sub: "Introduce el código que enviamos por SMS a",
    twofa_code: "Código SMS (6 dígitos)",
    twofa_confirm: "Confirmar",
    twofa_resend: "Enviar un nuevo código",
    t_twofa: "Verificación en dos pasos por SMS",
    t_twofa_short: "2FA",
    t_twofa_on: "Activo",
    t_twofa_hint: "Los administradores de este camping reciben un código por SMS al iniciar sesión. El número proviene de su ficha de usuario (con prefijo país, p. ej. +34 612 345 678).",
    t_turnstile: "Verificación Cloudflare (anti-bot)",
    t_turnstile_short: "Anti-bot",
    t_turnstile_hint: "Los visitantes resuelven una breve comprobación de Cloudflare (casi siempre invisible) al iniciar sesión y en los formularios públicos. Activada por defecto; solo el administrador principal puede cambiarlo.",
    t_demo_short: "Demo",
    t_demo: "Permitir demo para este camping",
    t_demo_hint: "Permite que este camping use el modo demo (datos ficticios). Solo el administrador principal puede permitirlo. Si está desactivado, el camping no ve ninguna función de demostración. 'Sí' se muestra en rojo porque la demo no es para uso real.",
    flag_confirm: "¿{state} '{flag}' para {name}?",
    flag_on: "Activar",
    flag_off: "Desactivar",
    user_phone_hint: "Con prefijo del país, p. ej. +34 612 345 678 — aquí se envía el código de verificación.",
    admin_tariffs_desc: "Tarifa base por zona, tarifas por período, precio por ítem y paquetes.",
    tariff_base: "Tarifas base por zona",
    tariff_base_desc: "Esta tarifa se aplica cuando no existe una tarifa de período para esa fecha.",
    tariff_periods: "Tarifas por período",
    tariff_periods_desc: "Tarifa para un período concreto. Deja la zona vacía para aplicarla a todas las zonas.",
    tariff_items: "Tarifa por ítem",
    tariff_items_desc: "Precio por ítem del formulario de entrada y de la ficha impresa. Puedes añadir tus propios ítems.",
    tariff_packages: "Paquetes",
    tariff_packages_desc: "Combina ítems en un paquete, p. ej. 1 caravana + 2 personas + perro.",
    tariff_price_night: "Precio",
    tariff_tourist_tax: "Tasa turística",
    tariff_children_free: "Niños exentos",
    tariff_default: "predeterminado",
    tariff_period_name: "Nombre",
    tariff_from: "Desde",
    tariff_to: "Hasta",
    tariff_all_zones: "Todas las zonas",
    tariff_pct: "% sobre la tarifa base",
    tariff_apply_pct: "Calcular",
    tariff_pct_hint: "Calcula los precios como % de la tarifa base. Después cada importe sigue siendo editable.",
    tariff_overrides: "Tarifas de ítems para este período",
    tariff_item_key: "Clave",
    tariff_item_label: "Ítem",
    tariff_item_mode: "Cálculo",
    tariff_mode_night: "Por noche",
    tariff_mode_once: "Una vez",
    tariff_mode_stay: "Por estancia",
    tariff_mode_fixed: "Importe total fijo",
    tariff_mode_discount: "% de descuento sobre la suma",
    tariff_new_item: "Nuevo ítem",
    tariff_countable: "Con cantidad",
    tariff_new_package: "Nuevo paquete",
    tariff_package: "Paquete",
    tariff_package_mode: "Cálculo",
    tariff_package_content: "Contenido",
    tariff_package_total: "Precio total",
    tariff_discount_pct: "% descuento",
    tariff_include_pitch: "Parcela incluida en el paquete",
    tariff_package_hint: "Con un importe total fijo el paquete sustituye los precios individuales de esos ítems.",
    tariff_save_first: "Guarda primero el período",
    tariff_calculated: "Tarifas calculadas",
    tariff_name_required: "El nombre es obligatorio",
    tariff_price_estimate: "Estimación de precio",
    tariff_no_package: "Sin paquete",
    tariff_no_tariffs: "Aún no hay tarifas configuradas (Admin → Tarifas).",
    new_rental_item: "Nuevo artículo de alquiler",
    rental_names: "Descripción por idioma (para la factura del huésped)",
    rental_pricing: "Cálculo", pricing_day: "Por día", pricing_week: "Por semana", pricing_stay: "Por estancia",
    rental_qty_owned: "En propiedad", rental_deposit: "Fianza",
    rentals: "Alquiler", rental_add: "Añadir alquiler", rental_item: "Artículo de alquiler",
    rental_none: "Aún no hay alquileres para esta reserva.",
    rental_available: "disponibles", rental_return: "Devuelto", rental_returned: "devuelto",
    rental_billed_until: "facturado hasta", rental_deposit_note: "Fianza (aparte, se devuelve al entregar)",
    change_period: "Cambiar periodo", until_date: "Hasta",
    interim_invoice: "Factura intermedia", bill_until: "Facturar hasta", end_last_month: "Fin del mes pasado",
    admin_suppliers: "Proveedores",
    admin_suppliers_desc: "Tus proveedores con sus datos y los precios acordados por artículo.",
    new_supplier: "Nuevo proveedor",
    select_supplier: "Elige un proveedor…",
    sup_name: "Nombre", sup_contact: "Persona de contacto", sup_mobile: "Móvil", sup_website: "Web",
    sup_street: "Calle", sup_number: "Número", sup_postal: "Código postal", sup_city: "Ciudad",
    sup_vat: "NIF/IVA", sup_company_nr: "Nº de empresa", sup_iban: "IBAN", sup_bic: "BIC",
    sup_customer_nr: "Nuestro nº de cliente", sup_payment_terms: "Condiciones de pago", sup_delivery_days: "Días de entrega",
    sup_prices: "Precios acordados",
    sup_prices_desc: "Por artículo una o varias líneas: a partir de qué cantidad se aplica qué precio unitario (p. ej. 1 ud = 5 €, desde 10 uds = 4,80 €).",
    sup_from_qty: "Desde cantidad", sup_unit_price: "Precio/ud",
    stays: "Estancias", stay_now: "Alojado ahora", stay_future: "Próxima", stay_past: "Pasada",
    admin_purchases: "Facturas de compra",
    admin_purchases_desc: "Entregas de proveedores; aumentan las existencias.",
    admin_sales_inv: "Facturas de venta",
    admin_sales_desc: "Historial de todas las facturas de venta creadas (contabilidad).",
    invoice_footer_note: "Factura emitida en euros. Importes con IVA según el cálculo anterior.",
    vat_of: "sobre",
    view_planning: "Planificación",
    view_map: "Mapa",
    view_today: "Hoy",
    toggle_view_hint: "Elige aquí mapa o planning",
    print_plus_hint: "Imprimir + ficha de registro",
    planning_hint: "Arrastra una reserva para moverla · doble clic para detalles · desplázate para navegar",
    jump_to_pitch: "Parcela arriba…",
    quick_booking: "Reserva rápida",
    quick_booking_now: "Entrada rápida",
    quick_max_nights: "Libre hasta la siguiente reserva: máx. noches",
    quick_free_until: "la parcela vuelve a estar ocupada desde",
    quick_mode_reserved: "Reserva (llega más tarde)",
    quick_mode_booking: "Estancia — el huésped está aquí",
    planning_months_back: "Planificación: meses atrás",
    planning_months_ahead: "Planificación: meses adelante",
    beschikbaar_dagen: "Disponible: días para nuevos clientes",
    available_new: "Disponible (nuevo)",
    mark_occupied: "Marcar como ocupada",
    search_guest: "Buscar un huésped…",
    marked_occupied: "La parcela está ocupada",
    which_guest: "¿Qué cliente ocupa esta parcela?",
    occupy_without_guest: "Ocupada, sin nombre",
    back_to_tray: "Volver a la bandeja",
    back_to_tray_done: "La parcela ha vuelto a la bandeja",
    drop_here_hint: "Arrastre un punto aquí para devolverlo a la bandeja",
    admin_cashclose: "Cierre de caja",
    admin_cashclose_desc: "Resumen diario de las ventas, recuento de efectivo y cierre del día.",
    admin_guestbook: "Libro de visitas",
    loading_data: "Cargando datos…",
    pay_card: "Tarjeta",
    sale_pick_first: "Haga clic primero en el huésped o en ‘De paso’ arriba",
    sale_pick_lines: "Añada al menos un artículo",
    invoice_finish: "Finalizar factura",
    invoice_finish_hint: "Elija cómo recibe el huésped la factura. Puede elegir ambas; la factura siempre se puede reimprimir o reenviar después desde Facturas.",
    invoice_finish_print_hint: "Abre la factura en una ventana nueva",
    invoice_finish_no_email: "No hay correo electrónico registrado",
    invoice_finish_confirm: "Finalizar",
    cash_card_total: "Tarjeta",
    cash_card_hint: "Los pagos con tarjeta no están en la caja y por tanto no cuentan para el efectivo a contar.",
    number_from: "Número (desde)",
    number_to: "hasta (opcional)",
    pitch_bulk_hint: "Deje 'hasta' vacío para crear una sola parcela. Máximo 50 por vez. Las parcelas existentes se omiten.",
    pitches_created: "{n} parcelas creadas",
    pitches_skipped: "{n} ya existían y se han omitido",
    admin_guestbook_desc: "Valoraciones de los huéspedes que se alojaron con usted. Reciben automáticamente una invitación amable unos días después de su salida.",
    gb_invited: "Invitados",
    gb_submitted: "Completadas",
    gb_rate: "Tasa de respuesta",
    gb_overall: "General",
    gb_cleanliness: "Limpieza",
    gb_sanitary: "Sanitarios",
    gb_welcome: "Acogida",
    gb_value: "Relación calidad-precio",
    gb_comment: "Comentario",
    gb_public: "Puede ser pública",
    gb_public_hint: "Solo lo que marque aquí aparece en la página pública del libro de visitas. Por defecto todo queda interno.",
    gb_waiting: "Aún sin completar",
    gb_send_now: "Enviar invitaciones ahora",
    gb_dry_run: "Contar primero",
    gb_sent_count: "{n} invitación(es) enviada(s)",
    gb_candidates: "{n} huésped(es) cumplen los requisitos",
    gb_none: "Todavía no hay valoraciones.",
    gb_enabled: "Pedir una valoración automáticamente",
    gb_delay: "Días después de la salida",
    gb_guest: "Huésped",
    gb_stay: "Estancia",
    gb_public_page: "Página pública",
    setup_review_enabled: "Pedir una valoración automáticamente",
    setup_review_days: "Días después de la salida",
    admin_email: "Correo y SMS",
    sms_title: "SMS (Spryng)",
    sms_desc: "SMS salientes (códigos de verificación, avisos).",
    sms_enabled: "Usar SMS vía Spryng",
    sms_originator: "Remitente (nombre/número)",
    sms_route: "Ruta",
    sms_token: "Token API",
    sms_test: "SMS de prueba",
    sms_test_ok: "SMS de prueba enviado",
    admin_email_desc: "Esta página tiene dos partes: correo SALIENTE (SMTP) para enviar y responder, y el buzón de recepción ENTRANTE (IMAP) para leer correos de huéspedes. Configura ambos para un funcionamiento completo.",
    smtp_section_title: "Correo saliente (SMTP) — enviar y responder",
    smtp_section_desc: "El servidor que CampAd Pro usa para enviar correos: facturas y tus respuestas a los huéspedes. Sin esto puedes recibir correos pero no enviar.",
    mail_need_smtp_warn: "Recibes correos a través del buzón de recepción, pero para responder o enviar debes primero rellenar y activar el servidor de correo saliente (SMTP) abajo.",
    smtp_enabled: "Usar mi propio servidor de correo (saliente/SMTP)",
    smtp_host: "Servidor SMTP",
    smtp_port: "Puerto",
    smtp_security: "Cifrado",
    smtp_username: "Usuario",
    smtp_from_email: "Correo del remitente",
    smtp_from_name: "Nombre del remitente",
    smtp_password: "Contraseña",
    smtp_password_set: "configurada",
    smtp_test: "Probar conexión",
    smtp_test_ok: "Conexión con el servidor de correo correcta",
    smtp_fallback_hint: "La factura se envía en el idioma del huésped, con el PDF adjunto.",
    cash_close: "Cerrar caja",
    cash_closed: "Caja cerrada",
    cash_counted: "Efectivo contado",
    cash_difference: "Diferencia",
    cash_unprinted: "Facturas aún no impresas",
    cash_closures: "Cierres anteriores",
    cash_auto: "automático",
    email_invoice: "Enviar factura",
    email_sent: "Factura enviada a",
    no_email_print: "No hay correo electrónico — imprima la factura.",
    no_vat_number_warning: "Atención: todavía no hay número de IVA para el camping. Indíquelo en Admin → Camping antes de imprimir facturas.",
    no_stock_tracking: "sin control",
    low_stock: "Bajo mínimo",
    low_stock_alert: "Alerta de stock",
    oos_note_required: "Una observación es obligatoria para 'fuera de servicio'",
    oos_only_from_free: "Una parcela solo puede ponerse fuera de servicio si está libre",
    oos_until: "Fuera de servicio hasta",
    oos_until_hint: "Déjelo vacío para permanente — la parcela queda fuera de servicio hasta que la libere.",
    oos_permanent: "Fuera de servicio permanente",
    map_search_ph: "Parcela o nombre…",
    map_search_btn: "Buscar",
    map_search_none: "No se encontró nada en el mapa",
    no_reservation_found: "No hay reserva para esta parcela",
    no_active_stay: "No hay estancia activa en esta parcela",
    remove_reservation_q: "¿Eliminar la reserva?",
    remove_reservation_hint: "Se eliminará la reserva de {name} y la parcela quedará libre. Los datos del cliente se conservan.",
    reservation_removed_guest_kept: "Reserva eliminada — datos del cliente conservados",
    setup_stock_alert_hour: "Hora de la alerta de stock",
    setup_stock_alert_enabled: "Correo diario de stock",
    setup_stock_alert_hint: "Cada día a esta hora los administradores reciben los artículos bajo mínimo por correo.",
    setup_audit_retention: "Conservar registro",
    setup_audit_retention_unit: "días",
    setup_audit_retention_hint: "El registro de cambios conserva las entradas durante estos días. Las más antiguas se eliminan automáticamente cada noche a medianoche.",
    setup_intro_music: "Música de bienvenida",
    setup_intro_music_on: "Música al iniciar sesión",
    setup_intro_music_hint: "Vivaldi — Las Cuatro Estaciones, \"Primavera\" (dominio público) suena brevemente al iniciar sesión.",
    setup_stationery: "Papelería / pie de documento",
    setup_stationery_hint: "Estos datos aparecen en el pie de facturas, tickets, justificantes de fianza y fichas de inscripción. Los días se imprimen en el idioma del cliente.",
    setup_bank_name: "Nombre del banco",
    setup_iban: "IBAN",
    setup_bic: "BIC",
    setup_footer_extra: "Texto adicional del pie (p. ej. número de empresa)",
    setup_opening_hours: "Horario de recepción",
    setup_closed: "Cerrado",
    setup_hour_seasons: "Horarios por temporada",
    setup_hour_seasons_hint: "Añada periodos (p. ej. temporada alta 15/06 → 15/09). También se admiten periodos que cruzan el fin de año. Los documentos muestran el horario del periodo vigente; fuera de esos periodos se usa el horario estándar de arriba.",
    setup_season_name: "Nombre de la temporada",
    settle_merged: "Parcelas liquidadas juntas (misma fecha de salida)",
    settle_parallel_warn: "Este huésped también ocupa",
    settle_parallel_ask: "¿Liquidarla también y cerrarla en la fecha de liquidación?",
    settle_sales_added: "Ventas pendientes añadidas a la factura",
    settle_open_invoices: "Facturas pendientes de este huésped",
    settle_total_open: "Total pendiente",
    overdue_dep_title: "Salidas atrasadas",
    overdue_dep_msg_one: "huésped ha superado su fecha de salida",
    overdue_dep_msg_many: "huéspedes han superado su fecha de salida",
    overdue_dep_view: "Ver detalles",
    overdue_dep_hide: "Ocultar detalles",
    overdue_dep_days: "días de retraso",
    overdue_dep_day: "día de retraso",
    overdue_dep_open: "Pendiente",
    outstanding_title: "Pendiente de pago",
    outstanding_none: "Este huésped no tiene nada pendiente.",
    outstanding_sales: "Ventas a cuenta",
    outstanding_deposits: "Fianzas pendientes",
    mobile_apps: "Apps móviles (Inspection / Visitors)",
    mobile_apps_hint: "Medidas del plano y calibración GPS que usan las apps móviles. Origen: esquina superior izquierda.",
    plan_width: "Ancho del plano",
    plan_height: "Alto del plano",
    plan_unit_px: "Unidad: píxeles del plano (igual que la web).",
    calib_nw_lat: "NO latitud",
    calib_nw_lng: "NO longitud",
    calib_se_lat: "SE latitud",
    calib_se_lng: "SE longitud",
    calib_bearing: "Rotación (°)",
    calib_opacity: "Opacidad (0-1)",
    admin_inspection: "Control (app)",
    admin_inspection_desc: "Avisos y presencia en vivo de los controladores",
    inspection_reports: "Avisos de la app de control",
    inspection_presence: "Controladores en el campin",
    inspection_open: "Ver pendientes",
    inspection_handled: "Ver resueltos",
    inspection_new_report: "Nuevo aviso de control",
    inspection_goto: "Ir a los avisos",
    reset_pw: "Restablecer contraseña",
    reset_pw_confirm: "¿Restablecer la contraseña a la inicial (= el correo electrónico)?",
    reset_pw_done: "Contraseña restablecida al correo electrónico",
    reset_pw_tooltip: "Restablecer contraseña: vuelve al correo electrónico como contraseña; el usuario deberá cambiarla en el próximo inicio de sesión",
    reset_pw_hint: "El usuario inicia sesión con su correo electrónico como contraseña y después debe elegir una nueva.",
    reset_pw_legend: "La llave amarilla = restablecer contraseña: vuelve a la contraseña inicial (= el correo electrónico); el usuario debe cambiarla en el próximo inicio de sesión.",
    admin_maintenance: "Mantenimiento",
    admin_maintenance_desc: "Sincronizar estados de parcelas y limpiar datos de prueba",
    admin_menu: "Disposición del menú",
    admin_menu_desc: "Define por rol qué elementos del menú son visibles y en qué grupo/orden",
    menu_role: "Rol",
    menu_hint: "Los elementos se agrupan en el menú lateral por grupo; el orden de abajo define el orden dentro de cada grupo. El administrador principal siempre lo ve todo.",
    menu_visible: "Visible",
    menu_group: "Grupo",
    menu_reset: "Restablecer",
    menu_drag: "Arrastra para cambiar el orden",
    menu_saved: "Disposición del menú guardada",
    menu_groups: "Grupos",
    menu_add_group: "Añadir grupo",
    menu_delete_group: "Eliminar grupo",
    menu_items_label: "Elementos del menú",
    maint_pitches: "Sincronizar estados de parcelas",
    maint_pitches_hint: "Ajusta el estado de cada parcela a las reservas de hoy. Las parcelas fuera de servicio no se tocan.",
    maint_pitches_confirm: "¿Sincronizar todos los estados con las reservas?",
    maint_to_fix: "Parcelas por ajustar",
    maint_sync_now: "Sincronizar ahora",
    maint_testdata: "Limpiar datos de prueba",
    maint_testdata_hint: "Elimina huéspedes, reservas, facturas y ventas que parecen de prueba. Las facturas y ventas con numeración correcta (p. ej. 2026-0005) se conservan siempre.",
    maint_testdata_confirm: "¿Eliminar definitivamente estos datos de prueba? No se puede deshacer.",
    maint_found: "Registros de prueba encontrados",
    maint_cleanup_now: "Limpiar ahora",
    maint_guest: "Huésped",
    maint_reservation: "Reserva",
    maint_invoice: "Factura",
    maint_sale: "Venta",
    mark_handled: "Resuelto",
    insp_observed: "Estado observado",
    insp_photo: "Ver foto",
    insp_cat_status_klopt_niet: "El estado no coincide",
    insp_cat_verkeerde_locatie: "Ubicación incorrecta",
    insp_cat_onbruikbaar: "Inutilizable",
    insp_cat_andere: "Otro",

    pay_link: "Enlace de pago",
    pay_link_copied: "Enlace de pago copiado",
    pay_online: "Pago en línea",
    payment_ok_title: "¡Pago recibido!",
    payment_ok_text: "Gracias. Su factura está marcada como pagada.",
    payment_pending_title: "Procesando el pago…",
    payment_pending_text: "Esperamos la confirmación del banco. No cierre esta página.",
    payment_failed_title: "El pago no se ha completado",
    payment_failed_text: "Vuelva a intentarlo o pregunte en recepción.",
    payment_cancel_title: "Pago cancelado",
    payment_cancel_text: "No se ha cobrado nada. Puede intentarlo de nuevo cuando quiera.",




    order_advice: "Propuesta de pedido",
    order_advice_desc: "Artículos bajo mínimo, agrupados por proveedor habitual",
    order_advice_none: "Ningún artículo bajo mínimo — nada que pedir",
    no_supplier: "Sin proveedor habitual",
    art_supplier: "Proveedor habitual",
    art_order_qty: "Cantidad de pedido",
    art_order_qty_hint: "Deje 0 para pedir solo la diferencia hasta el mínimo.",
    order_qty_short: "A pedir",
    order_mail: "Enviar pedido por correo",
    order_print: "Imprimir pedido",
    order_mail_sent: "Pedido enviado",
    order_mail_to: "Para",
    order_mail_subject: "Asunto",
    order_mail_message: "Mensaje",
    order_no_email: "Este proveedor no tiene correo electrónico",
    low_stock_msg: "artículo(s) en o por debajo del stock mínimo",
    goto_stock: "Ir al stock",
    search_article: "Buscar artículo…",
    stock_desc: "Las existencias solo cambian por una venta, una entrega con factura de compra o una corrección de un administrador.",
    stock_rule_hint: "Las existencias no se pueden escribir: use una entrega o una corrección.",
    stock_history: "Historial de existencias",
    move_kind: "Motivo",
    move_sale: "Venta",
    move_delivery: "Entrega",
    move_correction: "Corrección",
    new_correction: "Registrar corrección (rotura, inventario)",
    correction_reason: "Motivo",
    deliveries: "Entregas (facturas de compra)",
    new_delivery: "Nueva entrega",
    book_delivery: "Registrar entrega",
    delivery_booked: "Entrega registrada",
    delivery_hint: "Al registrarla, las existencias de cada línea aumentan y el movimiento queda vinculado a esta factura.",
    supplier: "Proveedor",
    purchase_price: "Precio de compra",
    select_article: "Elegir artículo…",
    ask_admin_article: "¿Nuevo artículo? Pregunte a su administrador.",
    sale_step_1: "Parcela",
    sale_step_2: "Cliente y pago",
    sale_step_3: "Artículos",
    search_stay: "Buscar por parcela o nombre…",
    walkin: "Visitante (sin parcela)",
    walkin_title: "Crear visitante",
    walkin_hint: "Crea una reserva provisional (máx. 48 h) y envía de inmediato un enlace QR + correo de bienvenida (válido 24 h) en el idioma del huésped.",
    walkin_need_fields: "El nombre y el correo son obligatorios",
    walkin_created: "Visitante creado",
    walkin_mail_sent: "Correo de bienvenida enviado",
    walkin_qr_hint: "Deje que el huésped escanee este código QR para registrarse.",
    walkin_create: "Crear + enviar",
    walkin_hours: "Horas (máx. 48)",
    actions: "Acciones",
    bf_last_name: "Apellido",
    bf_email: "Correo",
    nav_jobs: "Tareas",
    jobs_none: "No se encontraron tareas",
    job_task: "Tarea",
    job_assignee: "Controlador",
    job_unassigned: "Sin asignar",
    job_mark_done: "Hecho",
    job_done: "Tarea completada",
    job_new: "Nueva tarea",
    job_edit: "Editar tarea",
    job_title: "Título",
    job_category: "Categoría",
    job_priority: "Prioridad",
    job_due: "Fecha límite",
    job_detail: "Detalle",
    job_status: "Estado",
    job_saved: "Tarea guardada",
    job_deleted: "Tarea eliminada",
    job_delete_confirm: "¿Eliminar esta tarea?",
    job_all_assignees: "Todo el personal",
    tab_active: "Activas",
    tab_done: "Hechas",
    tab_all: "Todas",
    cat_power: "Electricidad", cat_repair: "Reparación", cat_cleaning: "Limpieza",
    cat_inspection: "Control", cat_delivery: "Entrega", cat_other: "Otro",
    prio_laag: "Baja", prio_normaal: "Normal", prio_hoog: "Alta", prio_dringend: "Urgente",
    status_open: "Abierta", status_assigned: "Asignada", status_busy: "En curso",
    status_done: "Hecha", status_cancelled: "Cancelada",
    demo_off_purge_confirm: "¿Desactivar la demo para {name}? Se eliminarán definitivamente {n} registros de demostración.",
    sale_billing: "Facturación",
    sale_private: "Particular",
    sale_company: "A empresa",
    no_company: "Este huésped no tiene empresa: la venta va a nombre particular.",
    payment: "Pago",
    pay_cash: "Pagado en efectivo",
    pay_account: "A cuenta (factura final)",
    save_cash: "Venta + pago en efectivo",
    save_account: "Venta a cuenta",
    stock_negative_warning: "las existencias quedarán negativas",
    back: "Atrás",
    next: "Siguiente",
    company: "Empresa",
    company_on_account: "A cargo de una empresa",
    company_name: "Nombre de la empresa",
    company_hint: "Estos datos aparecen en la factura si se factura a la empresa.",
    parking: "Estado del parking",
    find_parking: "Ir al estado del parking en el mapa",
    search_placeholder: "Buscar por nombre, matrícula o parcela…",
    search_in_screen: "Buscar en esta pantalla…",
    booker: "Titular",
    occupants: "Titular y acompañantes",
    tab_adult: "Adulto",
    tab_child: "Niño",
    complete: "Completo",
    complete_hint: "Complete la estancia y pulse Completo para poder rellenar los acompañantes.",
    stay_approved: "Estancia aprobada",
    stay_approved_hint: "Ahora puede rellenar los acompañantes.",
    id_required_over12: "El número de DNI o pasaporte es obligatorio a partir de 12 años.",
    same_address_hint: "Dirección (propuesta: la misma que el titular, modificable)",
    occupant_period: "Estancia de esta persona (dentro de la reserva)",
    no_extra_occupants: "Sin acompañantes: aumente el número de adultos o niños en la estancia.",
    occupants_incomplete: "Acompañantes incompletos",
    dblclick_hint: "doble clic para acercar, Mayús+doble clic para alejar",
    multi_select_hint: "Ctrl+clic (o Mayús+clic) para seleccionar varias y luego haga clic en el mapa donde debe empezar la cuadrícula",
    selected_n: "{n} seleccionadas",
    placed_n: "{n} parcelas colocadas en el mapa",
    grid_place: "Colocar en cuadrícula en el mapa",
    pan_hint: "arrastre el mapa con el ratón para moverlo",
    size: "Tamaño",
    size_1: "Pequeño",
    size_2: "Medio",
    size_3: "Grande",
    tenants: "Campings (clientes)",
    tenants_desc: "Solo el administrador principal ve esta tabla. El dominio determina qué camping corresponde a una dirección; el dominio de correo determina qué usuarios pueden crearse.",
    t_slug_hint: "p. ej. cap-blanch (vacío = automático del nombre)",
    t_slug_fixed: "El código es la clave de todos los datos de este camping y no se puede cambiar después.",
    t_domain: "Dominio",
    t_domain_hint: "¿Varias direcciones web? Sepárelas con una coma. La pantalla exterior y la pantalla de acceso siguen siempre la dirección con la que abre la aplicación.",
    t_handover: "Traspasar dirección",
    t_handover_desc: "La dirección web {domains} pasa al camping que elija abajo. {name} quedará inactivo: ya no se podrá trabajar en él, pero no se pierde nada. Solo es posible si ese camping ya no contiene datos.",
    t_handover_target: "Traspasar a",
    t_handover_do: "Traspasar dirección",
    t_handover_ok: "La dirección web {domains} se ha traspasado y el camping anterior está inactivo",
    t_delete_confirm: "¿Eliminar definitivamente el camping {name}? Solo es posible si no queda ningún dato y no se puede deshacer.",
    t_delete_ok: "El camping {name} se ha eliminado",
    t_name: "Nombre del camping",
    t_email_domain: "Dominio de correo de usuarios",
    t_slug: "Código",
    t_admin_email: "Correo del primer administrador (opcional)",
    new_tenant: "Nuevo camping",
    switch_tenant: "Trabajar en este camping",
    switched: "Camping activo cambiado",
    active_camp: "Camping activo",
    t_users: "Usuarios",
    t_pitches: "Parcelas",
    zones: "Zonas",
    new_zone: "Nueva zona",
    zone_code: "Código",
    zone_name: "Nombre",
    zone_new_inline: "Crear nueva zona…",
    zone_created: "Zona creada",
    zones_desc: "Las zonas definen la estructura del camping. Al crear una parcela eliges una zona existente o creas una nueva.",
    role_superadmin: "Administrador principal",
    setup: "Setup — camping",
    setup_desc: "Todos los datos propios del camping. Se utilizan en la barra lateral, la pantalla de acceso, las fichas, las facturas y los correos.",
    setup_payment_title: "Solicitud de pago",
    setup_payment_desc: "Determina el importe que debe pagar un huésped en una solicitud de pago en línea.",
    setup_payment_full: "Importe total",
    setup_payment_deposit: "Anticipo",
    setup_deposit_type: "Tipo de anticipo",
    setup_deposit_percent: "Porcentaje",
    setup_deposit_amount: "Importe fijo",
    setup_camp_name: "Nombre del camping",
    camping: "Camping",
    setup_street: "Calle y número",
    setup_postal_city: "Código postal y localidad",
    setup_country: "País",
    setup_phone: "Teléfono",
    setup_email: "Correo electrónico",
    setup_website: "Web (botón en la pantalla de acceso)",
    setup_gps: "Coordenadas GPS",
    setup_vat_number: "NIF/CIF",
    setup_vat_rate: "IVA estándar %",
    setup_tourist_tax: "Tasa turística por persona/noche",
    setup_currency: "Moneda",
    setup_default_lang: "Idioma por defecto",
    setup_base_lang: "Idioma base (origen de las traducciones)",
    setup_base_lang_hint: "El idioma en que están redactados los correos y las fichas para huéspedes y desde el cual se traduce a los demás idiomas de la UE. Elija solo uno: NL, ES o EN.",
    pretranslate_label: "Preparar idiomas",
    pretranslate: "Pretraducir todos los idiomas ahora",
    pretranslate_hint: "Prepara una sola vez los correos y las fichas para los huéspedes en todos los idiomas de la UE, para que el primer huésped en un idioma nuevo no tenga que esperar. Se ejecuta en segundo plano.",
    pretranslate_started: "Pretraducción iniciada — se ejecuta en segundo plano",
    pretranslate_done: "Todos los idiomas están listos",
    setup_logo: "Logotipo (barra lateral, ficha, factura)",
    setup_logo_tent: "Logotipo pequeño (barra plegada)",
    setup_emergency: "Números de emergencia (ficha)",
    setup_info_items: "Información general en la ficha",
    setup_label: "Descripción",
    setup_number: "Número",
    upload: "Subir",
    save: "Guardar",
    add: "Añadir fila",
    tagline: "Gestión del camping",
    login_title: "Bienvenido de nuevo",
    login_sub: "Inicie sesión para acceder a la gestión del camping",
    forgot_password: "¿Olvidó su contraseña?",
    reset_phone: "Número de móvil",
    reset_email_label: "Correo electrónico",
    reset_request_sub: "Introduzca su correo y su número de móvil. Recibirá un correo con un enlace de recuperación y un SMS con un código.",
    reset_request_btn: "Solicitar recuperación",
    reset_sent_msg: "Si esta cuenta existe, le enviaremos un correo (y un SMS) con las instrucciones de recuperación.",
    back_to_login: "Volver a iniciar sesión",
    reset_title: "Establecer nueva contraseña",
    reset_code: "Código SMS (6 dígitos)",
    reset_submit: "Establecer contraseña",
    reset_done: "Su contraseña ha sido cambiada. Ya puede iniciar sesión.",
    reset_invalid_link: "El enlace de recuperación no es válido o ha caducado. Solicite uno nuevo en la pantalla de inicio de sesión.",
    reset_pw_mismatch: "Las contraseñas no coinciden.",
    email: "Correo electrónico",
    password: "Contraseña",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    logging_in: "Iniciando sesión...",
    nav_dashboard: "Resumen",
    nav_aankomend: "Llegadas",
    nav_zoekers: "Buscadores",
    assign_pitch: "Asignar parcela",
    overdue_label: "Atrasado",
    no_zoekers: "No hay buscadores sin parcela",
    nav_reservaties: "Reservas",
    nav_vertrekkend: "Salidas",
    nav_afrekening: "Liquidación intermedia",
    nav_verhuizen: "Cambio de parcela",
    nav_verbeteringen: "Mejoras",
    nav_gasten: "Huéspedes",
    nav_verkopen: "Ventas sueltas",
    nav_facturen: "Crear facturas",
    nav_admin: "Admin",
    menu: "Menú",
    campsite_overview: "Resumen del camping",
    occupancy_zone: "Ocupación por zona",
    kpi_vrij: "Libres según el sistema",
    kpi_bezet: "Ocupadas",
    kpi_controle: "Requiere control",
    kpi_rood: "Cinta roja",
    legend: "Leyenda",
    arriving_today: "Llegadas hoy",
    departing_today: "Salidas hoy",
    zone: "Zona",
    free: "Libre",
    occupied: "Ocupado",
    reserved: "Reservado",
    pitch: "Parcela",
    status: "Estado",
    note: "Nota",
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    u_barcode: "Número de código de barras",
    users_hide_inactive: "Ocultar inactivos",
    users_show_inactive: "Mostrar inactivos",
    users_info: "Datos",
    users_search: "Buscar por alias, nombre, correo o rol...",
    guests_search: "Buscar por nombre, matrícula, parcela o correo...",
    pitch_note_placeholder: "Nota breve...",
    pitch_note_saved: "Nota guardada",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    guest: "Huésped",
    guests: "Huéspedes",
    new_guest: "Nuevo huésped",
    first_name: "Nombre",
    last_name: "Apellido",
    phone: "Teléfono",
    language: "Idioma",
    country: "País",
    license_plate: "Matrícula",
    notes: "Notas",
    documents: "Documentos",
    upload: "Subir",
    upload_hint: "Permitido: PDF, JPG, PNG, WEBP, HEIC · máx 15 MB",
    upload_bad_type: "Este tipo de archivo no se permite. Permitido: PDF, JPG, PNG, WEBP, HEIC.",
    upload_too_big: "Archivo demasiado grande (máx 15 MB).",
    finder_title: "Buscar parcela para un período",
    finder_search: "Buscar",
    finder_direct: "Libre de inmediato (0 cambios)",
    finder_one: "Disponible con 1 cambio",
    finder_two: "Disponible con 2 cambios",
    finder_none: "No se encontraron parcelas para este período",
    finder_move_arrow: "cambio el",
    move_planned: "Cambios programados",
    move_pending: "Por ejecutar",
    move_done: "Ya ejecutados",
    move_execute: "Ejecutado",
    move_due: "Hoy",
    move_other_zone: "otra zona",
    finder_plan_title: "Reservar con cambio",
    finder_create: "Reservar",
    finder_created: "Reserva con cambio(s) programado(s) creada",
    finder_first: "Nombre",
    finder_last: "Apellido",
    finder_persons: "Personas",
    reservation: "Reserva",
    reservations: "Reservas",
    new_reservation: "Nueva reserva",
    arrival: "Llegada",
    departure: "Salida",
    persons: "Personas",
    checkin: "Registrar entrada",
    print_registration: "Imprimir ficha + formulario de inscripción",
    checkout: "Registrar salida",
    to_reservation: "Ir a la reserva",
    pitch3d_hint: "Haz clic en una parcela para ver huésped y estancia",
    move: "Cambiar parcela",
    to_pitch: "A la parcela",
    invoice: "Factura",
    invoices: "Facturas",
    new_invoice: "Nueva factura",
    invoice_number: "Número de factura",
    description: "Descripción",
    qty: "Cantidad",
    unit_price: "Precio",
    subtotal: "Subtotal",
    tax: "IVA",
    total: "Total",
    new: "Nueva",
    users: "Usuarios",
    main_booker: "Titular principal",
    ribbon_guest: "Cinta roja — trabaja para el camping, parcela preferente (opcional)",
    until: "hasta",
    free_until: "libre hasta",
    drop_photos: "Arrastre fotos o PDF aquí",
    still_needed: "Falta",
    departure_before_arrival: "La salida es anterior a la llegada",
    quote_range_warn: "El período parece demasiado largo. Compruebe las fechas (año).",
    quote_per_month: "promedio por mes",
    inv_unpaid: "No pagada",
    inv_paid: "Pagada",
    pay: "Pagar",
    pay_registered: "Pago registrado",
    pay_m_cash: "Efectivo",
    pay_m_card: "Tarjeta",
    pay_m_split: "Dividido",
    pay_split_note: "Pago dividido: parte efectivo, parte tarjeta.",
    bf_first_name: "Nombre", bf_last_name: "Apellidos", bf_email: "Correo", bf_birth_date: "Fecha de nacimiento", bf_street: "Calle", bf_house_number: "Número",
    bf_postal_code: "Código postal", bf_city: "Localidad", bf_country: "País", bf_passport_number: "Nº de pasaporte", bf_passport_country: "País de expedición", bf_passport_place: "Lugar de expedición",
    plate: "Matrícula",
    print_fiche: "Imprimir ficha",
    print_fiche_map: "Imprimir ficha + mapa",
    confirm_delete_reservation: "¿Eliminar esta reserva?",
    passport_docs: "Documentos (pasaporte / DNI)",
    take_photo: "Hacer foto",
    choose_files: "Elegir archivos",
    docs_uploaded: "documento(s) subido(s)",
    open: "Abrir",
    nav_verblijven: "Estancias",
    search_staying: "Buscar por nombre, apodo o ubicación…",
    no_staying: "No se encontraron estancias",
    email_invalid: "Correo electrónico no válido (p. ej. nombre@dominio.es)",
    email_no_domain: "Este dominio no existe o no recibe correo",
    type_pitch: "Escriba la ubicación, p. ej. T12…",
    no_free_pitch: "No hay ubicación libre para este período",
    pick_existing_guest: "Elegir huésped existente…",
    chosen_pitch: "Ubicación elegida",
    period: "Período",
    your_stay: "Su estancia",
    passport: "Nº de pasaporte",
    issue_country: "País de expedición",
    issue_place: "Lugar de expedición",
    card_number: "Nº de tarjeta",
    valid_until: "Válida hasta",
    power: "Electricidad",
    stay_adults: "Adultos", stay_children: "Niños (4-12)", stay_dogs: "Perro",
    stay_car: "Coche", stay_caravan: "Caravana", stay_mobilhome: "Autocaravana", stay_trailer: "Remolque", stay_tent: "Tienda",
    stay_moto: "Moto", stay_boat: "Barco", stay_mobilhome9: "Autocaravana > 9 m", stay_bungalow: "Bungalow", stay_cabin: "Cabaña",
    conflict_bungalow_cabin: "Bungalow no puede combinarse con cabaña",
    conflict_unit_accommodation: "Caravana, autocaravana o tienda no pueden combinarse con bungalow o cabaña",
    save_provisional: "Guardar provisional",
    save_definitive: "Cerrar definitivo",
    definitive_hint: "Definitivo: todos los datos del titular son obligatorios; se envía confirmación por correo en su idioma.",
    provisional_hint: "Provisional: solo ubicación, nombre y apellidos obligatorios.",
    missing_fields: "Complete todos los campos obligatorios marcados",
    mail_sent: "Correo de confirmación enviado",
    provisional: "Provisional",
    birth_future: "La fecha de nacimiento no puede ser futura",
    new_user: "Nuevo usuario",
    u_number: "Número",
    cash_opening: "Caja inicial",
    cash_keep: "Cambio en caja",
    live_updated: "En vivo · actualizado",
    admin_deposits: "Ingresos en banco",
    deposits_desc: "Todos los ingresos con número correlativo, por mes o por año (clase financiera 4 o 5).",
    deposits_next_number: "Siguiente número",
    deposits_seq_hint: "Los números son correlativos por año y no pueden ser inferiores al último usado.",
    deposit_cancel: "Anular",
    deposit_cancelled: "Anulado",
    deposit_cancel_hint: "El número se conserva, pero el importe ya no cuenta.",
    deposit_cancel_reason: "Motivo de la anulación",
    cash_deposit_interim: "Ingreso parcial",
    cash_deposit_where: "El ingreso se hace en Admin → Cierre de caja.",
    cash_deposit_interim_hint: "El importe se descuenta de la caja al momento y recibes un justificante.",
    cash_deposit_account: "Cuenta bancaria",
    cash_deposit_receipt: "Justificante de ingreso",
    cash_deposit_origin: "Origen",
    cash_sign_staff: "Firma del empleado",
    cash_sign_bank: "Firma del banco",
    cash_banked_today: "Ingresado durante el día",
    cash_account_paid: "Efectivo en facturas pendientes",
    cash_account_card: "Tarjeta en facturas pendientes (info)",
    cash_account_hint: "Los pagos en efectivo de facturas pendientes (a cuenta) cuentan en la caja en la fecha de pago. Los pagos con tarjeta se muestran solo a título informativo.",
    cash_online_deposits: "Anticipos online recibidos",
    cash_online_deposits_hint: "Anticipos pagados online (pagos anticipados vía Stripe). Se indican por separado — no cuentan en la caja.",
    admin_season: "Resumen anual",
    season_desc: "Ingresos, diferencias de caja y horas por empleado de un año o temporada (solo clase financiera 5).",
    season_year: "Año",
    season_from: "Desde",
    season_to: "Hasta",
    season_staff: "Por empleado",
    m_jan: "enero",
    m_feb: "febrero",
    m_mar: "marzo",
    m_apr: "abril",
    m_may: "mayo",
    m_jun: "junio",
    m_jul: "julio",
    m_aug: "agosto",
    m_sep: "septiembre",
    m_oct: "octubre",
    m_nov: "noviembre",
    m_dec: "diciembre",
    cash_max_enabled: "Avisar si la caja está llena",
    cash_max_limit: "Máximo en caja (€)",
    cash_max_hint: "Si hay más efectivo en caja que este importe, recepción recibe un aviso para ingresar parte.",
    cash_level_warning: "Hay mucho efectivo en caja — haz un ingreso parcial",
    cash_sellers_today: "Vendido ese día",
    cash_deposit: "Ingreso en banco",
    cash_deposit_register: "Registrar ingreso",
    cash_deposit_by: "Llevado al banco por",
    cash_deposit_by_ph: "nombre del empleado",
    amount: "Importe",
    cash_count_show: "Contar billetes y monedas",
    cash_count_hide: "Cerrar contador",
    cash_count_hint: "Introduce la cantidad; el total se calcula automáticamente.",
    cash_diff_weeks: "Diferencias de caja por semana",
    cash_diff_list: "Lista de diferencia de caja",
    cash_diff_history: "Diferencias de caja anteriores por vendedor",
    cash_diff_history_opt: "Incluir historial por vendedor",
    cash_last_8: "8 semanas",
    cash_last_13: "13 semanas",
    cash_this_year: "Este año",
    cash_days_with_diff: "Días con diferencia",
    cash_max_diff: "Mayor diferencia",
    admin_seller_revenue: "Ingresos por empleado",
    seller_revenue_desc: "Ingresos por empleado según la tarjeta usada en la venta.",
    cash_alert_enabled: "Avisar si hay diferencia de caja",
    cash_alert_limit: "Importe límite (€)",
    cash_alert_hint: "Si la diferencia supera este importe, los administradores con clase financiera 5 reciben un correo.",
    cash_to_deposit: "A ingresar",
    cash_not_closed: "Aún no cerrado",
    cash_signature: "Comprobado por / fecha",
    seller: "Empleado",
    staff_scan: "Escanea la tarjeta para cambiar de empleado",
    staff_scan_ph: "Escanea la tarjeta o escribe el número de personal",
    shift_note_hint: "Nota breve para el siguiente turno (opcional)",
    shift_note_ph: "p. ej. baños B limpiados · parcela A12 avisa de un problema de agua",
    shift_notes_title: "Notas del turno",
    hours_mail_enabled: "Enviar resumen semanal",
    hours_mail_day: "Día",
    hours_mail_hour: "Hora",
    hours_mail_hint: "El resumen de la semana anterior se envía a los administradores con clase financiera 5.",
    u_min_week_hours: "Horas mín. por semana",
    u_min_week_hint: "0 = sin mínimo (horario flexible)",
    admin_hours: "Registro de horas",
    my_hours: "Mis horas",
    break: "Pausa",
    break_hint: "Pausa: se cierra la sesión y el tiempo se registra como pausa",
    hours_week: "Semana",
    hours_month: "Mes",
    hours_worked: "Trabajadas",
    hours_planned: "Previstas",
    hours_diff: "Diferencia",
    hours_min: "Mínimo",
    hours_days_worked: "Días trabajados",
    hours_desc: "Las horas provienen del inicio y cierre de sesión. Haz clic en un día para revisar o corregir.",
    hours_desc_own: "Tus propias horas, registradas automáticamente al iniciar y cerrar sesión.",
    hours_none: "Sin registros este día",
    hours_open: "en curso",
    hours_idle: "Inactividad",
    hours_auto: "Cerrado automáticamente",
    hours_manual: "Manual",
    hours_add: "Añadir registro",
    u_badge: "Tarjeta",
    login_identifier: "Correo electrónico o número de tarjeta",
    login_identifier_ph: "nombre@ejemplo.com o escanea tu tarjeta",
    u_staff_number: "Número de personal",
    u_staff_hint: "Opcional, debe ser único",
    u_number_hint: "Generado automáticamente (EAN13)",
    u_idle: "Cierre automático tras (min, mínimo 60)",
    u_nickname: "Apodo",
    u_birth: "Fecha de nacimiento",
    u_role: "Tipo/rol",
    u_street: "Calle",
    u_house: "Nº",
    u_postal: "Código postal",
    u_city: "Localidad",
    u_workdays: "Días y horarios de trabajo estándar",
    role_admin: "Administrador",
    u_finance_class: "Clase financiera",
    u_finance_hint: "Derechos financieros extra para un usuario normal. Los administradores siempre tienen todo.",
    fin_0: "0 – sin derechos financieros",
    fin_1: "1 – facturas y cobros",
    fin_2: "2 – también cierre de caja",
    fin_3: "3 – también resúmenes financieros",
    fin_4: "4 – también editar tarifas",
    fin_5: "5 – todo lo financiero",
    role_reception: "Recepción",
    role_controller: "Controlador",
    role_personeel: "Personal",
    day_mon: "Lu", day_tue: "Ma", day_wed: "Mi", day_thu: "Ju", day_fri: "Vi", day_sat: "Sá", day_sun: "Do",
    active: "Activo",
    inactive: "Desactivado",
    activate: "Activar",
    deactivate: "Desactivar",
    pw_pending: "contraseña pendiente de cambio",
    user_pw_info: "La contraseña temporal es igual al correo electrónico. En el primer inicio de sesión el usuario debe elegir una nueva contraseña.",
    user_created_hint: "Usuario creado — contraseña temporal = correo electrónico",
    nav_wachtwoord: "Contraseña",
    change_password: "Cambiar contraseña",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    repeat_password: "Repetir nueva contraseña",
    pw_requirements: "Requisitos",
    pw_rule_length: "Mínimo 10 caracteres",
    pw_rule_upper: "Al menos 1 mayúscula",
    pw_rule_lower: "Al menos 1 minúscula",
    pw_rule_digit: "Al menos 1 número",
    pw_rule_special: "Al menos 1 signo de puntuación",
    pw_rule_match: "Las dos contraseñas nuevas coinciden",
    pw_changed: "Contraseña cambiada",
    pw_first_login: "Primer inicio de sesión: elija primero una nueva contraseña. Su contraseña actual es su correo electrónico.",
    guest_created: "Huésped creado y seleccionado",
    save_guest: "Guardar huésped",
    final_invoice: "Liquidación final",
    checkout_and_invoice: "Check-out + liquidación final",
    checkout_only: "Check-out sin factura",
    no_departures: "No hay salidas pendientes de check-out",
    nights: "noches",
    pitch_fee: "Parcela",
    tourist_tax: "Tasa turística",
    electricity: "Electricidad",
    add_line: "Añadir línea",
    description: "Descripción",
    qty: "Cantidad",
    unit_price: "Precio",
    subtotal: "Subtotal",
    vat: "IVA",
    checked_out_ok: "Check-out realizado",
    sales_included: "Ventas sueltas de este huésped",
    new_arrival: "Nueva llegada (reserva + check-in)",
    no_arrivals: "No hay llegadas pendientes de check-in",
    checked_in_ok: "Registrado",
    vrij: "Libre",
    bezet: "Ocupado",
    gereserveerd: "Reservado",
    add_line: "Añadir línea",
    send: "Enviar",
    send_email: "Enviar por correo",
    sent: "Enviada",
    open: "Abierta",
    view: "Ver",
    sales: "Ventas sueltas",
    new_sale: "Nueva venta",
    date: "Fecha",
    needs_attention: "Parcelas que necesitan atención",
    mark_free: "Marcar como libre",
    no_data: "Sin datos",
    settings: "Ajustes",
    camping_map: "Mapa del camping",
    upload_map: "Subir mapa",
    logged_in_as: "Conectado como",
    select_guest: "Seleccionar huésped",
    select_pitch: "Seleccionar parcela",
    saved: "Guardado",
    use: "usar",
    move_from: "Desde parcela",
    move_to: "A parcela",
    move_pick_free: "Elige una parcela libre",
    move_none_free: "No hay parcelas libres en esta zona",
    move_all_zones: "Todas las zonas",
    move_reason: "Motivo del traslado",
    invoice_mark_paid: "Marcar como pagada",
    invoice_unpay: "Volver a pendiente",
    invoice_marked_paid: "Factura marcada como pagada",
    invoice_paid_today: "Se usa la fecha de hoy como fecha de pago.",
    payment_method: "Forma de pago",
    pay_cash: "Efectivo",
    pay_card: "Tarjeta",
    pay_transfer: "Transferencia",
    pay_other: "Otro",
    move_free_whole_stay: "La lista solo muestra parcelas libres hasta el final de esta estancia.",
    move_reason_default: "A petición del cliente",
    invoice_delivery_ask: "¿Quieres imprimir esta factura o enviarla por correo al huésped?",
    invoice_print_and_mail: "Imprimir y enviar",
    invoice_later: "Más tarde",
    invoice_mailed: "Factura enviada al huésped",
    setup_login_style: "Pantalla de acceso",
    setup_reminder_days: "Recordatorio de pago tras (días)",
    setup_reminder_repeat: "Repetir recordatorio tras (días)",
    setup_reminder_max: "nº máx.",
    setup_reminder_repeat_hint: "Tras el primer recordatorio, el siguiente solo se envía después de estos días. Introduzca 0 en 'nº máx.' para recordar sin límite.",
    setup_reminder_enabled: "Enviar automáticamente",
    setup_overdue_reminder: "Recordatorio para salidas atrasadas",
    setup_display: "Pantalla exterior en la entrada",
    setup_demo: "Demo",
    setup_demo_on: "Permitir datos de demostración",
    setup_demo_on_ok: "Demo activada: ahora aparece un botón rojo en cada pantalla operativa",
    demo_fill_label: "Ocupación demo",
    demo_fill_hint: "Demo: llena la camping al azar con parcelas demo hasta el % ocupado y % reservado elegido (sin cliente). Se borra al desactivar la Demo.",
    demo_fill_occupied: "% ocupado",
    demo_fill_reserved: "% reservado",
    demo_fill_apply: "Aplicar",
    demo_fill_reset: "Borrar",
    demo_fill_sum_err: "Ocupado + reservado juntos no pueden superar el 100%",
    demo_fill_done: "Ocupación demo actualizada — {b} ocupadas, {r} reservadas añadidas",
    setup_demo_off_ok: "Demo desactivada, se han eliminado todos los datos de demostración",
    setup_demo_purge_confirm: "Se eliminarán {n} registros de demostración (huéspedes, reservas, facturas, ventas, alquileres, valoraciones). ¿Continuar?",
    setup_demo_hint: "Si está marcada, aparece un botón rojo abajo a la derecha en cada pantalla operativa (nunca en Admin). Cada pulsación añade 1 registro ficticio en esa pantalla para poder probar en bloque. Al desmarcarla se eliminan todos los datos de demostración.",
    setup_demo_allowed: "Permitir demo para este camping",
    setup_demo_allowed_hint: "Solo el superadministrador puede permitir la demo. Mientras esté desactivada, este camping no ve ninguna función de demostración.",
    setup_demo_unavailable: "La demo no está disponible para este camping. Pida al superadministrador que la active.",
    pitch_continue: "Continuar",
    dummy_add: "Añadir demo",
    dummy_added: "Registro de demostración añadido",
    dummy_added_bulk: "Registros de demostración añadidos",
    dummy_add_hint: "Pulsación corta = 1 registro ficticio; pulsación larga = 10 de una vez",
    demo_banner: "Modo demo activo: los registros añadidos se eliminan al desmarcar la casilla",
    demo_banner_count: "registros de demostración",
    setup_display_none: "Aún sin código: pulse «Código nuevo»",
    setup_display_copy: "Copiar",
    setup_display_copied: "Enlace copiado",
    setup_display_mismatch: "Atención: estás trabajando en {work}, pero esta dirección web pertenece a {host}. La pantalla exterior sigue siempre la dirección web: cambia primero a {host} (Admin → Campings → Trabajar en este camping) y sube allí el logotipo y los horarios.",
    setup_display_new: "Código nuevo",
    setup_display_new_ok: "Código nuevo creado: el enlace anterior ya no funciona",
    setup_display_hint: "Abra este enlace en el televisor o la tableta de la entrada: muestra «bienvenido» y el número de parcelas libres en 25 idiomas. Verde por debajo del 90 % de ocupación, naranja por encima del 90 % y rojo con «COMPLETO» por encima del 98 %. Se actualiza en vivo con cada cambio.",
    setup_overdue_reminder_hint: "Cada mañana a las 09:00 un correo amable (y SMS cuando Spryng esté activo) a los huéspedes que han superado su fecha de salida: como máximo uno al día.",
    setup_interim_reminder: "Recordatorio de liquidación parcial (días)",
    setup_interim_reminder_hint: "Envía automáticamente al huésped un correo amable cuando la última liquidación parcial (o la llegada) fue hace más de estos días. Se ejecuta con los recordatorios diarios de las 09:00.",
    setup_interim_auto: "Factura parcial automática (días mín.)",
    setup_interim_auto_hint: "Crea automáticamente una factura parcial mensual para los huéspedes que se quedan más de estos días. Solo se cobra el nuevo periodo desde la última liquidación, se descuentan las ventas a cuenta y los anticipos pendientes, y el PDF se envía como adjunto. Se ejecuta a las 09:00.",
    setup_reminder_hint: "Cada mañana el huésped con una factura pendiente recibe un recordatorio amable con el PDF, repetido como máximo cada semana.",
    setup_dunning: "Recordatorios de pago (avisos)",
    setup_dunning_hint: "Envía automáticamente recordatorios de pago de las facturas pendientes, con la factura como PDF adjunto y en el idioma del huésped. Se ejecuta cada mañana a las 09:00.",
    setup_dunning_tiers: "Avisos tras (días): 1º · 2º · 3º",
    setup_dunning_tiers_hint: "Tres avisos sucesivos con tono progresivo: un recordatorio amable (1º), un aviso claro (2º) y un último aviso (3º). Por defecto a los 15, 30 y 45 días. Cada nivel se envía como máximo una vez por factura.",
    invoice_reminders_run: "Enviar recordatorios ahora",
    invoice_reminders_done: "Recordatorios enviados",
    dunning_label: "Avisos de pago",
    dunning_none: "Aún no se ha enviado ningún aviso",
    dunning_tier_name_1: "1er recordatorio",
    dunning_tier_name_2: "2º aviso",
    dunning_tier_name_3: "Último aviso",
    dunning_overdue: "días de retraso",
    dunning_filter_label: "Filtrar por aviso:",
    dunning_filter_all: "Todas",
    dunning_customer_number: "Nº de cliente",
    dunning_report_summary_title: "Resumen de avisos",
    dunning_report_incasso_title: "Expediente de cobro",
    dunning_report_generated: "Generado el",
    dunning_stays: "Estancias",
    dunning_total_due: "Total pendiente",
    dunning_print_summary: "Imprimir resumen",
    dunning_print_incasso: "Imprimir expediente de cobro",
    setup_login_style_sober: "Sobria",
    setup_login_style_original: "Original (foto)",
    setup_login_style_scene3d: "Escena 3D",
    demo_reset: "Restablecer demo",
    demo_reset_confirm: "¿Restablecer por completo los datos de la demo Camping CampAd Pro?",
    demo_reset_done: "Entorno demo restablecido",
    meter_reading: "Contador de electricidad",
    meter_arrival: "Lectura a la llegada (kWh)",
    meter_now: "Lectura actual",
    meter_start_label: "Lectura inicial",
    meter_consumption: "Consumo",
    meter_last_known: "Última lectura conocida",
    meter_last_unknown: "Aún sin lectura",
    meter_recalc: "Recalcular",
    tariff_power: "Electricidad",
    tariff_power_desc: "Precio por kWh del consumo entre lecturas. Cada periodo puede tener su propio precio por kWh.",
    tariff_kwh_price: "Precio por kWh",
    tariff_mode_month: "Por mes empezado",
    tariff_mode_month_prorata: "Por mes, prorrateado por día",
    deleted: "Eliminado",
    created: "Creado",
    doc_language: "Idioma del documento",
    interim_billing: "Liquidación intermedia",
    checked_in_guests: "Huéspedes registrados",
    create_invoice_for: "Crear factura para",
    total_pitches: "Total de parcelas",
    edit_layout: "Mover parcelas",
    editing_layout: "Arrastre los marcadores a su lugar en el mapa",
    done: "Listo",
    reset_positions: "Posiciones por defecto",
    assign_guest: "Asignar huésped",
    occupied_by: "Ocupado por",
    none_selected: "Ninguno",
    flags: "Marcas",
    parking_capacity: "Capacidad",
    parking_occupied: "Ocupado",
    accommodation: "Alojamiento",
    zoom_in: "Acercar",
    zoom_out: "Alejar",
    map_hint: "Haga clic en una parcela para ver detalles · si está ocupada verá el nombre del huésped al pasar el ratón",
    map_help: "Ayuda del mapa",
    handover_today: "Traspaso hoy",
    map_update: "Actualizar mapa",
    map_update_desc: "Crear parcelas, colocarlas en el mapa, moverlas o eliminarlas (solo parcelas libres).",
    new_pitch: "Crear nueva parcela",
    zone: "Zona",
    number: "Número",
    label_optional: "Etiqueta (opcional)",
    label_optional_hint: "Nombre propio para una sola parcela, p.ej. T20X. Entonces no se puede una serie.",
    type: "Tipo",
    shape: "Forma",
    color: "Color",
    add: "Añadir",
    kind_pitch: "Parcela",
    kind_bungalow: "Bungalow",
    kind_cabin: "Cabaña",
    shape_circle: "Redondo",
    shape_square: "Cuadrado",
    shape_diamond: "Rombo",
    unplaced_pitches: "Por colocar — arrastre al mapa",
    unplaced_empty: "Todas las parcelas están en el mapa.",
    pitch_created: "Parcela creada — arrástrela al mapa",
    delete_only_free: "Solo se pueden eliminar parcelas libres",
    zoom_hint: "use la rueda del ratón para hacer zoom",
    fit_width: "Ajustar al ancho",
    fit_height: "Ajustar a la altura",
    total_occupancy: "Ocupación total",
    totals: "Totales",
    red_ribbons: "Cintas rojas",
    red_ribbons_total: "Número total de cintas rojas (stock)",
    print: "Imprimir",
    print_map: "Imprimir mapa (A4)",
    print_plus: "Print+",
    print_plus_title: "Print+ · mapa + reserva",
    print_plus_desc: "Registre la llegada: buscamos al cliente (primero el correo), creamos de inmediato una reserva provisional e imprimimos el mapa con el formulario. El huésped puede completar el cuestionario más tarde a través de la app.",
    print_plus_confirm: "Imprimir + reserva",
    existing_guest_found: "Cliente existente encontrado — datos rellenados",
    reservation_created: "Reserva provisional creada",
    print_plus_send_card: "Enviar ahora por correo la ficha + el plano al huésped",
    card_sent_to: "Ficha enviada por correo a {email}",
    card_mailed: "Ficha enviada",
    confirm_long_stay: "El período es superior a 6 meses — confírmelo.",
    check: "Buscar",
    print_planning: "Imprimir planificación (A3)",
    print_planning_desc: "Elige el mes. La planificación se imprime en A3 horizontal, lista para recepción.",
    month: "Mes",
    same_pitch: "misma parcela",
    linked_stays: "Estancias enlazadas",
    chain_all_booking: "Todo como reserva en curso",
    merge_stays: "Combinar",
    jump_search: "Parcela, huésped, matrícula, tel. o correo…",
    act_merge: "combinado",
    undo: "Deshacer",
    redo: "Rehacer",
    act_quick_booking: "reserva rápida",
    act_quick_checkin: "reserva en curso",
    act_move: "mover",
    act_resize: "duración cambiada",
    act_split: "dividido",
    act_move_split: "trasladado",
    act_chain_checkin: "todo como reserva en curso",
    move_date: "Fecha del traslado",
    split_move_desc: "Haz doble clic en una barra para trasladar desde un día concreto. La estancia se divide y el historial se mantiene.",
    history: "Historial",
    planning_month_title: "Planificación mensual",
    broken_block_legend: "Continúa fuera del mes",
    print_period_desc: "Indique el período de estancia previsto. Debajo del mapa aparecerá un resumen de las parcelas libres por zona en ese período.",
    from: "Desde",
    to: "Hasta",
    period: "Período",
    free_pitches_period: "Parcelas libres en el período",
    total: "Total",
    admin_interfaces: "Interfaces",
    maint_ses: "SES.HOSPEDAJES — estancias no conformes",
    maint_ses_hint: "Las reservas y estancias sin los datos obligatorios del viajero (fecha de nacimiento, documento, domicilio, país reconocido, contacto) no pueden comunicarse a la Guardia Civil. La limpieza elimina estas reservas y libera sus parcelas. Los huéspedes se conservan.",
    maint_ses_now: "Eliminar estancias no conformes y liberar parcelas",
    maint_ses_confirm: "Todas las reservas indicadas se eliminarán definitivamente y se liberarán las parcelas. ¿Continuar?",
    nav_interfaces: "Interfaces",
    iface_tab_overheid: "Autoridades",
    iface_tab_boekhouding: "Contabilidad",
    credit_note: "Nota de crédito",
    credit_note_confirm: "¿Crear una nota de crédito para esta factura? La factura quedará bloqueada.",
    credit_note_created: "Nota de crédito creada:",
    credited: "Acreditada",
    edit_invoice: "Editar factura",
    accounting_locked: "Enviado a contabilidad — bloqueado",
    acc_manual_export: "Exportación manual",
    acc_automate: "Automatizar",
    acc_selection: "Selección",
    acc_documents: "documento(s)",
    acc_csv_sep: "Separador CSV",
    acc_csv_sep_hint: "Separador para CSV (p. ej. ; o ,)",
    acc_format: "Descargar formato",
    acc_export_note: "Una exportación manual marca los documentos como 'enviados'; después quedan bloqueados.",
    acc_export_done: "Exportación descargada",
    acc_export_empty: "No hay documentos en esta selección",
    acc_scope_unsent: "Aún no enviado",
    acc_scope_week: "Esta semana",
    acc_scope_quarter: "Este trimestre",
    acc_scope_year: "Este año",
    fmt_text: "Texto plano",
    acc_trigger: "Activador",
    acc_trigger_manual: "Manual",
    acc_trigger_daily: "Automático diario",
    acc_trigger_weekly: "Automático semanal",
    acc_trigger_quarterly: "Automático trimestral",
    acc_destinations: "Destinos",
    acc_vars_hint: "Variables en la descripción: {camping}, {datum}, {periode}, {aantal}",
    acc_sender: "Remitente",
    acc_recipient: "Destinatario",
    acc_description: "Descripción (con variables)",
    acc_path: "Carpeta/ruta",
    acc_user: "Usuario",
    acc_password: "Contraseña",
    acc_no_dest: "Aún no hay destinos configurados",
    acc_run_now: "Enviar ahora",
    acc_grp_documents: "Documentos",
    acc_grp_spreadsheets: "Hojas de cálculo",
    acc_grp_data: "Datos",
    acc_what_to_send: "Qué enviar",
    acc_when: "Cuándo",
    acc_add_dest: "Añadir destino",
    acc_sent_now: "Enviado",
    xm_title: "XML personalizado",
    xm_enable: "Usar XML personalizado",
    xm_enable_hint: "Sustituye el XML estándar por tus propios nombres de campo y estructura.",
    xm_structure: "Estructura XML",
    xm_root: "Elemento raíz",
    xm_doc_el: "Elemento documento",
    xm_line_wrap: "Envoltorio de líneas",
    xm_line_el: "Elemento línea",
    xm_sources: "Qué documentos",
    xm_src_invoices: "Facturas",
    xm_src_credits: "Notas de crédito",
    xm_src_sales: "Ventas a cuenta",
    xm_xsd: "Esquema XSD",
    xm_xsd_hint: "Sube un XSD para elegir los nombres de campo de destino. Sin XSD los escribes tú.",
    xm_xsd_upload: "Subir XSD",
    xm_xsd_loaded: "campos encontrados",
    xm_not_in_xsd: "no en XSD",
    fill_required: "Rellena los campos obligatorios marcados en azul.",
    xm_xsd_clear: "Borrar XSD",
    xm_doc_fields: "Campos de documento",
    xm_line_fields: "Campos de línea (por línea de factura/venta)",
    xm_app_field: "Campo de la app",
    xm_xml_field: "Nombre de campo XML",
    xm_add_row: "Asignar un campo",
    xm_pick: "Elegir…",
    xm_preview: "Mostrar vista previa",
    xm_preview_title: "Vista previa XML",
    xm_no_fields: "Aún no hay campos asignados",
    xm_autofill: "Rellenar todos los campos",
    accf_number: "Número",
    accf_doc_type: "Tipo de documento",
    accf_date: "Fecha",
    accf_guest_name: "Cliente",
    accf_guest_number: "Número de cliente",
    accf_vat_number: "Número de IVA",
    accf_status: "Estado",
    accf_payment_method: "Forma de pago",
    accf_subtotal: "Subtotal",
    accf_tax_rate: "Tipo de IVA",
    accf_tax_amount: "Importe de IVA",
    accf_total: "Total",
    accf_amount_due: "A pagar",
    accf_currency: "Moneda",
    accf_credit_of_number: "Nota de crédito de",
    accf_line_code: "Código de artículo",
    accf_line_description: "Descripción",
    accf_line_qty: "Cantidad",
    accf_line_unit_price: "Precio unitario",
    accf_line_vat_rate: "Tipo de IVA (línea)",
    accf_line_total: "Total de línea",
    nav_mailbox: "Buzón",
    mb_inbox: "Bandeja de entrada",
    mb_sent: "Enviados",
    mb_archive: "Archivo",
    mb_trash: "Papelera",
    mb_search: "Buscar remitente o asunto…",
    mb_new: "Nuevo mensaje",
    mb_reply: "Responder",
    mb_forward: "Reenviar",
    mb_send: "Enviar",
    mb_to: "Para",
    mb_subject: "Asunto",
    mb_message: "Mensaje",
    mb_sent_ok: "Mensaje enviado",
    mb_moved: "Mensaje movido",
    mb_mark_unread: "Marcar como no leído",
    mb_empty: "No hay mensajes en esta carpeta",
    mb_pick: "Elige un mensaje para leer",
    mb_no_access: "No tienes acceso al buzón compartido. Pide a un administrador que active 'Acceso al buzón'.",
    mb_not_configured: "El buzón compartido de recepción aún no está configurado. Un administrador puede hacerlo en Admin > Mail & SMS.",
    mb_known_guest: "Huésped conocido",
    mb_provisional: "provisional",
    mb_open_guest: "Abrir ficha del huésped →",
    mb_signature_hint: "Firmado como {name} en nombre del camping.",
    mb_quote_hint: "El mensaje original se cita debajo.",
    mb_forward_hint: "El mensaje original se adjunta.",
    mb_emails_of_guest: "Correos de este huésped",
    imap_title: "Buzón de recepción entrante (IMAP) — recibir y leer",
    imap_desc: "Solo para recibir y leer correos de huéspedes en CampAd Pro. El envío de respuestas se hace por el servidor de correo saliente (SMTP) de arriba y se guarda en Enviados.",
    imap_enabled: "Activar buzón de recepción (entrante/IMAP)",
    imap_host: "Servidor IMAP",
    imap_sent: "Carpeta Enviados",
    imap_archive: "Carpeta Archivo",
    imap_trash: "Carpeta Papelera",
    imap_test_ok: "Conexión correcta",
    imap_folders: "Carpetas",
    mb_do_search: "Buscar",
    mb_unanswered: "Correos sin responder",
    mb_unread: "Correos sin leer",
    mb_templates: "Plantillas de respuesta",
    mb_quick_reply: "Respuesta rápida",
    mb_pick_template: "Elige una plantilla…",
    mb_tpl_name: "Nombre",
    mb_tpl_new: "Nueva plantilla",
    mb_tpl_delete_confirm: "¿Eliminar esta plantilla?",
    mb_tpl_placeholders: "Campos disponibles",
    mb_make_reservation: "Crear reserva",
    mb_from_mail: "Desde correo",
    mb_pitch_type: "Tipo de parcela",
    mb_dogs: "perro(s)",
    mb_emails: "Correos",
    mb_no_email: "Este huésped no tiene correo electrónico.",
    mb_none_with_guest: "Aún no hay correos con este huésped.",
    guest_data: "Datos",
    mb_prefilled: "Datos del remitente rellenados — elige parcela y fechas y guarda como provisional.",
    mb_review_title: "Reserva desde correo",
    mb_review_hint: "Revise los datos del correo y complete lo que falte.",
    mb_ask_info: "Pedir datos",
    mb_still_needed: "falta",
    mb_not_booking_warn: "La IA no reconoció esto claramente como una solicitud de reserva.",
    mb_requested_pitch: "Parcela solicitada",
    avail_green: "Disponible",
    avail_orange: "Disponible con traslado",
    avail_red: "No disponible",
    avail_unknown: "Parcela desconocida",
    avail_checking: "Comprobando disponibilidad…",
    avail_need_dates: "Introduce llegada y salida para ver la disponibilidad.",
    avail_alts: "Parcelas libres en la zona {zone}:",
    avail_no_alts: "No hay parcelas libres en la misma zona.",
    avail_move_on: "El {date}: traslado de la parcela {from} a {to}",
    move_plan_title: "También se creará el plan de traslado",
    move_plan_single: "Una sola parcela",
    move_plan_moves: "traslado(s) programado(s)",
    admin_vat: "Resumen de IVA",
    admin_vat_desc: "IVA a pagar por trimestre (ventas, facturas, anticipos) con IVA soportado y saldo.",
    incl_vat: "Con IVA",
    saldo: "Saldo",
    vat_due: "IVA repercutido",
    vat_input: "IVA soportado",
    vat_to_pay: "A pagar",
    vat_to_reclaim: "A devolver",
    vat_deposit_note: "Los anticipos se muestran aparte y se liquidan en las facturas (no en el saldo).",
    vat_input_note: "El IVA soportado proviene de las compras de stock y de las líneas de coste libres (Admin → Gastos).",
    admin_expenses: "Gastos",
    admin_expenses_desc: "Compras generales (energía, mantenimiento…) con importe + IVA%, se incluyen en el IVA soportado.",
    expense_new: "Nuevo gasto",
    expenses_hint: "Añade aquí costes generales (energía, mantenimiento, seguros…). El IVA se incluye en el resumen de IVA.",
    expense_desc_ph: "p. ej. Electricidad, mantenimiento piscina…",
    interim_last: "Última liquidación",
    interim_due: "Se recomienda nueva liquidación",
    invoices_unpaid: "Sin pagar",
    invoices_paid: "Pagadas",
    no_unpaid_invoices: "No hay facturas sin pagar.",
    no_paid_invoices: "Aún no hay facturas pagadas.",
    u_mailbox_access: "Acceso al buzón",
    u_mailbox_hint: "Puede leer y responder el buzón compartido de recepción (administradores siempre).",
    ses_send_interval: "Agrupar cada",
    ses_interval_0: "Enviar al instante",
    ses_send_interval_hint: "Con un intervalo de agrupación las comunicaciones se envían juntas (p. ej. cada media hora u hora) para no sobrecargar el servicio.",
    ses_will_send_at: "Se enviará a las",
    ovw_ok: "Las comunicaciones se envían automáticamente. Sin incidencias.",
    ovw_attention: "Hay comunicaciones que requieren atención (rechazadas o fuera de plazo).",
    ovw_disabled: "La interfaz está desactivada — no se comunica nada.",
    ovw_manual: "El envío automático está desactivado — un administrador envía manualmente.",
    ovw_manage: "Gestionar",
    ovw_next_send: "Próximo envío",
    ovw_recent: "Comunicaciones recientes",
    iface_accounting: "Contabilidad",
    xls_desc: "Exporte los datos como archivo Excel (.xlsx) para compartirlos o procesarlos.",
    xls_pitches: "Parcelas y ocupación",
    xls_pitches_desc: "Todas las parcelas con quién está o llega, desde cuándo hasta cuándo.",
    xls_finance: "Finanzas: entradas y salidas",
    xls_finance_desc: "Ventas, facturas cobradas, compras e ingresos bancarios en el período elegido, con columnas separadas para efectivo y tarjeta.",
    xls_download: "Descargar Excel",
    xls_done: "Archivo Excel descargado",
    ses_checkin_title: "Comunicación Guardia Civil",
    ses_checkin_missing: "faltan estos datos antes del check-in",
    ses_checkin_ok: "todos los datos de los viajeros están completos",
    provisional_list: "Reservas provisionales",
    maint_ses_done: "Limpieza única realizada el",
    setup_provisional_reminder: "Recordatorio de reserva provisional (días antes de la llegada)",
    setup_provisional_reminder_hint: "Los huéspedes con una reserva aún provisional reciben automáticamente un correo con un enlace para completar sus datos; después la reserva pasa a definitiva.",
    send_complete_link: "Enviar enlace para completar",
    complete_link_sent: "Enlace enviado a",
    extend_complete_link: "Ampliar enlace (+24h)",
    complete_link_extended: "Enlace ampliado y reenviado a",
    completion_complete: "100% completado",
    completion_incomplete: "Incompleto",
    link_expired: "Enlace de completado caducado — amplíe o reenvíe",
    send_confirmation_card: "Enviar tarjeta de confirmación",
    confirmation_card_sent: "Tarjeta de confirmación enviada a",
    admin_loginlog: "Registro de accesos",
    admin_loginlog_desc: "Intentos de acceso bloqueados y fallidos por día, con dirección IP — así ve cuántos bots se detienen.",
    admin_audit: "Registro de cambios",
    admin_audit_desc: "Quién modificó a qué usuario y cuándo. Vea exactamente qué cambió cada administrador.",
    audit_when: "Momento",
    audit_actor: "Quién",
    audit_action: "Acción",
    audit_target: "Usuario afectado",
    audit_details: "Detalles",
    audit_none: "Sin cambios en este período",
    audit_all_actions: "Todas las acciones",
    audit_search: "Buscar por correo…",
    audit_activated: "Activado",
    audit_deactivated: "Desactivado",
    audit_a_user_created: "Usuario creado",
    audit_a_user_updated: "Usuario modificado",
    audit_a_user_active_changed: "Estado activo modificado",
    audit_a_user_password_reset: "Contraseña restablecida",
    audit_a_settings_updated: "Ajustes modificados",
    audit_a_tariff_updated: "Tarifa modificada",
    audit_a_reservation_created: "Reserva creada",
    audit_a_reservation_updated: "Reserva modificada",
    audit_a_reservation_extended: "Reserva ampliada",
    audit_a_reservation_moved: "Reserva trasladada",
    audit_a_reservation_checkin: "Registrada (check-in)",
    audit_a_reservation_deleted: "Reserva eliminada",
    audit_a_sale_created: "Venta creada",
    audit_a_sale_deleted: "Venta eliminada",
    audit_a_cash_closed: "Caja cerrada",
    audit_a_cash_deposit_created: "Depósito",
    audit_a_cash_deposit_cancelled: "Depósito cancelado",
    audit_stat_today: "Hoy",
    audit_stat_week: "Esta semana (7 días)",
    audit_stat_by_actor: "Por empleado (30 días)",
    audit_export_csv: "CSV",
    audit_export_pdf: "PDF",
    ll_total: "Intentos",
    ll_bots: "Bots bloqueados",
    ll_period: "Período",
    ll_since: "desde",
    ll_per_day: "Por día",
    ll_per_ip: "Por dirección IP",
    ll_recent: "Intentos recientes",
    ll_none: "Sin intentos bloqueados en este período.",
    ll_last: "Último",
    ll_when: "Cuándo",
    ll_reason: "Motivo",
    ll_identifier: "Usuario",
    ll_honeypot: "Honeypot (bot)",
    ll_too_fast: "Demasiado rápido (bot)",
    ll_challenge: "Puzle fallido (bot)",
    ll_turnstile: "Turnstile rechazado",
    ll_ip_locked: "IP bloqueada",
    ll_account_locked: "Cuenta bloqueada",
    ll_wrong_password: "Contraseña incorrecta",
    ll_block: "Bloquear",
    ll_unblock: "Desbloquear",
    ll_blocked: "Bloqueada:",
    ll_unblocked: "Desbloqueada:",
    ll_blocked_badge: "BLOQUEADA",
    ll_blocklist: "Direcciones IP bloqueadas permanentemente",
    ll_ip_blocklist: "Lista de bloqueo (bot)",
    ll_day_title: "Accesos por día",
    ll_ok: "correctos",
    ll_failed: "fallidos",
    ll_day_none: "Sin accesos este día.",
    ll_login_ok: "Acceso correcto",
    ll_out: "salidas/pausa",
    ll_logout: "Sesión cerrada",
    ll_logout_auto: "Cerrada automáticamente",
    ll_pause: "Pausa",
    hours_day: "Día",
    hours_total: "Total",
    hours_day_none: "Nadie conectado este día.",
    hours_open: "aún conectado",
    hours_reason_logout: "Sesión cerrada",
    hours_reason_break: "Pausa",
    hours_reason_idle: "Cerrada automáticamente",
    hours_reason_auto: "Cerrada automáticamente",
    hours_reason_manual: "Introducido a mano",
    hours_reason_open: "Aún conectado",
    hours_break: "Pausa",
    hours_no_break: "sin pausa",
    hours_no_break_hint: "Más de 6 horas trabajadas sin pausa",
    idle_warn_title: "¿Seguir conectado?",
    idle_warn_text: "Se cerrará la sesión automáticamente en",
    idle_stay: "Seguir conectado",
    draft_found: "Reserva sin terminar recuperada",
    draft_saved_at: "Guardada automáticamente al cerrar sesión el",
    draft_resume: "Continuar",
    draft_discard: "Descartar",
    draft_resumed: "Borrador recuperado — continúe donde lo dejó",
    draft_found_other: "Reserva sin terminar de",
    draft_take: "Asumir y terminar",
    draft_taken_title: "Su borrador fue completado",
    draft_taken_text: "su reserva sin terminar fue asumida por",
    admin_interfaces_desc: "Conexiones con servicios externos: autoridades (Guardia Civil), contabilidad y otros programas.",
    iface_available: "Disponible",
    iface_soon: "Próximamente",
    iface_open: "Abiertos",
    iface_on: "Activada",
    iface_off: "Desactivada",
    iface_pending: "En trámite",
    iface_rejected: "Rechazados",
    iface_last_sent: "Último envío",
    iface_never: "nunca",
    iface_back: "Todas las interfaces",
    ses_title: "SES.HOSPEDAJES",
    ses_subtitle: "Registro de viajeros · Ministerio del Interior · Real Decreto 933/2021",
    ses_tab_settings: "Configuración",
    ses_tab_files: "Ficheros",
    ses_tab_log: "Registro",
    ses_readonly: "Solo lectura — modificar requiere clase financiera 5.",
    ses_enabled: "Interfaz activa",
    ses_mode: "Entorno",
    ses_mode_test: "Pruebas (preproducción)",
    ses_mode_live: "Producción (real)",
    ses_mode_hint: "Nunca ambos a la vez: todas las comunicaciones van al entorno elegido. Producción exige credenciales completas.",
    ses_codes: "Identificación SES",
    ses_arrendador: "codigoArrendador (titular)",
    ses_establecimiento: "codigoEstablecimiento (establecimiento)",
    ses_aplicacion: "Nombre de la aplicación (aplicacion)",
    ses_creds_test: "Usuario del servicio web — pruebas",
    ses_creds_live: "Usuario del servicio web — producción",
    ses_user: "Usuario",
    ses_password: "Contraseña",
    ses_pw_set: "guardada",
    ses_events: "Eventos que generan una comunicación",
    ses_ev_rh: "Reservas (RH)",
    ses_ev_rh_desc: "Reserva nueva o modificada → comunicación de reserva.",
    ses_ev_pv: "Llegadas (PV)",
    ses_ev_pv_desc: "Check-in → parte de entrada con todos los viajeros.",
    ses_ev_cancel: "Anulaciones (B)",
    ses_ev_cancel_desc: "Reserva eliminada → anulación de la comunicación aceptada.",
    ses_sending: "Envío",
    ses_auto_send: "Enviar automáticamente",
    ses_send_time: "Hora de envío (Europe/Madrid)",
    ses_send_time_hint: "Todo se envía a esta hora; lo que cambie después (hasta las 24:00) se envía al instante. Vacío = todo al instante.",
    ses_max_batch: "Máx. comunicaciones por petición",
    ses_payment: "Forma de pago por defecto (TIPO_PAGO)",
    ses_mail_to: "Correo por defecto para los ficheros",
    ses_access: "Acceso",
    ses_reception_files: "Recepción puede ver y enviar ficheros por correo",
    ses_endpoints: "Endpoints (v3.1.2)",
    ses_files_desc: "Cada comunicación es un fichero XML. Los ficheros enviados son inmutables; una corrección = anulación + nueva versión.",
    ses_filter_all: "Todos",
    ses_filter_open: "Abiertos",
    ses_filter_accepted: "Aceptados",
    ses_filter_rejected: "Rechazados",
    ses_search: "Buscar huésped o parcela…",
    ses_col_file: "Fichero",
    ses_col_content: "Contenido",
    ses_col_status: "Estado",
    ses_col_created: "Creado",
    ses_late: "Fuera del plazo de 24 h",
    ses_process_now: "Procesar la cola ahora",
    ses_check_now: "Consultar estado",
    ses_st_incomplete: "Incompleto",
    ses_st_ready: "Preparado",
    ses_st_sending: "Enviando",
    ses_st_received: "Recibido (lote)",
    ses_st_processing: "En proceso",
    ses_st_accepted: "Aceptado",
    ses_st_rejected: "Rechazado",
    ses_st_uncertain: "Incierto",
    ses_st_cancel_requested: "Anulación solicitada",
    ses_st_cancelled: "Anulado",
    ses_st_withdrawn: "Retirado",
    ses_missing: "Datos que faltan",
    ses_view: "Ver",
    ses_xml: "Contenido XML",
    ses_edit: "Editar",
    ses_save_xml: "Guardar XML",
    ses_send: "Enviar ahora",
    ses_resend: "Reenviar",
    ses_rebuild: "Reconstruir desde la reserva",
    ses_cancel: "Anular en SES",
    ses_withdraw: "Retirar",
    ses_download: "Descargar",
    ses_mail: "Enviar por correo",
    ses_mail_to_label: "Para",
    ses_mail_lang: "Idioma del mensaje",
    ses_mail_note: "Observación (opcional)",
    ses_mail_send: "Enviar por correo",
    ses_mailed: "Enviado por correo",
    ses_batch: "Lote",
    ses_codigo: "Código de comunicación",
    ses_error: "Error",
    ses_version: "Versión",
    ses_deadline: "Plazo",
    ses_by: "por",
    ses_log_desc: "Todo lo que hace la interfaz, en orden cronológico.",
    ses_mode_badge_test: "PRUEBAS",
    ses_mode_badge_live: "PRODUCCIÓN",
    ses_no_creds: "Sin credenciales, los ficheros permanecen en \"Preparado\" hasta que se completen.",
    ses_immutable: "Fichero enviado — inmutable",
  },
};

export function browserLang() {
  const l = (navigator.language || "en").slice(0, 2).toLowerCase();
  return l === "nl" || l === "es" ? l : "en";
}

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("cb_lang") || browserLang());
  // manual = de gebruiker koos zelf een taal; dan overschrijft zijn profieltaal dit niet meer
  const changeLang = useCallback((l, manual = true) => {
    localStorage.setItem("cb_lang", l);
    if (manual) localStorage.setItem("cb_lang_manual", "1");
    setLang(l);
  }, []);
  const t = useCallback((key) => dict[lang]?.[key] ?? dict.en[key] ?? dict.nl[key] ?? key, [lang]);
  return <LangContext.Provider value={{ lang, changeLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
